/*! @charter/helix 2.11.39 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("Helix", [], t) : "object" == typeof exports ? exports.Helix = t() : e.Helix = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var t = {};

    function a(r) {
      if (t[r]) return t[r].exports;
      var i = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, a), i.l = !0, i.exports;
    }

    return a.m = e, a.c = t, a.d = function (e, t, r) {
      a.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, a.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, a.t = function (e, t) {
      if (1 & t && (e = a(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (a.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) {
        a.d(r, i, function (t) {
          return e[t];
        }.bind(null, i));
      }
      return r;
    }, a.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return a.d(t, "a", t), t;
    }, a.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, a.p = "/", a(a.s = 21);
  }([function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function a(e, t) {
      for (var a = 0; a < t.length; a++) {
        var r = t[a];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    e.exports = function (e, t, r) {
      return t && a(e.prototype, t), r && a(e, r), e;
    };
  }, function (e, t, a) {
    e.exports = a(24);
  }, function (e, t) {
    function a(e, t, a, r, i, n, o) {
      try {
        var s = e[n](o),
            l = s.value;
      } catch (e) {
        return void a(e);
      }

      s.done ? t(l) : Promise.resolve(l).then(r, i);
    }

    e.exports = function (e) {
      return function () {
        var t = this,
            r = arguments;
        return new Promise(function (i, n) {
          var o = e.apply(t, r);

          function s(e) {
            a(o, i, n, s, l, "next", e);
          }

          function l(e) {
            a(o, i, n, s, l, "throw", e);
          }

          s(void 0);
        });
      };
    };
  }, function (e, t) {
    function a(t) {
      return e.exports = a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, a(t);
    }

    e.exports = a;
  }, function (e, t) {
    e.exports = function (e, t, a) {
      return t in e ? Object.defineProperty(e, t, {
        value: a,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = a, e;
    };
  }, function (e, t) {
    function a(t) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = a = function a(e) {
        return typeof e;
      } : e.exports = a = function a(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, a(t);
    }

    e.exports = a;
  }, function (e, t, a) {
    var r = a(22);

    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && r(e, t);
    };
  }, function (e, t, a) {
    var r = a(6),
        i = a(23);

    e.exports = function (e, t) {
      return !t || "object" !== r(t) && "function" != typeof t ? i(e) : t;
    };
  }, function (e, t, a) {
    var r = a(25),
        i = a(26),
        n = a(18),
        o = a(27);

    e.exports = function (e) {
      return r(e) || i(e) || n(e) || o();
    };
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = a(31);
    t.Expression = r.Expression;
    var i = a(36);
    t.Context = i.Context;
    var n = a(15);
    t.Operand = n.Operand;
    var o = a(11);
    t.OperandType = o.OperandType;
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Unknown = 0] = "Unknown", e[e.Litteral = 1] = "Litteral", e[e.Data = 2] = "Data", e[e.Cookies = 3] = "Cookies", e[e.LocalStorage = 4] = "LocalStorage";
    }(t.OperandType || (t.OperandType = {}));
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(16),
        i = function () {
      function e() {}

      return e.nullOrEmpty = function (e) {
        return !e || "" === e;
      }, e.isWhiteSpace = function (e) {
        return /^\s*$/.test(e);
      }, e.eatSpaces = function (t, a) {
        for (; a.valueOf() < t.length;) {
          if (!e.isWhiteSpace(t[a.valueOf()])) return !0;
          a.increment();
        }

        return !1;
      }, e.readToken = function (t, a) {
        var r = "",
            i = !1;

        for (e.eatSpaces(t, a), "'" === t[a.valueOf()] && (i = !0, r += "'", a.increment()); a.valueOf() < t.length;) {
          if (i && "'" === t[a.valueOf()]) return a.increment(), r += "'";
          if (!i && (e.isWhiteSpace(t[a.valueOf()]) || ")" === t[a.valueOf()])) return r;
          r += t[a.valueOf()], a.increment();
        }

        if (i) throw new Error("Unterminated token. Expected single quote");
        if ("" === r) throw new Error("Unexpected empty token");
        return r;
      }, e.isLogicalOperator = function (e) {
        return e === r.OperatorType.AND || e === r.OperatorType.OR;
      }, e.stringToOperatorType = function (e) {
        switch (e = e.toUpperCase().trim()) {
          case "=":
            return r.OperatorType.EQ;

          case "!=":
          case "<>":
            return r.OperatorType.NEQ;

          case "<":
            return r.OperatorType.LT;

          case "<=":
            return r.OperatorType.LTE;

          case ">":
            return r.OperatorType.GT;

          case ">=":
            return r.OperatorType.GTE;

          case "AND":
            return r.OperatorType.AND;

          case "OR":
            return r.OperatorType.OR;

          case "+":
            return r.OperatorType.ADD;

          case "-":
            return r.OperatorType.MINUS;

          case "*":
            return r.OperatorType.MULTIPLY;

          case "/":
            return r.OperatorType.DIVIDE;

          case "LIKE":
            return r.OperatorType.LIKE;

          default:
            throw new Error("Invalid operator: " + e);
        }
      }, e.isInt = function (e) {
        return Number(e) === e && e % 1 == 0;
      }, e.isFloat = function (e) {
        return Number(e) === e && e % 1 != 0;
      }, e;
    }();

    t.Utils = i;
  }, function (e, t, a) {
    var r = a(28),
        i = a(29),
        n = a(18),
        o = a(30);

    e.exports = function (e, t) {
      return r(e) || i(e, t) || n(e, t) || o();
    };
  }, function (e) {
    e.exports = JSON.parse('{"name":"@charter/helix","version":"2.11.39","description":"Analytics wrapper that passes down data to multiple trackers","main":"build/venona/portals/index.min.js","publishConfig":{"registry":""},"scripts":{"test":"babel-node spec/run.js","test:coverage":"nyc npm test","test:watch":"nodemon -w spec -w src --exec npm run test","lint:watch":"esw src/ spec/ -w --color","lint":"esw src/ spec/","lint:fix":"eslint src/ spec/ --fix","build-old":"babel src -d build --extensions \\".ts,.js\\"","build":"npm run build-video && npm run build-portals && npm run build-video-legacy && npm run build-portals-legacy && npm run build-tealium && npm run build-extensions && npm run build-modules","build-video":"better-npm-run build-dev --domain video --type venona && better-npm-run build-prod --domain video --type venona","build-portals":"better-npm-run build-dev --domain portals --type venona && better-npm-run build-prod --domain portals --type venona ","build-video-legacy":"better-npm-run build-dev-legacy --domain video --type venona && better-npm-run build-prod-legacy --domain video --type venona","build-portals-legacy":"better-npm-run build-dev-legacy --domain portals --type venona && better-npm-run build-prod-legacy --domain portals --type venona ","build-tealium":"better-npm-run build-dev --type tealium --domain tealium && better-npm-run build-prod --type tealium --domain tealium","build-extensions":"babel ./src/extensions --out-dir ./build/extensions --extensions \\".ts,.js\\" ","build-modules":"babel ./src/modules --out-dir ./build/modules --extensions \\".ts,.js\\" ","gen:docs":"esdoc","prepublishOnly":"babel src -d build"},"betterScripts":{"build-dev":{"command":"webpack --config webpack.config.js ","env":{"NODE_ENV":"development"}},"build-prod":{"command":"webpack --config webpack.config.js","env":{"NODE_ENV":"production"}},"build-dev-legacy":{"command":"webpack --config webpack.config_legacy","env":{"NODE_ENV":"development"}},"build-prod-legacy":{"command":"webpack --config webpack.config_legacy","env":{"NODE_ENV":"production"}}},"files":["build/*"],"contributors":["Pablo Giani <c-pablo.giani@charter.com","Antonio Assad Santos <c-antonio.assadsantos@charter.com"],"license":"UNLICENSED","devDependencies":{"@babel/cli":"^7.12.10","@babel/core":"^7.12.10","@babel/plugin-proposal-class-properties":"^7.4.0","@babel/plugin-proposal-numeric-separator":"^7.2.0","@babel/plugin-proposal-object-rest-spread":"^7.4.0","@babel/plugin-proposal-optional-chaining":"^7.7.5","@babel/plugin-syntax-dynamic-import":"^7.8.3","@babel/plugin-transform-runtime":"^7.12.10","@babel/plugin-transform-typescript":"^7.7.4","@babel/preset-env":"^7.12.11","@babel/preset-typescript":"^7.9.0","axios":"^0.21.1","babel-eslint":"^10.1.0","babel-loader":"^8.0.5","babel-plugin-lodash":"^3.3.4","babel-plugin-rewire":"1.2.0","better-npm-run":"^0.1.1","compression-webpack-plugin":"^3.1.0","esdoc":"^1.1.0","esdoc-standard-plugin":"^1.0.0","eslint":"^4.19.1","eslint-config-airbnb-base":"^14.0.0","eslint-config-prettier":"^6.9.0","eslint-import-resolver-webpack":"^0.13.0","eslint-plugin-import":"^2.11.0","eslint-plugin-prettier":"^3.3.1","eslint-watch":"^3.1.4","html-webpack-plugin":"^4.5.1","jasmine":"^3.4.0","jasmine-spec-reporter":"^4.2.1","jsdoc-to-markdown":"^4.0.1","jsdom":"^12.2.0","lodash-webpack-plugin":"^0.11.6","minimist":"^1.2.0","mocha":"^5.2.0","mocha-clean":"^1.0.0","mocha-webpack":"2.0.0-beta.0","nodemon":"^1.17.4","nyc":"^15.1.0","performance-now":"^2.1.0","prettier":"^1.19.1","source-map-support":"^0.5.10","string-replace-loader":"^3.0.1","typescript":"3.7.4","webpack":"^4.29.3","webpack-bundle-analyzer":"^3.0.3","webpack-cli":"^3.2.3","webpack-dev-server":"^3.11.1","webpack-node-externals":"^1.7.2"},"dependencies":{"@babel/node":"^7.12.10","@babel/plugin-proposal-optional-chaining":"^7.7.5","@babel/runtime":"^7.7.7","@charter/helix-extensions":"^1.0.1-rc.3","@charter/quantum":"~6.13.0","ua-parser-js":"^0.7.28"},"nyc":{"check-coverage":true,"per-file":true,"lines":50,"statements":50,"functions":50,"branches":50,"include":["src/**/*.js"],"reporter":["lcov","text-summary"],"cache":false},"resolutions":{"event-stream":"3.3.5"}}');
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(11),
        i = a(12),
        n = function () {
      function e(e, t) {
        this.valueVar = e, this.operandTypeVar = t || r.OperandType.Unknown;
      }

      return e.parse = function (t) {
        var a,
            n = r.OperandType.Unknown;
        if (i.Utils.nullOrEmpty(t)) throw new Error("Invalid operand");

        if (t.indexOf(".") > -1 && "'" !== t[0]) {
          switch ((a = t.split("."))[0].toUpperCase()) {
            case "DATA":
              n = r.OperandType.Data;
              break;

            case "COOKIES":
              n = r.OperandType.Cookies;
              break;

            case "LOCALSTORAGE":
              n = r.OperandType.LocalStorage;
              break;

            default:
              return new e(e.unbox(t), r.OperandType.Litteral);
          }

          return new e(a[1].trim(), n);
        }

        return new e(e.unbox(t), r.OperandType.Litteral);
      }, e.unbox = function (e) {
        if (i.Utils.nullOrEmpty(e)) return null;

        if ("'" === e[0]) {
          if (1 === e.length || "'" !== e[e.length - 1]) throw new Error("Unterminated String");
          return e.substr(1, e.length - 2);
        }

        if ("TRUE" === e.toUpperCase()) return !0;
        if ("FALSE" === e.toUpperCase()) return !1;
        if (e.indexOf(".") > -1 && !Number.isNaN(e)) return parseFloat(e);
        var t = parseInt(e, 10);
        return Number.isNaN(t) ? e : t;
      }, e.readOperand = function (t, a) {
        var r, n;

        try {
          "'" === (n = i.Utils.readToken(t, a))[0] ? (n = n.substr(1, n.length - 2), r = e.parse(n)) : r = e.parse(n);
        } catch (e) {
          throw new Error("Unable to parse operand: " + e);
        }

        return r;
      }, Object.defineProperty(e.prototype, "operandType", {
        get: function get() {
          return this.operandTypeVar;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "value", {
        get: function get() {
          return this.valueVar;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.Operand = n;
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Unknown = 0] = "Unknown", e[e.LT = 1] = "LT", e[e.GT = 2] = "GT", e[e.LTE = 3] = "LTE", e[e.GTE = 4] = "GTE", e[e.EQ = 5] = "EQ", e[e.NEQ = 6] = "NEQ", e[e.LIKE = 7] = "LIKE", e[e.AND = 8] = "AND", e[e.OR = 9] = "OR", e[e.ADD = 10] = "ADD", e[e.MINUS = 11] = "MINUS", e[e.DIVIDE = 12] = "DIVIDE", e[e.MULTIPLY = 13] = "MULTIPLY", e[e.NOOP = 14] = "NOOP";
    }(t.OperatorType || (t.OperatorType = {}));
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var a = 0, r = new Array(t); a < t; a++) {
        r[a] = e[a];
      }

      return r;
    };
  }, function (e, t, a) {
    var r = a(17);

    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return r(e, t);
        var a = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? r(e, t) : void 0;
      }
    };
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function () {
      function e(e) {
        this.idx = e || 0;
      }

      return e.prototype.setValue = function (e) {
        this.idx = e;
      }, e.prototype.increment = function () {
        ++this.idx;
      }, e.prototype.decrement = function () {
        --this.idx;
      }, e.prototype.valueOf = function () {
        return this.idx;
      }, e;
    }();

    t.Index = r;
  }, function (e, t, a) {
    var r;
    /*!@license
     * UAParser.js v0.7.28
     * Lightweight JavaScript-based User-Agent string parser
     * https://github.com/faisalman/ua-parser-js
     *
     * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
     * Licensed under MIT License
     */

    !function (i, n) {
      "use strict";

      var o = "model",
          s = "name",
          l = "type",
          u = "vendor",
          c = "version",
          v = "mobile",
          p = "tablet",
          d = "smarttv",
          g = {
        extend: function extend(e, t) {
          var a = {};

          for (var r in e) {
            t[r] && t[r].length % 2 == 0 ? a[r] = t[r].concat(e[r]) : a[r] = e[r];
          }

          return a;
        },
        has: function has(e, t) {
          return "string" == typeof e && -1 !== t.toLowerCase().indexOf(e.toLowerCase());
        },
        lowerize: function lowerize(e) {
          return e.toLowerCase();
        },
        major: function major(e) {
          return "string" == typeof e ? e.replace(/[^\d\.]/g, "").split(".")[0] : void 0;
        },
        trim: function trim(e, t) {
          return e = e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), void 0 === t ? e : e.substring(0, 255);
        }
      },
          y = {
        rgx: function rgx(e, t) {
          for (var a, r, i, n, o, s, l = 0; l < t.length && !o;) {
            var u = t[l],
                c = t[l + 1];

            for (a = r = 0; a < u.length && !o;) {
              if (o = u[a++].exec(e)) for (i = 0; i < c.length; i++) {
                s = o[++r], "object" == typeof (n = c[i]) && n.length > 0 ? 2 == n.length ? "function" == typeof n[1] ? this[n[0]] = n[1].call(this, s) : this[n[0]] = n[1] : 3 == n.length ? "function" != typeof n[1] || n[1].exec && n[1].test ? this[n[0]] = s ? s.replace(n[1], n[2]) : void 0 : this[n[0]] = s ? n[1].call(this, s, n[2]) : void 0 : 4 == n.length && (this[n[0]] = s ? n[3].call(this, s.replace(n[1], n[2])) : void 0) : this[n] = s || void 0;
              }
            }

            l += 2;
          }
        },
        str: function str(e, t) {
          for (var a in t) {
            if ("object" == typeof t[a] && t[a].length > 0) {
              for (var r = 0; r < t[a].length; r++) {
                if (g.has(t[a][r], e)) return "?" === a ? void 0 : a;
              }
            } else if (g.has(t[a], e)) return "?" === a ? void 0 : a;
          }

          return e;
        }
      },
          f = {
        browser: {
          oldSafari: {
            version: {
              "1.0": "/8",
              1.2: "/1",
              1.3: "/3",
              "2.0": "/412",
              "2.0.2": "/416",
              "2.0.3": "/417",
              "2.0.4": "/419",
              "?": "/"
            }
          },
          oldEdge: {
            version: {
              .1: "12.",
              21: "13.",
              31: "14.",
              39: "15.",
              41: "16.",
              42: "17.",
              44: "18."
            }
          }
        },
        os: {
          windows: {
            version: {
              ME: "4.90",
              "NT 3.11": "NT3.51",
              "NT 4.0": "NT4.0",
              2e3: "NT 5.0",
              XP: ["NT 5.1", "NT 5.2"],
              Vista: "NT 6.0",
              7: "NT 6.1",
              8: "NT 6.2",
              8.1: "NT 6.3",
              10: ["NT 6.4", "NT 10.0"],
              RT: "ARM"
            }
          }
        }
      },
          m = {
        browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [c, [s, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [c, [s, "Edge"]], [/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i, /(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i], [s, c], [/opios[\/\s]+([\w\.]+)/i], [c, [s, "Opera Mini"]], [/\sopr\/([\w\.]+)/i], [c, [s, "Opera"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i, /(ba?idubrowser)[\/\s]?([\w\.]+)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i, /(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i, /(weibo)__([\d\.]+)/i], [s, c], [/(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i], [c, [s, "UCBrowser"]], [/(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i], [c, [s, "WeChat(Win) Desktop"]], [/micromessenger\/([\w\.]+)/i], [c, [s, "WeChat"]], [/konqueror\/([\w\.]+)/i], [c, [s, "Konqueror"]], [/trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i], [c, [s, "IE"]], [/yabrowser\/([\w\.]+)/i], [c, [s, "Yandex"]], [/(avast|avg)\/([\w\.]+)/i], [[s, /(.+)/, "$1 Secure Browser"], c], [/focus\/([\w\.]+)/i], [c, [s, "Firefox Focus"]], [/opt\/([\w\.]+)/i], [c, [s, "Opera Touch"]], [/coc_coc_browser\/([\w\.]+)/i], [c, [s, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [c, [s, "Dolphin"]], [/coast\/([\w\.]+)/i], [c, [s, "Opera Coast"]], [/xiaomi\/miuibrowser\/([\w\.]+)/i], [c, [s, "MIUI Browser"]], [/fxios\/([\w\.-]+)/i], [c, [s, "Firefox"]], [/(qihu|qhbrowser|qihoobrowser|360browser)/i], [[s, "360 Browser"]], [/(oculus|samsung|sailfish)browser\/([\w\.]+)/i], [[s, /(.+)/, "$1 Browser"], c], [/(comodo_dragon)\/([\w\.]+)/i], [[s, /_/g, " "], c], [/\s(electron)\/([\w\.]+)\ssafari/i, /(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i, /m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i], [s, c], [/(MetaSr)[\/\s]?([\w\.]+)/i, /(LBBROWSER)/i], [s], [/;fbav\/([\w\.]+);/i], [c, [s, "Facebook"]], [/FBAN\/FBIOS|FB_IAB\/FB4A/i], [[s, "Facebook"]], [/safari\s(line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(chromium|instagram)[\/\s]([\w\.-]+)/i], [s, c], [/\bgsa\/([\w\.]+)\s.*safari\//i], [c, [s, "GSA"]], [/headlesschrome(?:\/([\w\.]+)|\s)/i], [c, [s, "Chrome Headless"]], [/\swv\).+(chrome)\/([\w\.]+)/i], [[s, "Chrome WebView"], c], [/droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i], [c, [s, "Android Browser"]], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i], [s, c], [/version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i], [c, [s, "Mobile Safari"]], [/version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i], [c, s], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [s, [c, y.str, f.browser.oldSafari.version]], [/(webkit|khtml)\/([\w\.]+)/i], [s, c], [/(navigator|netscape)\/([\w\.-]+)/i], [[s, "Netscape"], c], [/ile\svr;\srv:([\w\.]+)\).+firefox/i], [c, [s, "Firefox Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i, /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [s, c]],
        cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [["architecture", "amd64"]], [/(ia32(?=;))/i], [["architecture", g.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [["architecture", "ia32"]], [/\b(aarch64|armv?8e?l?)\b/i], [["architecture", "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [["architecture", "armhf"]], [/windows\s(ce|mobile);\sppc;/i], [["architecture", "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [["architecture", /ower/, "", g.lowerize]], [/(sun4\w)[;\)]/i], [["architecture", "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [["architecture", g.lowerize]]],
        device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i], [o, [u, "Samsung"], [l, p]], [/\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i, /\ssamsung[\s-]([\w-]+)/i, /sec-(sgh\w+)/i], [o, [u, "Samsung"], [l, v]], [/\((ip(?:hone|od)[\s\w]*);/i], [o, [u, "Apple"], [l, v]], [/\((ipad);[\w\s\),;-]+apple/i, /applecoremedia\/[\w\.]+\s\((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [o, [u, "Apple"], [l, p]], [/\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i], [o, [u, "Huawei"], [l, p]], [/d\/huawei([\w\s-]+)[;\)]/i, /\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i, /\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i], [o, [u, "Huawei"], [l, v]], [/\b(poco[\s\w]+)(?:\sbuild|\))/i, /\b;\s(\w+)\sbuild\/hm\1/i, /\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i, /\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i, /\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i], [[o, /_/g, " "], [u, "Xiaomi"], [l, v]], [/\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i], [[o, /_/g, " "], [u, "Xiaomi"], [l, p]], [/;\s(\w+)\sbuild.+\soppo/i, /\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i], [o, [u, "OPPO"], [l, v]], [/\svivo\s(\w+)(?:\sbuild|\))/i, /\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i], [o, [u, "Vivo"], [l, v]], [/\s(rmx[12]\d{3})(?:\sbuild|;)/i], [o, [u, "Realme"], [l, v]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i, /\smot(?:orola)?[\s-](\w*)/i, /((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i], [o, [u, "Motorola"], [l, v]], [/\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [o, [u, "Motorola"], [l, p]], [/((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i], [o, [u, "LG"], [l, p]], [/(lm-?f100[nv]?|nexus\s[45])/i, /lg[e;\s\/-]+((?!browser|netcast)\w+)/i, /\blg(\-?[\d\w]+)\sbuild/i], [o, [u, "LG"], [l, v]], [/(ideatab[\w\-\s]+)/i, /lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i], [o, [u, "Lenovo"], [l, p]], [/(?:maemo|nokia).*(n900|lumia\s\d+)/i, /nokia[\s_-]?([\w\.-]*)/i], [[o, /_/g, " "], [u, "Nokia"], [l, v]], [/droid.+;\s(pixel\sc)[\s)]/i], [o, [u, "Google"], [l, p]], [/droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i], [o, [u, "Google"], [l, v]], [/droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [o, [u, "Sony"], [l, v]], [/sony\stablet\s[ps]\sbuild\//i, /(?:sony)?sgp\w+(?:\sbuild\/|\))/i], [[o, "Xperia Tablet"], [u, "Sony"], [l, p]], [/\s(kb2005|in20[12]5|be20[12][59])\b/i, /\ba000(1)\sbuild/i, /\boneplus\s(a\d{4})[\s)]/i], [o, [u, "OnePlus"], [l, v]], [/(alexa)webm/i, /(kf[a-z]{2}wi)(\sbuild\/|\))/i, /(kf[a-z]+)(\sbuild\/|\)).+silk\//i], [o, [u, "Amazon"], [l, p]], [/(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i], [[o, "Fire Phone"], [u, "Amazon"], [l, v]], [/\((playbook);[\w\s\),;-]+(rim)/i], [o, u, [l, p]], [/((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10;\s(\w+)/i], [o, [u, "BlackBerry"], [l, v]], [/(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i], [o, [u, "ASUS"], [l, p]], [/\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i], [o, [u, "ASUS"], [l, v]], [/(nexus\s9)/i], [o, [u, "HTC"], [l, p]], [/(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i], [u, [o, /_/g, " "], [l, v]], [/droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i], [o, [u, "Acer"], [l, p]], [/droid.+;\s(m[1-5]\snote)\sbuild/i, /\bmz-([\w-]{2,})/i], [o, [u, "Meizu"], [l, v]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i, /(microsoft);\s(lumia[\s\w]+)/i, /(lenovo)[_\s-]?([\w-]+)/i, /linux;.+(jolla);/i, /droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i], [u, o, [l, v]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i, /[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i, /[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i, /\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i, /\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i], [u, o, [l, p]], [/\s(surface\sduo)\s/i], [o, [u, "Microsoft"], [l, p]], [/droid\s[\d\.]+;\s(fp\du?)\sbuild/i], [o, [u, "Fairphone"], [l, v]], [/\s(u304aa)\sbuild/i], [o, [u, "AT&T"], [l, v]], [/sie-(\w*)/i], [o, [u, "Siemens"], [l, v]], [/[;\/]\s?(rct\w+)\sbuild/i], [o, [u, "RCA"], [l, p]], [/[;\/\s](venue[\d\s]{2,7})\sbuild/i], [o, [u, "Dell"], [l, p]], [/[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i], [o, [u, "Verizon"], [l, p]], [/[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i], [o, [u, "Barnes & Noble"], [l, p]], [/[;\/]\s(tm\d{3}\w+)\sbuild/i], [o, [u, "NuVision"], [l, p]], [/;\s(k88)\sbuild/i], [o, [u, "ZTE"], [l, p]], [/;\s(nx\d{3}j)\sbuild/i], [o, [u, "ZTE"], [l, v]], [/[;\/]\s?(gen\d{3})\sbuild.*49h/i], [o, [u, "Swiss"], [l, v]], [/[;\/]\s?(zur\d{3})\sbuild/i], [o, [u, "Swiss"], [l, p]], [/[;\/]\s?((zeki)?tb.*\b)\sbuild/i], [o, [u, "Zeki"], [l, p]], [/[;\/]\s([yr]\d{2})\sbuild/i, /[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i], [[u, "Dragon Touch"], o, [l, p]], [/[;\/]\s?(ns-?\w{0,9})\sbuild/i], [o, [u, "Insignia"], [l, p]], [/[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i], [o, [u, "NextBook"], [l, p]], [/[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i], [[u, "Voice"], o, [l, v]], [/[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i], [[u, "LvTel"], o, [l, v]], [/;\s(ph-1)\s/i], [o, [u, "Essential"], [l, v]], [/[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i], [o, [u, "Envizen"], [l, p]], [/[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i], [o, [u, "MachSpeed"], [l, p]], [/[;\/]\s?tu_(1491)\sbuild/i], [o, [u, "Rotor"], [l, p]], [/(shield[\w\s]+)\sbuild/i], [o, [u, "Nvidia"], [l, p]], [/(sprint)\s(\w+)/i], [u, o, [l, v]], [/(kin\.[onetw]{3})/i], [[o, /\./g, " "], [u, "Microsoft"], [l, v]], [/droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [o, [u, "Zebra"], [l, p]], [/droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i], [o, [u, "Zebra"], [l, v]], [/\s(ouya)\s/i, /(nintendo)\s([wids3utch]+)/i], [u, o, [l, "console"]], [/droid.+;\s(shield)\sbuild/i], [o, [u, "Nvidia"], [l, "console"]], [/(playstation\s[345portablevi]+)/i], [o, [u, "Sony"], [l, "console"]], [/[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i], [o, [u, "Microsoft"], [l, "console"]], [/smart-tv.+(samsung)/i], [u, [l, d]], [/hbbtv.+maple;(\d+)/i], [[o, /^/, "SmartTV"], [u, "Samsung"], [l, d]], [/(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i], [[u, "LG"], [l, d]], [/(apple)\s?tv/i], [u, [o, "Apple TV"], [l, d]], [/crkey/i], [[o, "Chromecast"], [u, "Google"], [l, d]], [/droid.+aft([\w])(\sbuild\/|\))/i], [o, [u, "Amazon"], [l, d]], [/\(dtv[\);].+(aquos)/i], [o, [u, "Sharp"], [l, d]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i], [[u, g.trim], [o, g.trim], [l, d]], [/[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i], [[l, d]], [/((pebble))app\/[\d\.]+\s/i], [u, o, [l, "wearable"]], [/droid.+;\s(glass)\s\d/i], [o, [u, "Google"], [l, "wearable"]], [/droid\s[\d\.]+;\s(wt63?0{2,3})\)/i], [o, [u, "Zebra"], [l, "wearable"]], [/(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i], [u, [l, "embedded"]], [/droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i], [o, [l, v]], [/droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i], [o, [l, p]], [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i], [[l, g.lowerize]], [/(android[\w\.\s\-]{0,9});.+build/i], [o, [u, "Generic"]], [/(phone)/i], [[l, v]]],
        engine: [[/windows.+\sedge\/([\w\.]+)/i], [c, [s, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [c, [s, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [s, c], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [c, s]],
        os: [[/microsoft\s(windows)\s(vista|xp)/i], [s, c], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i], [s, [c, y.str, f.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[s, "Windows"], [c, y.str, f.os.windows.version]], [/ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i, /cfnetwork\/.+darwin/i], [[c, /_/g, "."], [s, "iOS"]], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i], [[s, "Mac OS"], [c, /_/g, "."]], [/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/\s]([\w\.]+)/i, /\((series40);/i], [s, c], [/\(bb(10);/i], [c, [s, "BlackBerry"]], [/(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i], [c, [s, "Symbian"]], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[s, "Firefox OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [c, [s, "webOS"]], [/crkey\/([\d\.]+)/i], [c, [s, "Chromecast"]], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[s, "Chromium OS"], c], [/(nintendo|playstation)\s([wids345portablevuch]+)/i, /(xbox);\s+xbox\s([^\);]+)/i, /(mint)[\/\s\(\)]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i, /\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku)\s(\w+)/i], [s, c], [/(sunos)\s?([\w\.\d]*)/i], [[s, "Solaris"], c], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, /(unix)\s?([\w\.]*)/i], [s, c]]
      },
          w = function w(e, t) {
        if ("object" == typeof e && (t = e, e = void 0), !(this instanceof w)) return new w(e, t).getResult();
        var a = e || (void 0 !== i && i.navigator && i.navigator.userAgent ? i.navigator.userAgent : ""),
            r = t ? g.extend(m, t) : m;
        return this.getBrowser = function () {
          var e = {
            name: void 0,
            version: void 0
          };
          return y.rgx.call(e, a, r.browser), e.major = g.major(e.version), e;
        }, this.getCPU = function () {
          var e = {
            architecture: void 0
          };
          return y.rgx.call(e, a, r.cpu), e;
        }, this.getDevice = function () {
          var e = {
            vendor: void 0,
            model: void 0,
            type: void 0
          };
          return y.rgx.call(e, a, r.device), e;
        }, this.getEngine = function () {
          var e = {
            name: void 0,
            version: void 0
          };
          return y.rgx.call(e, a, r.engine), e;
        }, this.getOS = function () {
          var e = {
            name: void 0,
            version: void 0
          };
          return y.rgx.call(e, a, r.os), e;
        }, this.getResult = function () {
          return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
          };
        }, this.getUA = function () {
          return a;
        }, this.setUA = function (e) {
          return a = "string" == typeof e && e.length > 255 ? g.trim(e, 255) : e, this;
        }, this.setUA(a), this;
      };

      w.VERSION = "0.7.28", w.BROWSER = {
        NAME: s,
        MAJOR: "major",
        VERSION: c
      }, w.CPU = {
        ARCHITECTURE: "architecture"
      }, w.DEVICE = {
        MODEL: o,
        VENDOR: u,
        TYPE: l,
        CONSOLE: "console",
        MOBILE: v,
        SMARTTV: d,
        TABLET: p,
        WEARABLE: "wearable",
        EMBEDDED: "embedded"
      }, w.ENGINE = {
        NAME: s,
        VERSION: c
      }, w.OS = {
        NAME: s,
        VERSION: c
      }, void 0 !== t ? (void 0 !== e && e.exports && (t = e.exports = w), t.UAParser = w) : void 0 === (r = function () {
        return w;
      }.call(t, a, t, e)) || (e.exports = r);
      var h = void 0 !== i && (i.jQuery || i.Zepto);

      if (h && !h.ua) {
        var b = new w();
        h.ua = b.getResult(), h.ua.get = function () {
          return b.getUA();
        }, h.ua.set = function (e) {
          b.setUA(e);
          var t = b.getResult();

          for (var a in t) {
            h.ua[a] = t[a];
          }
        };
      }
    }("object" == typeof window ? window : this);
  }, function (e, t, a) {
    "use strict";

    a.r(t);
    var r = a(38).default;
    t.default = r;
  }, function (e, t) {
    function a(t, r) {
      return e.exports = a = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, a(t, r);
    }

    e.exports = a;
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t, a) {
    var r = function (e) {
      "use strict";

      var t = Object.prototype,
          a = t.hasOwnProperty,
          r = "function" == typeof Symbol ? Symbol : {},
          i = r.iterator || "@@iterator",
          n = r.asyncIterator || "@@asyncIterator",
          o = r.toStringTag || "@@toStringTag";

      function s(e, t, a) {
        return Object.defineProperty(e, t, {
          value: a,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        s({}, "");
      } catch (e) {
        s = function s(e, t, a) {
          return e[t] = a;
        };
      }

      function l(e, t, a, r) {
        var i = t && t.prototype instanceof v ? t : v,
            n = Object.create(i.prototype),
            o = new S(r || []);
        return n._invoke = function (e, t, a) {
          var r = "suspendedStart";
          return function (i, n) {
            if ("executing" === r) throw new Error("Generator is already running");

            if ("completed" === r) {
              if ("throw" === i) throw n;
              return R();
            }

            for (a.method = i, a.arg = n;;) {
              var o = a.delegate;

              if (o) {
                var s = b(o, a);

                if (s) {
                  if (s === c) continue;
                  return s;
                }
              }

              if ("next" === a.method) a.sent = a._sent = a.arg;else if ("throw" === a.method) {
                if ("suspendedStart" === r) throw r = "completed", a.arg;
                a.dispatchException(a.arg);
              } else "return" === a.method && a.abrupt("return", a.arg);
              r = "executing";
              var l = u(e, t, a);

              if ("normal" === l.type) {
                if (r = a.done ? "completed" : "suspendedYield", l.arg === c) continue;
                return {
                  value: l.arg,
                  done: a.done
                };
              }

              "throw" === l.type && (r = "completed", a.method = "throw", a.arg = l.arg);
            }
          };
        }(e, a, o), n;
      }

      function u(e, t, a) {
        try {
          return {
            type: "normal",
            arg: e.call(t, a)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      e.wrap = l;
      var c = {};

      function v() {}

      function p() {}

      function d() {}

      var g = {};

      g[i] = function () {
        return this;
      };

      var y = Object.getPrototypeOf,
          f = y && y(y(k([])));
      f && f !== t && a.call(f, i) && (g = f);
      var m = d.prototype = v.prototype = Object.create(g);

      function w(e) {
        ["next", "throw", "return"].forEach(function (t) {
          s(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function h(e, t) {
        var r;

        this._invoke = function (i, n) {
          function o() {
            return new t(function (r, o) {
              !function r(i, n, o, s) {
                var l = u(e[i], e, n);

                if ("throw" !== l.type) {
                  var c = l.arg,
                      v = c.value;
                  return v && "object" == typeof v && a.call(v, "__await") ? t.resolve(v.__await).then(function (e) {
                    r("next", e, o, s);
                  }, function (e) {
                    r("throw", e, o, s);
                  }) : t.resolve(v).then(function (e) {
                    c.value = e, o(c);
                  }, function (e) {
                    return r("throw", e, o, s);
                  });
                }

                s(l.arg);
              }(i, n, r, o);
            });
          }

          return r = r ? r.then(o, o) : o();
        };
      }

      function b(e, t) {
        var a = e.iterator[t.method];

        if (void 0 === a) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = void 0, b(e, t), "throw" === t.method)) return c;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return c;
        }

        var r = u(a, e.iterator, t.arg);
        if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, c;
        var i = r.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, c) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, c);
      }

      function P(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function T(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function S(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(P, this), this.reset(!0);
      }

      function k(e) {
        if (e) {
          var t = e[i];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var r = -1,
                n = function t() {
              for (; ++r < e.length;) {
                if (a.call(e, r)) return t.value = e[r], t.done = !1, t;
              }

              return t.value = void 0, t.done = !0, t;
            };

            return n.next = n;
          }
        }

        return {
          next: R
        };
      }

      function R() {
        return {
          value: void 0,
          done: !0
        };
      }

      return p.prototype = m.constructor = d, d.constructor = p, p.displayName = s(d, o, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, d) : (e.__proto__ = d, s(e, o, "GeneratorFunction")), e.prototype = Object.create(m), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, w(h.prototype), h.prototype[n] = function () {
        return this;
      }, e.AsyncIterator = h, e.async = function (t, a, r, i, n) {
        void 0 === n && (n = Promise);
        var o = new h(l(t, a, r, i), n);
        return e.isGeneratorFunction(a) ? o : o.next().then(function (e) {
          return e.done ? e.value : o.next();
        });
      }, w(m), s(m, o, "Generator"), m[i] = function () {
        return this;
      }, m.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var a in e) {
          t.push(a);
        }

        return t.reverse(), function a() {
          for (; t.length;) {
            var r = t.pop();
            if (r in e) return a.value = r, a.done = !1, a;
          }

          return a.done = !0, a;
        };
      }, e.values = k, S.prototype = {
        constructor: S,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(T), !e) for (var t in this) {
            "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;

          function r(a, r) {
            return o.type = "throw", o.arg = e, t.next = a, r && (t.method = "next", t.arg = void 0), !!r;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var n = this.tryEntries[i],
                o = n.completion;
            if ("root" === n.tryLoc) return r("end");

            if (n.tryLoc <= this.prev) {
              var s = a.call(n, "catchLoc"),
                  l = a.call(n, "finallyLoc");

              if (s && l) {
                if (this.prev < n.catchLoc) return r(n.catchLoc, !0);
                if (this.prev < n.finallyLoc) return r(n.finallyLoc);
              } else if (s) {
                if (this.prev < n.catchLoc) return r(n.catchLoc, !0);
              } else {
                if (!l) throw new Error("try statement without catch or finally");
                if (this.prev < n.finallyLoc) return r(n.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var i = this.tryEntries[r];

            if (i.tryLoc <= this.prev && a.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var n = i;
              break;
            }
          }

          n && ("break" === e || "continue" === e) && n.tryLoc <= t && t <= n.finallyLoc && (n = null);
          var o = n ? n.completion : {};
          return o.type = e, o.arg = t, n ? (this.method = "next", this.next = n.finallyLoc, c) : this.complete(o);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), c;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var a = this.tryEntries[t];
            if (a.finallyLoc === e) return this.complete(a.completion, a.afterLoc), T(a), c;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var a = this.tryEntries[t];

            if (a.tryLoc === e) {
              var r = a.completion;

              if ("throw" === r.type) {
                var i = r.arg;
                T(a);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, a) {
          return this.delegate = {
            iterator: k(e),
            resultName: t,
            nextLoc: a
          }, "next" === this.method && (this.arg = void 0), c;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = r;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t, a) {
    var r = a(17);

    e.exports = function (e) {
      if (Array.isArray(e)) return r(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var a = [],
            r = !0,
            i = !1,
            n = void 0;

        try {
          for (var o, s = e[Symbol.iterator](); !(r = (o = s.next()).done) && (a.push(o.value), !t || a.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          i = !0, n = e;
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (i) throw n;
          }
        }

        return a;
      }
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(32),
        i = a(33),
        n = a(19),
        o = a(34),
        s = a(12),
        l = function () {
      function e() {
        this.commandTypeVar = i.ExpressionType.Unknown;
      }

      return e.prototype.parse = function (e) {
        var t,
            a,
            l = new n.Index(0),
            u = e.trim();
        if (!s.Utils.eatSpaces(u, l)) throw new Error("Unexpected end of statement");
        if ((a = u.indexOf("WHEN")) < 0) throw new Error("WHEN keyword was not detected");

        switch (s.Utils.readToken(u, l).toUpperCase()) {
          case "SET":
            t = (t = u.substr(0, a)).substr("SET".length), this.assignmentVar = r.Assignment.parse(t), this.commandTypeVar = i.ExpressionType.Set;
            break;

          case "BLOCK":
            this.commandTypeVar = i.ExpressionType.Block;
            break;

          default:
            throw new Error("Unknown command type!");
        }

        t = u.substr(a + "WHEN".length), l.setValue(0), this.operationVar = o.Parser.parse(t, l);
      }, e.prototype.eval = function (e) {
        var t = !0;

        switch (this.commandTypeVar) {
          case i.ExpressionType.Set:
            this.operationVar.eval(e) && this.assignmentVar.eval(e);
            break;

          case i.ExpressionType.Block:
            this.operationVar.eval(e) && (t = !1);
        }

        return t;
      }, Object.defineProperty(e.prototype, "commandType", {
        get: function get() {
          return this.commandTypeVar;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "assignment", {
        get: function get() {
          return this.assignmentVar;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "operation", {
        get: function get() {
          return this.operationVar;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.Expression = l;
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(19),
        i = a(15),
        n = a(11),
        o = a(16),
        s = a(12),
        l = function () {
      function e(e, t) {
        e && (this.leftOperandVar = e), t && (this.rightOperandVar = t);
      }

      return e.parse = function (t) {
        var a,
            i,
            n,
            l = new r.Index(0);
        if (!s.Utils.eatSpaces(t, l)) throw new Error("Unable to parse due to spacing issues!");
        if (a = e.readOperand(t, l), s.Utils.eatSpaces(t, l), n = e.readToken(t, l, !1), s.Utils.stringToOperatorType(n) !== o.OperatorType.EQ) throw new Error("Invalid operator in assignment expression!");
        return s.Utils.eatSpaces(t, l), i = e.readOperand(t, l), new e(a, i);
      }, e.readOperand = function (t, a) {
        var r, n;

        try {
          n = e.readToken(t, a), r = i.Operand.parse(n);
        } catch (e) {
          throw new Error("Unable to parse operand: " + e);
        }

        return r;
      }, e.readToken = function (e, t, a) {
        var r = "";

        for (a = !1, s.Utils.eatSpaces(e, t), "'" === e[t.valueOf()] && (a = !0, t.increment()); t.valueOf() < e.length;) {
          if (a && "'" === e[t.valueOf()]) return t.increment(), r;
          if (!a && (s.Utils.isWhiteSpace(e[t.valueOf()]) || ")" === e[t.valueOf()])) return r;
          r += e[t.valueOf()], t.increment();
        }

        if (a) throw new Error("Unterminated token. Expected single quote");
        if ("" === r) throw new Error("Unexpected empty token");
        return r;
      }, e.prototype.eval = function (e) {
        var t;
        if (this.leftOperandVar.operandType === n.OperandType.Litteral) throw new Error("Invalid assignment to litteral operand");
        t = this.rightOperandVar.operandType === n.OperandType.Litteral ? this.rightOperandVar.value : this.rightOperandVar.operandType === n.OperandType.Data ? e.getValue(this.rightOperandVar) : e.getValue(this.leftOperandVar), e.setValue(this.leftOperandVar, t);
      }, Object.defineProperty(e.prototype, "rightOperand", {
        get: function get() {
          return this.rightOperandVar;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "leftOperand", {
        get: function get() {
          return this.leftOperandVar;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.Assignment = l;
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e[e.Unknown = 0] = "Unknown", e[e.Set = 1] = "Set", e[e.Block = 2] = "Block";
    }(t.ExpressionType || (t.ExpressionType = {}));
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(35),
        i = function () {
      function e() {}

      return e.parse = function (e, t) {
        return r.Operation.readOperation(e, t);
      }, e;
    }();

    t.Parser = i;
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(15),
        i = a(11),
        n = a(16),
        o = a(12),
        s = function () {
      function e(e, t, a) {
        this.op1Var = e, this.operatorTypeVar = t || n.OperatorType.Unknown, this.op2Var = a;
      }

      return e.readOperation = function (t, a) {
        var i, s, l, u;
        t = t.trim();
        var c = n.OperatorType.Unknown;
        if (!o.Utils.eatSpaces(t, a)) throw new Error("Unexpected EOL");

        for (; o.Utils.eatSpaces(t, a);) {
          if ("(" === t[a.valueOf()]) {
            if (a.increment(), s = e.readOperation(t, a), ")" !== t[a.valueOf()]) throw new Error("Expected ')'");
            if (s.operatorType === n.OperatorType.NOOP) throw new Error("Invalid operation: will always return true");
            a.increment(), i ? i.add(s, c) : i = s;
          } else {
            if (")" === t[a.valueOf()]) break;
            s = new e(r.Operand.readOperand(t, a), n.OperatorType.NOOP, null), i ? i.add(s, c) : i = s;
          }

          if (!o.Utils.eatSpaces(t, a)) return i;

          if (")" === t[a.valueOf()]) {
            if (null == i) throw new Error("Unexpected end of expression at index: " + a);
            return i;
          }

          if (u = o.Utils.readToken(t, a), c = o.Utils.stringToOperatorType(u), !o.Utils.eatSpaces(t, a)) throw new Error("Missing operand at index " + a);
          if (l = "(" === t[a.valueOf()] ? e.readOperation(t, a) : new e(r.Operand.readOperand(t, a), n.OperatorType.NOOP, null), i.add(l, c), !o.Utils.eatSpaces(t, a)) break;
          if (")" === t[a.valueOf()]) return i;
          if (u = o.Utils.readToken(t, a), !o.Utils.eatSpaces(t, a)) throw new Error("Missing operand at index " + a);
          c = o.Utils.stringToOperatorType(u), o.Utils.isLogicalOperator(c) && (l = e.readOperation(t, a), i = new e(i, c, l));
        }

        return i;
      }, e.convertToObject = function (e, t) {
        var a;
        if (e.operandType === i.OperandType.Litteral) a = "string" == typeof e.value && "null" === e.value.toLowerCase() ? null : "string" == typeof e.value && "undefined" === e.value.toLowerCase() ? void 0 : "string" == typeof e.value && "true" === e.value.toLowerCase() || ("string" != typeof e.value || "false" !== e.value.toLowerCase()) && e.value;else switch (e.operandType) {
          case i.OperandType.Cookies:
            throw new Error("Cookies is not a currently supported assignment");

          case i.OperandType.Data:
            a = t.data[e.value] ? t.data[e.value.toString()] : null;
            break;

          case i.OperandType.LocalStorage:
            throw new Error("LocalStorage is not a currently supported assignment");

          default:
            throw new Error("Invalid operand type");
        }
        return "string" != typeof a && "boolean" != typeof a && null !== a && (a = parseFloat(a)), a;
      }, e.calculate = function (t, a, r) {
        if ("boolean" == typeof t && "boolean" != typeof r || "boolean" != typeof t && "boolean" === r) throw new Error("Invalid operation on boolean value");

        switch (a) {
          case n.OperatorType.AND:
            return t && r;

          case n.OperatorType.OR:
            return t || r;

          case n.OperatorType.EQ:
            return t === r;

          case n.OperatorType.NEQ:
            return t !== r;

          case n.OperatorType.GT:
            return t > r;

          case n.OperatorType.GTE:
            return t >= r;

          case n.OperatorType.LT:
            return t < r;

          case n.OperatorType.LTE:
            return t <= r;

          case n.OperatorType.LIKE:
            return e.processLike(t, r);

          case n.OperatorType.ADD:
          case n.OperatorType.MINUS:
          case n.OperatorType.MULTIPLY:
          case n.OperatorType.DIVIDE:
            return e.processMathOperation(t, a, r);

          default:
            throw new Error("Unknown or invalid operator!");
        }
      }, e.processLike = function (e, t) {
        return RegExp(t).test(e);
      }, e.processMathOperation = function (t, a, r) {
        return o.Utils.isFloat(t) ? e.processFloatOperation(t, a, r) : e.processIntegerOperation(t, a, r);
      }, e.processIntegerOperation = function (e, t, a) {
        var r;

        switch (t) {
          case n.OperatorType.ADD:
            r = e + a;
            break;

          case n.OperatorType.MINUS:
            r = e - a;
            break;

          case n.OperatorType.MULTIPLY:
            r = e * a;
            break;

          case n.OperatorType.DIVIDE:
            r = e / a;
            break;

          default:
            throw new Error("Invalid math operation");
        }

        if (Number.isNaN(r) || !Number.isFinite(r)) throw new Error("Result is NaN or Infinite");
        return r;
      }, e.processFloatOperation = function (e, t, a) {
        var r;

        switch (t) {
          case n.OperatorType.ADD:
            r = parseFloat(e.toString()) + parseFloat(a.toString());
            break;

          case n.OperatorType.MINUS:
            r = parseFloat(e.toString()) - parseFloat(a.toString());
            break;

          case n.OperatorType.MULTIPLY:
            r = parseFloat(e.toString()) * parseFloat(a.toString());
            break;

          case n.OperatorType.DIVIDE:
            r = parseFloat(e.toString()) / parseFloat(a.toString());
            break;

          default:
            throw new Error("Invalid math operation");
        }

        if (Number.isNaN(r) || !Number.isFinite(r)) throw new Error("Result is NaN or Infinite");
        return parseFloat(r.toFixed(2));
      }, e.prototype.add = function (t, a) {
        this.operatorTypeVar === n.OperatorType.NOOP ? (this.operatorTypeVar = a, this.op2Var = t.operatorType === n.OperatorType.NOOP ? t.op1 : t) : (this.op1Var = new e(this.op1Var, this.operatorTypeVar, this.op2Var), this.operatorTypeVar = a, this.op2Var = t);
      }, e.prototype.eval = function (e) {
        var t;
        if ("boolean" != typeof (t = this.process(this, e))) throw new Error("Top-level operation must return a boolean");
        return t;
      }, e.prototype.process = function (t, a) {
        var n, o, s, l;
        return n = t.op1 instanceof e ? new r.Operand(this.process(t.op1, a), i.OperandType.Litteral) : t.op1, o = t.op2 instanceof e ? new r.Operand(this.process(t.op2, a), i.OperandType.Litteral) : t.op2, s = e.convertToObject(n, a), l = e.convertToObject(o, a), e.calculate(s, t.operatorType, l);
      }, Object.defineProperty(e.prototype, "op1", {
        get: function get() {
          return this.op1Var;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "op2", {
        get: function get() {
          return this.op2Var;
        },
        enumerable: !0,
        configurable: !0
      }), Object.defineProperty(e.prototype, "operatorType", {
        get: function get() {
          return this.operatorTypeVar;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.Operation = s;
  }, function (e, t, a) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = a(11),
        i = function () {
      function e() {
        this.dataVar = {};
      }

      return e.prototype.setValue = function (e, t) {
        switch (e.operandType) {
          case r.OperandType.Data:
            this.dataVar[e.value.toString()] = t;
            break;

          case r.OperandType.LocalStorage:
            throw new Error("LocalStorage is not a currently supported assignment");

          case r.OperandType.Cookies:
            throw new Error("Cookies is not a currently supported assignment");

          default:
            throw new Error("Invalid or unsupported assignment");
        }
      }, e.prototype.getValue = function (e) {
        switch (e.operandType) {
          case r.OperandType.Data:
            return this.dataVar[e.value.toString()];

          case r.OperandType.LocalStorage:
            throw new Error("LocalStorage is not a currently supported assignment");

          case r.OperandType.Cookies:
            throw new Error("Cookies is not a currently supported assignment");

          default:
            throw new Error("Invalid or unsupported assignment");
        }
      }, Object.defineProperty(e.prototype, "data", {
        get: function get() {
          return this.dataVar;
        },
        enumerable: !0,
        configurable: !0
      }), e;
    }();

    t.Context = i;
  }, function (e, t, a) {
    /*! @charter/quantum 6.13.0 */
    "undefined" != typeof self && self, e.exports = function (e) {
      var t = {};

      function a(r) {
        if (t[r]) return t[r].exports;
        var i = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(i.exports, i, i.exports, a), i.l = !0, i.exports;
      }

      return a.m = e, a.c = t, a.d = function (e, t, r) {
        a.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, a.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, a.t = function (e, t) {
        if (1 & t && (e = a(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (a.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var i in e) {
          a.d(r, i, function (t) {
            return e[t];
          }.bind(null, i));
        }
        return r;
      }, a.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return a.d(t, "a", t), t;
      }, a.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, a.p = "/", a(a.s = 62);
    }([function (e, t) {
      e.exports = function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      };
    }, function (e, t) {
      function a(e, t) {
        for (var a = 0; a < t.length; a++) {
          var r = t[a];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      e.exports = function (e, t, r) {
        return t && a(e.prototype, t), r && a(e, r), e;
      };
    }, function (e, t) {
      e.exports = function (e, t, a) {
        return t in e ? Object.defineProperty(e, t, {
          value: a,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = a, e;
      };
    }, function (e, t, a) {
      var r = a(52);

      e.exports = function (e, t, a) {
        var i = null == e ? void 0 : r(e, t);
        return void 0 === i ? a : i;
      };
    }, function (e, t, a) {
      var r = a(67);

      e.exports = function (e) {
        return r(e, 5);
      };
    }, function (e, t, a) {
      e.exports = a(66);
    }, function (e, t, a) {
      var r = a(47),
          i = a(39),
          n = a(49),
          o = Function.prototype,
          s = Object.prototype,
          l = o.toString,
          u = s.hasOwnProperty,
          c = l.call(Object);

      e.exports = function (e) {
        if (!n(e) || "[object Object]" != r(e)) return !1;
        var t = i(e);
        if (null === t) return !0;
        var a = u.call(t, "constructor") && t.constructor;
        return "function" == typeof a && a instanceof a && l.call(a) == c;
      };
    }, function (e, t) {
      function a(e, t, a, r, i, n, o) {
        try {
          var s = e[n](o),
              l = s.value;
        } catch (e) {
          return void a(e);
        }

        s.done ? t(l) : Promise.resolve(l).then(r, i);
      }

      e.exports = function (e) {
        return function () {
          var t = this,
              r = arguments;
          return new Promise(function (i, n) {
            var o = e.apply(t, r);

            function s(e) {
              a(o, i, n, s, l, "next", e);
            }

            function l(e) {
              a(o, i, n, s, l, "throw", e);
            }

            s(void 0);
          });
        };
      };
    }, function (e, t, a) {
      var r = a(50);

      e.exports = function (e, t, a) {
        return null == e ? e : r(e, t, a);
      };
    }, function (e, t, a) {
      var r = a(124),
          i = a(133)(function (e, t, a) {
        r(e, t, a);
      });
      e.exports = i;
    }, function (e, t) {
      var a = Array.isArray;
      e.exports = a;
    }, function (e, t, a) {
      var r = a(110),
          i = a(114)(function (e, t) {
        return null == e ? {} : r(e, t);
      });
      e.exports = i;
    }, function (e) {
      e.exports = JSON.parse('{"startSession":"session","userConfigSet":"session","playbackSelect":"playback","playbackStreamUriAcquired":"playback","playbackExitBeforeStart":"playback","playbackStart":"playback","playbackStartAfterRetry":"playback","playbackStop":"playback","bufferingStart":"playback","bufferingStop":"playback","playbackPause":"playback","playbackUnpause":"playback","playbackFailure":"playback","playbackFailureBeforeRetry":"playback","attemptRestart":"playback","playbackTrickPlayStart":"playback","playbackTrickPlayRateChange":"playback","playbackTrickPlayStop":"playback","playbackBitRateUpshift":"playback","playbackBitRateDownshift":"playback","playbackHeartbeat":"playback","loginStart":"login","loginStop":"login","logout":"login","inVisitOauthRefresh":"login","pageView":"navigation","modalView":"navigation","selectAction":"select","selectContent":"select","searched":"search","searchClosed":"search","adBreakStart":"ads","adBreakStop":"ads","adStart":"ads","adStop":"ads","error":"error","apiCall":"apiCall","pinEntry":"navigation","requestToRecord":"navigation","requestToDeleteRecording":"navigation","requestToEditRecording":"navigation","requestToCancelRecording":"navigation","setVideoZone":"session","setAccountFeatures":"session","setNetworkStatus":"session","setDeviceLocation":"session","setAutoAccessEnabled":"session","setExperimentConfigurations":"session","setSegment":"playback","pageViewInit":"navigation","pageViewPartiallyRendered":"navigation","purchaseStart":"navigation","purchaseStop":"navigation","applicationActivity":"navigation","checkAvailableChannels":"navigation","forcedLogin":"login","requestToRemind":"navigation","requestToEditReminder":"navigation","requestToDeleteReminder":"navigation","switchScreen":"navigation","setApplicationName":"session","displayChange":"navigation","setTimeZone":"session","featureStart":"navigation","featureStop":"navigation","deviceConfigSet":"session","modalCancel":"navigation","modalClose":"navigation","setBulkMduClass":"session","setPageAdditionalInfo":"navigation","setOtaChannels":"session","connectionChange":"session","setPictureInPicture":"navigation","setEntitlements":"session","pageViewPerformance":"navigation","userFeedback":"navigation","externalAppStateChange":"navigation","applicationCrash":"error","customEvent":"custom","impressionStart":"navigation","impressionStop":"navigation","assetDisplayed":"navigation","applicationPerformance":"session","deeplinkStart":"navigation","deeplinkStop":"navigation","concurrencyChange":"playback","setTrafficOriginId":"session","pushNotification":"navigation","setAccessibilitySettings":"session","setMaxVideoDetails":"playback","setResolution":"playback","setDevicePerformance":"session","setPlaybackPerformance":"playback","setAudioBitRate":"playback","setPackageInformation":"session","setLocationStatus":"session","webSocketActivity":"apiCall","webSocketHeartbeat":"apiCall","webSocketOpen":"apiCall","webSocketClose":"apiCall","webSocketError":"apiCall","temporaryView":"navigation","pageViewCompleteAwaitingAction":"navigation"}');
    }, function (e, t) {
      e.exports = function (e) {
        var t = typeof e;
        return null != e && ("object" == t || "function" == t);
      };
    }, function (e, t, a) {
      var r = a(21),
          i = a(22);

      e.exports = function (e, t, a, n) {
        var o = !a;
        a || (a = {});

        for (var s = -1, l = t.length; ++s < l;) {
          var u = t[s],
              c = n ? n(a[u], e[u], u, a, e) : void 0;
          void 0 === c && (c = e[u]), o ? i(a, u, c) : r(a, u, c);
        }

        return a;
      };
    }, function (e, t, a) {
      var r = a(93),
          i = a(42),
          n = a(30),
          o = a(45),
          s = n(function (e, t) {
        return o(e) ? r(e, i(t, 1, o, !0)) : [];
      });
      e.exports = s;
    }, function (e) {
      e.exports = JSON.parse('{"startSession":{"blank":"appInitializing"},"playbackSelect":{"initiating":"initiating","navigating":"initiating","failed":"initiating","DISABLED":"initiating","playing":"initiating","buffering":"initiating","appInitializing":"initiating","appInitialized":"initiating"},"playbackExitBeforeStart":{"initiating":"navigating","restarting":"navigating"},"playbackStreamUriAcquired":{"restarting":"initiating","initiating":"initiating"},"playbackStart":{"initiating":"playing","restarting":"playing"},"playbackStartAfterRetry":{"restarting":"playing"},"playbackStop":{"restarting":"navigating","playing":"navigating","buffering":"navigating","paused":"navigating"},"bufferingStart":{"playing":"buffering"},"bufferingStop":{"buffering":"playing"},"playbackPause":{"playing":"paused"},"playbackUnpause":{"paused":"playing"},"playbackFailure":{"playing":"failed","initiating":"failed","buffering":"failed","paused":"failed","scrubbing":"failed","restarting":"failed","DISABLED":"failed"},"playbackFailureBeforeRetry":{"playing":"failed","initiating":"failed","buffering":"failed","paused":"failed","scrubbing":"failed","restarting":"failed","DISABLED":"DISABLED"},"attemptRestart":{"failed":"restarting"},"playbackTrickPlayStart":{"playing":"scrubbing","paused":"scrubbing","buffering":"scrubbing"},"playbackTrickPlayRateChange":{"scrubbing":"scrubbing"},"playbackTrickPlayStop":{"scrubbing":"playing"},"playbackBitRateUpshift":{"playing":"playing","scrubbing":"scrubbing","buffering":"buffering","paused":"paused"},"playbackBitRateDownshift":{"playing":"playing","scrubbing":"scrubbing","buffering":"buffering","paused":"paused"},"playbackHeartbeat":{"playing":"playing"},"loginStart":{"navigating":"authenticating","appInitializing":"authenticating"},"loginStop":{"authenticating":"navigating"},"pageView":{"appInitializing":"navigating","appInitialized":"navigating","*":"*"},"modalView":{"appInitializing":"navigating","appInitialized":"navigating","*":"*"},"selectAction":{"*":"*"},"selectContent":{"*":"*"},"searched":{"*":"*"},"searchClosed":{"*":"*"},"adBreakStart":{"playing":"playing"},"adBreakStop":{"playing":"playing"},"adStart":{"playing":"playing"},"adStop":{"playing":"playing"},"apiCall":{"*":"*"},"error":{"*":"*"},"connectionChanged":{"*":"*"},"logout":{"failed":"navigating","restarting":"navigating","initiating":"navigating","*":"*"},"inVisitOauthRefresh":{"*":"*"},"userConfigSet":{"*":"*"},"pinEntry":{"*":"*"},"requestToRecord":{"*":"*"},"requestToDeleteRecording":{"*":"*"},"requestToEditRecording":{"*":"*"},"requestToCancelRecording":{"*":"*"},"setVideoZone":{"*":"*"},"setAccountFeatures":{"*":"*"},"setNetworkStatus":{"*":"*"},"setExperimentConfigurations":{"*":"*"},"setAutoAccessEnabled":{"*":"*"},"setSegment":{"*":"*"},"pageViewInit":{"*":"*"},"pageViewPartiallyRendered":{"*":"*"},"purchaseStart":{"*":"*"},"purchaseStop":{"*":"*"},"applicationActivity":{"*":"*"},"checkAvailableChannels":{"*":"*"},"forcedLogin":{"*":"*"},"experimentStarted":{"*":"*"},"requestToRemind":{"*":"*"},"requestToEditReminder":{"*":"*"},"requestToDeleteReminder":{"*":"*"},"switchScreen":{"*":"*"},"setApplicationName":{"*":"*"},"displayChange":{"*":"*"},"setPlayerTestFields":{"*":"*"},"setTimeZone":{"*":"*"},"featureStart":{"*":"*"},"featureStop":{"*":"*"},"deviceConfigSet":{"*":"*"},"modalCancel":{"*":"*"},"modalClose":{"*":"*"},"setBulkMduClass":{"*":"*"},"setPageAdditionalInfo":{"*":"*"},"setOtaChannels":{"*":"*"},"connectionChange":{"*":"*"},"setPictureInPicture":{"*":"*"},"setEntitlements":{"*":"*"},"pageViewPerformance":{"*":"*"},"userFeedback":{"*":"*"},"externalAppStateChange":{"*":"*"},"applicationCrash":{"*":"*"},"customEvent":{"*":"*"},"impressionStart":{"*":"*"},"impressionStop":{"*":"*"},"assetDisplayed":{"*":"*"},"applicationPerformance":{"*":"*"},"deeplinkStart":{"*":"*"},"deeplinkStop":{"*":"*"},"concurrencyChange":{"*":"*"},"pushNotification":{"*":"*"},"setDevicePerformance":{"*":"*"},"setPlaybackPerformance":{"*":"*"},"setAudioBitRate":{"*":"*"},"setPackageInformation":{"*":"*"},"setLocationStatus":{"*":"*"},"webSocketActivity":{"*":"*"},"webSocketHeartbeat":{"*":"*"},"webSocketOpen":{"*":"*"},"webSocketClose":{"*":"*"},"webSocketError":{"*":"*"},"pageViewCompleteAwaitingAction":{"*":"*"},"temporaryView":{"*":"*"}}');
    }, function (e, t, a) {
      var r = a(20);

      e.exports = function (e, t) {
        for (var a = e.length; a--;) {
          if (r(e[a][0], t)) return a;
        }

        return -1;
      };
    }, function (e, t, a) {
      var r = a(10),
          i = a(104),
          n = a(106),
          o = a(108);

      e.exports = function (e, t) {
        return r(e) ? e : i(e, t) ? [e] : n(o(e));
      };
    }, function (e, t, a) {
      var r = a(28),
          i = a(109),
          n = a(53),
          o = a(37);

      e.exports = function (e, t) {
        if (null == e) return {};
        var a = r(o(e), function (e) {
          return [e];
        });
        return t = i(t), n(e, a, function (e, a) {
          return t(e, a[0]);
        });
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        return e === t || e != e && t != t;
      };
    }, function (e, t, a) {
      var r = a(22),
          i = a(20),
          n = Object.prototype.hasOwnProperty;

      e.exports = function (e, t, a) {
        var o = e[t];
        n.call(e, t) && i(o, a) && (void 0 !== a || t in e) || r(e, t, a);
      };
    }, function (e, t, a) {
      var r = a(74);

      e.exports = function (e, t, a) {
        "__proto__" == t && r ? r(e, t, {
          configurable: !0,
          enumerable: !0,
          value: a,
          writable: !0
        }) : e[t] = a;
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        return function (a) {
          return e(t(a));
        };
      };
    }, function (e, t) {
      e.exports = function (e) {
        var t = [];
        if (null != e) for (var a in Object(e)) {
          t.push(a);
        }
        return t;
      };
    }, function (e, t, a) {
      var r = a(79),
          i = "object" == typeof self && self && self.Object === Object && self,
          n = r || i || Function("return this")();
      e.exports = n;
    }, function (e, t) {
      e.exports = function (e, t) {
        var a = -1,
            r = e.length;

        for (t || (t = Array(r)); ++a < r;) {
          t[a] = e[a];
        }

        return t;
      };
    }, function (e, t) {
      e.exports = function (e, t, a) {
        for (var r = a - 1, i = e.length; ++r < i;) {
          if (e[r] === t) return r;
        }

        return -1;
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        for (var a = -1, r = null == e ? 0 : e.length, i = Array(r); ++a < r;) {
          i[a] = t(e[a], a, e);
        }

        return i;
      };
    }, function (e, t) {
      e.exports = function () {
        return !1;
      };
    }, function (e, t, a) {
      var r = a(101),
          i = a(43),
          n = a(44);

      e.exports = function (e, t) {
        return n(i(e, t, r), e + "");
      };
    }, function (e, t) {
      e.exports = function (e) {
        return e;
      };
    }, function (e, t) {
      function a(t) {
        return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = a = function a(e) {
          return typeof e;
        } : e.exports = a = function a(e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, a(t);
      }

      e.exports = a;
    }, function (e, t) {
      function a(t) {
        return e.exports = a = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        }, a(t);
      }

      e.exports = a;
    }, function (e, t, a) {
      var r = a(68),
          i = a(69),
          n = a(70),
          o = a(71),
          s = a(72);

      function l(e) {
        var t = -1,
            a = null == e ? 0 : e.length;

        for (this.clear(); ++t < a;) {
          var r = e[t];
          this.set(r[0], r[1]);
        }
      }

      l.prototype.clear = r, l.prototype.delete = i, l.prototype.get = n, l.prototype.has = o, l.prototype.set = s, e.exports = l;
    }, function (e, t, a) {
      var r = a(23)(Object.keys, Object);
      e.exports = r;
    }, function (e, t, a) {
      (function (e) {
        var r = a(25),
            i = t && !t.nodeType && t,
            n = i && "object" == typeof e && e && !e.nodeType && e,
            o = n && n.exports === i ? r.Buffer : void 0,
            s = o ? o.allocUnsafe : void 0;

        e.exports = function (e, t) {
          if (t) return e.slice();
          var a = e.length,
              r = s ? s(a) : new e.constructor(a);
          return e.copy(r), r;
        };
      }).call(this, a(78)(e));
    }, function (e, t) {
      e.exports = function (e) {
        var t = [];
        if (null != e) for (var a in Object(e)) {
          t.push(a);
        }
        return t;
      };
    }, function (e, t, a) {
      var r = a(89),
          i = a(39),
          n = a(90);

      e.exports = function (e) {
        return "function" != typeof e.constructor || n(e) ? {} : r(i(e));
      };
    }, function (e, t, a) {
      var r = a(23)(Object.getPrototypeOf, Object);
      e.exports = r;
    }, function (e, t) {
      e.exports = function () {
        return !1;
      };
    }, function (e, t) {
      e.exports = function (e) {
        return function (t) {
          return e(t);
        };
      };
    }, function (e, t, a) {
      var r = a(98),
          i = a(99);

      e.exports = function e(t, a, n, o, s) {
        var l = -1,
            u = t.length;

        for (n || (n = i), s || (s = []); ++l < u;) {
          var c = t[l];
          a > 0 && n(c) ? a > 1 ? e(c, a - 1, n, o, s) : r(s, c) : o || (s[s.length] = c);
        }

        return s;
      };
    }, function (e, t, a) {
      var r = a(102),
          i = Math.max;

      e.exports = function (e, t, a) {
        return t = i(void 0 === t ? e.length - 1 : t, 0), function () {
          for (var n = arguments, o = -1, s = i(n.length - t, 0), l = Array(s); ++o < s;) {
            l[o] = n[t + o];
          }

          o = -1;

          for (var u = Array(t + 1); ++o < t;) {
            u[o] = n[o];
          }

          return u[t] = a(l), r(e, this, u);
        };
      };
    }, function (e, t) {
      e.exports = function (e) {
        return e;
      };
    }, function (e, t, a) {
      var r = a(103),
          i = a(49);

      e.exports = function (e) {
        return i(e) && r(e);
      };
    }, function (e, t, a) {
      var r = a(47),
          i = a(13);

      e.exports = function (e) {
        if (!i(e)) return !1;
        var t = r(e);
        return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
      };
    }, function (e, t) {
      var a = Object.prototype.toString;

      e.exports = function (e) {
        return a.call(e);
      };
    }, function (e, t) {
      e.exports = function (e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
      };
    }, function (e, t) {
      e.exports = function (e) {
        return null != e && "object" == typeof e;
      };
    }, function (e, t, a) {
      var r = a(21),
          i = a(18),
          n = a(51),
          o = a(13),
          s = a(31);

      e.exports = function (e, t, a, l) {
        if (!o(e)) return e;

        for (var u = -1, c = (t = i(t, e)).length, v = c - 1, p = e; null != p && ++u < c;) {
          var d = s(t[u]),
              g = a;

          if (u != v) {
            var y = p[d];
            void 0 === (g = l ? l(y, d, p) : void 0) && (g = o(y) ? y : n(t[u + 1]) ? [] : {});
          }

          r(p, d, g), p = p[d];
        }

        return e;
      };
    }, function (e, t) {
      var a = /^(?:0|[1-9]\d*)$/;

      e.exports = function (e, t) {
        var r = typeof e;
        return !!(t = null == t ? 9007199254740991 : t) && ("number" == r || "symbol" != r && a.test(e)) && e > -1 && e % 1 == 0 && e < t;
      };
    }, function (e, t, a) {
      var r = a(18),
          i = a(31);

      e.exports = function (e, t) {
        for (var a = 0, n = (t = r(t, e)).length; null != e && a < n;) {
          e = e[i(t[a++])];
        }

        return a && a == n ? e : void 0;
      };
    }, function (e, t, a) {
      var r = a(52),
          i = a(50),
          n = a(18);

      e.exports = function (e, t, a) {
        for (var o = -1, s = t.length, l = {}; ++o < s;) {
          var u = t[o],
              c = r(e, u);
          a(c, u) && i(l, n(u, e), c);
        }

        return l;
      };
    }, function (e, t, a) {
      var r = a(22),
          i = a(20);

      e.exports = function (e, t, a) {
        (void 0 !== a && !i(e[t], a) || void 0 === a && !(t in e)) && r(e, t, a);
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
      };
    }, function (e, t, a) {
      var r = a(64);

      e.exports = function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && r(e, t);
      };
    }, function (e, t, a) {
      var r = a(32),
          i = a(65);

      e.exports = function (e, t) {
        return !t || "object" !== r(t) && "function" != typeof t ? i(e) : t;
      };
    }, function (e, t, a) {
      var r = a(116),
          i = a(117),
          n = a(118),
          o = a(120);

      e.exports = function (e, t) {
        return r(e) || i(e, t) || n(e, t) || o();
      };
    }, function (e, t, a) {
      var r = a(30)(a(121));
      e.exports = r;
    }, function (e) {
      e.exports = JSON.parse('{"before":{"applicationActivity":[{"operation.operationType":["backgrounded","foregrounded","sectionView"]}],"switchScreen":[],"connectionChange":[]},"after":{"loginStart":[],"loginStop":[],"logout":[],"error":[],"playbackFailure":[],"userConfigSet":[],"deviceConfigSet":[],"switchScreen":[{"operation.switchScreenDirection":["referrerDisconnect"]}],"applicationActivity":[{"operation.operationType":["foregrounded"]}],"featureStop":[],"purchaseStop":[],"apiCall":[{"operation.success":[false]}]}}');
    }, function (e) {
      e.exports = JSON.parse('{"version":"2021-07-19:5f8869b60cbf57dae943b518adc56ea36a5c2279","domain":"portals","checks":{"apiCall":{"application.api.apiCached":{"venonaKey":"apiCached","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"]}],"value":true},{"value":false}]}},"application.api.architecture":{"venonaKey":"apiArchitecture","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.clientServiceResult":{"venonaKey":"clientServiceResult","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.gql.operationName":{"venonaKey":"gqlOperationName","validationRules":{"type":[{"value":"string"}],"allowed":[{"condition":[{"!application.api.architecture":["GQL"]}],"value":false},{"value":true}],"required":[{"condition":[{"application.api.architecture":["GQL"]}],"value":true},{"value":false}]}},"application.api.gql.operationType":{"venonaKey":"gqlOperationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"condition":[{"!application.api.architecture":["GQL"]}],"value":false},{"value":true}],"required":[{"condition":[{"application.api.architecture":["GQL"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["query","mutation"]}]}},"application.api.host":{"venonaKey":"host","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"application.api.httpVerb":{"venonaKey":"httpVerb","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"application.api.maxRetryCount":{"venonaKey":"maxRetryCount","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.path":{"venonaKey":"path","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"application.api.queryParameters":{"venonaKey":"queryParameters","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.reportedHeaders":{"venonaKey":"apiReportedHeaders","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.responseCode":{"venonaKey":"responseCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"application.api.responseSize":{"venonaKey":"responseSize","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.responseText":{"venonaKey":"responseText","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["SpectrumLocal","RegionalSportsNetwork","Hawaii"]}],"value":false},{"condition":[{"application.api.architecture":["GQL"],"application.api.clientServiceResult":["failure","partialFailure"]}],"value":true},{"value":false}]},"blacklists":["password"]},"application.api.responseTimeMs":{"venonaKey":"responseTimeMs","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"application.api.retry":{"venonaKey":"retry","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[true],"condition":[{"!application.api.retryCount":["anullValue",0]}]},{"value":[false],"condition":[{"application.api.retryCount":["anullValue",0]}]}]}},"application.api.retryCount":{"venonaKey":"retryCount","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[0],"condition":[{"application.api.retry":[false]}]}]}},"application.api.traceId":{"venonaKey":"traceId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["SpectrumLocal","RegionalSportsNetwork","Hawaii"]}],"value":false},{"value":false}]}},"application.api.willRetry":{"venonaKey":"willRetry","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings.appliedConfigs":{"venonaKey":"appliedConfigs","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings.privateAppliedConfigs":{"venonaKey":"privateAppliedConfigs","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings.reinitVersion":{"venonaKey":"reinitVersion","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"applicationActivity":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"value":false}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user"]}]}},"message.triggeredUsing":{"venonaKey":"triggeredUsing","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.intValue":{"venonaKey":"operationIntValue","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["remoteBatteryLevelCritical"]}],"value":true},{"value":false}]}},"operation.operationType":{"venonaKey":"operationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["backgrounded","foregrounded","startConversation","surveyRespondentId","chatId","userAddFailureBanner","userAddSuccessBanner","sectionView","bannerView","mobileBanner","alertView","resetModem","resetRouter","peopleCardSuccess","serviceOutage","saveSettingsSuccessful","saveSettingsUnsuccessful","verificationSuccessful","genericAppEvent"]}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.elementStringValue":{"venonaKey":"elementStringValue","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.elementUrl":{"venonaKey":"elementUrl","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSection.onSiteCampaignId":{"venonaKey":"onSiteCampaignId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.appointmentScheduled":{"venonaKey":"appointmentScheduled","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.autoPayStatus":{"venonaKey":"autoPayStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["active","suspended","locked","inactive","unknown"]}]}},"visit.account.details.billingAmountDueSource":{"venonaKey":"billingAmountDueSource","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["legacy","consolidated"]}]}},"visit.account.details.billingStatus":{"venonaKey":"billingStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["pastDue","current","inactiveAccount","unknown","hardDisconnectInvoluntary","hardDisconnectVoluntary","softDisconnect"]}]}},"visit.account.details.statementMethod":{"venonaKey":"statementMethod","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["paper","paperless","unknown"]}]}},"visit.account.equipment.activationStatus":{"venonaKey":"equipmentActivationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.internet.equipment":{"venonaKey":"accountInternetEquipment","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.internet.packageName":{"venonaKey":"accountInternetPackageName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.internet.premiumOrAddOn":{"venonaKey":"accountInternetPremiumOrAddOn","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.internet.productId":{"venonaKey":"accountInternetProductId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.phone.equipment":{"venonaKey":"accountPhoneEquipment","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.phone.packageName":{"venonaKey":"accountPhonePackageName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.phone.premiumOrAddOn":{"venonaKey":"accountPhonePremiumOrAddOn","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.phone.productId":{"venonaKey":"accountPhoneProductId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.tv.equipment":{"venonaKey":"accountTVEquipment","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.tv.packageName":{"venonaKey":"accountTVPackageName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.tv.premiumOrAddOn":{"venonaKey":"accountTVPremiumOrAddOn","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.tv.productId":{"venonaKey":"accountTVProductId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.externalApps":{"venonaKey":"externalApps","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"],"visit.device.browser.name":["Chrome"],"visit.device.deviceType":["webBrowser"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"]}],"value":true},{"value":false}]}},"visit.features.callerId":{"venonaKey":"featuresCallerId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.features.favorites":{"venonaKey":"featuresFavorites","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.features.parentalControls":{"venonaKey":"featuresParentalControls","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.features.powerOn":{"venonaKey":"featuresPowerOn","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.features.titleInGuide":{"venonaKey":"featuresTitleInGuide","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.kochavaSdk.firstInstall":{"venonaKey":"kochavaFirstInstall","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.kochavaSdk.installDate":{"venonaKey":"kochavaInstallDate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.kochavaSdk.kochavaDeviceId":{"venonaKey":"kochavaDeviceId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.kochavaSdk.originalRequest":{"venonaKey":"kochavaOriginalRequest","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.kochavaSdk.trackerId":{"venonaKey":"kochavaTrackerId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.kochavaSdk.waterfallLevel":{"venonaKey":"kochavaWaterfallLevel","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.permissionSettings.limitAdTracking":{"venonaKey":"limitAdTracking","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["true","false","unknown","restricted"]}]}},"visit.promotion.buyflow.appPromoState":{"venonaKey":"appPromoState","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.blacklistedFromFreePreview":{"venonaKey":"blacklistedFromFreePreview","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.blacklistedFromFreeTrial":{"venonaKey":"blacklistedFromFreeTrial","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.eligible":{"venonaKey":"buyflowEligible","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.householdFoundInMarketingFile":{"venonaKey":"householdFoundInMarketingFile","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.offerPriority":{"venonaKey":"offerPriority","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.presentedOffers":{"venonaKey":"presentedOffers","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.requestedFreePreviewDisabled":{"venonaKey":"requestedFreePreviewDisabled","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.requestedOfferId":{"venonaKey":"requestedOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.requestedOfferIsReturned":{"venonaKey":"requestedOfferIsReturned","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.requestedOfferMatchedTargeted":{"venonaKey":"requestedOfferMatchedTargeted","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.scenarioNumber":{"venonaKey":"scenarioNumber","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"min":[{"value":-99}],"max":[{"value":318}]}},"visit.promotion.buyflow.singleOfferReturned":{"venonaKey":"singleOfferReturned","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["true","false","unknown"]}]}},"visit.promotion.buyflow.targetedOfferFound":{"venonaKey":"targetedOfferFound","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.endDate":{"venonaKey":"promoEndDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["promoChange"],"visit.promotion.promoType":["freePreview"]}],"value":true},{"value":false}]}},"visit.promotion.offerId":{"venonaKey":"offerId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.promoId":{"venonaKey":"promoId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.promoType":{"venonaKey":"promoType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["promoPrice","Promotional","freeTrial","Free Trial","frontPorch","freePreview"]}]}},"visit.promotion.startDate":{"venonaKey":"promoStartDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"applicationPerformance":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.intValue":{"venonaKey":"operationIntValue","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"operation.operationType":{"venonaKey":"operationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["appLaunchTimeMs","closedCaptionDownload","fullAudioDownload","applobbyConnectionEstablished","applobbyHtmlLoaded","applobbyJsLoaded","appLaunchToVideoStartUp","appLaunchToVideoForeground"]}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"assetDisplayed":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.device.macAddress":{"venonaKey":"opDeviceMacAddress","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.device.serialNumber":{"venonaKey":"opDeviceSerialNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.operationType":{"venonaKey":"operationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.components":{"venonaKey":"components","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.currentBalanceAmount":{"venonaKey":"currentBalanceAmount","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.elementStringValue":{"venonaKey":"elementStringValue","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.xCoordinate":{"venonaKey":"elementXCoordinate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.yCoordinate":{"venonaKey":"elementYCoordinate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSection.name":{"venonaKey":"pageSectionName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.view.currentPage.pageSection.onSiteCampaignId":{"venonaKey":"onSiteCampaignId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pastDueAmount":{"venonaKey":"pastDueAmount","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.totalAmountDue":{"venonaKey":"totalAmountDue","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"connectionChange":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.operationType":{"venonaKey":"operationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.connection.connectionType":{"venonaKey":"connectionType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["wifi","wired","cell","offline","unknown"]}]}},"visit.connection.deviceLocation":{"venonaKey":"connectionDeviceLocation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["inMarket","outOfMarket","inHome","unknown"]}]}},"visit.connection.networkCellCarrier":{"venonaKey":"networkCellCarrier","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.connection.networkCellNetworkType":{"venonaKey":"networkCellNetworkType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.connection.networkStatus":{"venonaKey":"networkStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["RTDashboard","SpecNet","SMB","MySpectrum","SpecMobile"]}],"value":false},{"value":false}],"restrictedTo":[{"value":["onNet","offNet","unknown","inHome","inMarket","outOfMarket"]}]}}},"customEvent":{"custom.domain":{"venonaKey":"customDomain","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"custom.level":{"venonaKey":"customLevel","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["verbose","debug","info","warn","error","critical"]}]}},"custom.message":{"venonaKey":"customMessage","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"custom.name":{"venonaKey":"customName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"custom.sourceCodeInfo.fileName":{"venonaKey":"fileName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"custom.sourceCodeInfo.functionName":{"venonaKey":"functionName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"custom.sourceCodeInfo.lineNumber":{"venonaKey":"lineNumber","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"deeplinkStart":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.referrer.instanceCampaignId":{"venonaKey":"instanceCampaignId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.referrer.instanceLink":{"venonaKey":"instanceLink","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.referrer.instanceLocation":{"venonaKey":"instanceLocation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.campaign.campaignId":{"venonaKey":"campaignId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.applicationName":{"venonaKey":"referrerAppName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["OneApp","TVGo","Loader","UNKNOWN","Forums","SMB","SpecNet","IDManagement","community_portal","SpecCom","spectrumCommunityServices"]}]}},"visit.applicationDetails.referrerApp.applicationType":{"venonaKey":"referrerAppType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["Web","iOS","OVP","Android","AppleTV","com.apple.purplebuddy","com.apple.TVSettings","com.apple.VSViewService","Xbox","SamsungTV","Roku","FireTV"]}]}}},"deeplinkStop":{"application.error.clientErrorCode":{"venonaKey":"clientErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorCode":{"venonaKey":"errorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras":{"venonaKey":"errorExtras","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password","sensitive"]},"application.error.errorExtras.nativeErrorCode":{"venonaKey":"nativeErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.nativeErrorName":{"venonaKey":"nativeErrorName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorMessage":{"venonaKey":"errorMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.success":[false],"message.triggeredBy":["application"]}],"value":true},{"value":false}]},"blacklists":["password"]},"application.error.errorType":{"venonaKey":"errorType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.success":[false],"message.triggeredBy":["application"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["authentication","playback","api","generic","application","cyclops","cdvr","tdcs","deviceAvailability","networkDisconnected","msoAvailability","nonFatalPlayerError","rdvr","switchScreen","tvod","billPay","applicationCrash","identity","settings","chromecast","buyFlow","kochava","nielsenSDK","downloadError","webSocket"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"deviceConfigSet":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountFeatures.accessibility":{"venonaKey":"accessibility","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["RTDashboard","SpecNet","SMB","MySpectrum","SpecMobile"]}],"value":false},{"value":true}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.connection.networkStatus":{"venonaKey":"networkStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["RTDashboard","SpecNet","SMB","MySpectrum","SpecMobile"]}],"value":false},{"value":true}],"restrictedTo":[{"value":["onNet","offNet","unknown"]}]}},"visit.experimentUuids":{"venonaKey":"experimentUuids","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.variantUuids":{"venonaKey":"variantUuids","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"error":{"application.api.apiCached":{"venonaKey":"apiCached","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.architecture":{"venonaKey":"apiArchitecture","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.clientServiceResult":{"venonaKey":"clientServiceResult","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.gql.operationName":{"venonaKey":"gqlOperationName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.gql.operationType":{"venonaKey":"gqlOperationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["query","mutation"]}]}},"application.api.host":{"venonaKey":"host","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.httpVerb":{"venonaKey":"httpVerb","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.maxRetryCount":{"venonaKey":"maxRetryCount","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.path":{"venonaKey":"path","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.queryParameters":{"venonaKey":"queryParameters","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.reportedHeaders":{"venonaKey":"apiReportedHeaders","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.responseCode":{"venonaKey":"responseCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.responseSize":{"venonaKey":"responseSize","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.responseText":{"venonaKey":"responseText","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password"]},"application.api.responseTimeMs":{"venonaKey":"responseTimeMs","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.retry":{"venonaKey":"retry","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.retryCount":{"venonaKey":"retryCount","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.traceId":{"venonaKey":"traceId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.api.willRetry":{"venonaKey":"willRetry","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.clientErrorCode":{"venonaKey":"clientErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorCode":{"venonaKey":"errorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras":{"venonaKey":"errorExtras","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password","sensitive"]},"application.error.errorExtras.nativeErrorCode":{"venonaKey":"nativeErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.nativeErrorName":{"venonaKey":"nativeErrorName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.passedJailbreakChecks":{"venonaKey":"passedJailbreakChecks","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorMessage":{"venonaKey":"errorMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password"]},"application.error.errorType":{"venonaKey":"errorType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["authentication","playback","api","generic","application","cyclops","cdvr","tdcs","deviceAvailability","networkDisconnected","msoAvailability","nonFatalPlayerError","rdvr","switchScreen","tvod","billPay","applicationCrash","identity","settings","chromecast","buyFlow","kochava","nielsenSDK","downloadError","webSocket"]}]}},"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"value":false}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"featureStart":{"message.category":{"venonaKey":"category","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["contentDiscovery"],"condition":[{"message.context":["buyFlow","buyFlow2"]}]},{"value":["identity","equipment","billPay","activation","Notifications","contentDiscovery"]}]}},"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["identity","internetTroubleshoot","tvTroubleshoot","voiceTroubleshoot","equipTroubleshoot","buyFlow","buyFlow2","activation","paymentManagement","reminders","equipmentSelfInstall"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.accountNumber":{"venonaKey":"featureAccountNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.buyflow.offerId":{"venonaKey":"buyflowOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[419392,419400,419401,419394,419398,419396,419391,419399,419402,419393,419397,419395,"FreePreview-419391","FreePreview-419399","FreePreview-419402","FreePreview-419393","FreePreview-419397","FreePreview-419395","UEXSILVER","UEXGOLD","UEXSILVER5350","UEXGOLD5351"],"condition":[{"!visit.applicationDetails.applicationName":["SpecCom"]}]}]}},"message.feature.clientCart":{"venonaKey":"featureClientCart","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.currentStep":{"venonaKey":"featureCurrentStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["identity","internetTroubleshoot","tvTroubleshoot","voiceTroubleshoot","equipTroubleshoot","activation","paymentManagement","reminders"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"condition":[{"message.context":["identity","internetTroubleshoot","tvTroubleshoot","voiceTroubleshoot","equipTroubleshoot","activation","paymentManagement","reminders"]}],"value":true},{"value":false}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["identity","internetTroubleshoot","tvTroubleshoot","voiceTroubleshoot","equipTroubleshoot","activation","paymentManagement","reminders"]}],"value":true},{"value":false}]}},"message.feature.numberOfSteps":{"venonaKey":"featureNumberOfSteps","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"min":[{"value":0}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"featureStop":{"application.error.clientErrorCode":{"venonaKey":"clientErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorCode":{"venonaKey":"errorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow2"],"operation.success":[false],"message.triggeredBy":["application"]}],"value":true},{"value":false}]}},"application.error.errorExtras":{"venonaKey":"errorExtras","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password","sensitive"]},"application.error.errorExtras.nativeErrorCode":{"venonaKey":"nativeErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.nativeErrorName":{"venonaKey":"nativeErrorName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorMessage":{"venonaKey":"errorMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password"]},"application.error.errorType":{"venonaKey":"errorType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow2"],"operation.success":[false],"message.triggeredBy":["application"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["buyFlow"],"condition":[{"message.context":["buyFlow2"],"operation.success":[false],"message.triggeredBy":["application"]}]},{"value":["authentication","playback","api","generic","application","cyclops","cdvr","tdcs","deviceAvailability","networkDisconnected","msoAvailability","nonFatalPlayerError","rdvr","switchScreen","tvod","billPay","applicationCrash","identity","settings","chromecast","buyFlow","kochava","nielsenSDK","downloadError","webSocket"]}]}},"message.category":{"venonaKey":"category","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["identity","equipment","billPay","activation","Notifications"]}]}},"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["identity","internetTroubleshoot","tvTroubleshoot","voiceTroubleshoot","buyFlow","buyFlow2","activation","reminders","equipmentSelfInstall"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.buyflow.offerId":{"venonaKey":"buyflowOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[419392,419400,419401,419394,419398,419396,419391,419399,419402,419393,419397,419395,"FreePreview-419391","FreePreview-419399","FreePreview-419402","FreePreview-419393","FreePreview-419397","FreePreview-419395","UEXSILVER","UEXGOLD","UEXSILVER5350","UEXGOLD5351"],"condition":[{"!visit.applicationDetails.applicationName":["SpecCom"]}]}]}},"message.feature.clientCart":{"venonaKey":"featureClientCart","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.currentStep":{"venonaKey":"featureCurrentStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["identity","internetTroubleshoot","tvTroubleshoot","voiceTroubleshoot","activation","reminders"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"condition":[{"message.context":["identity","internetTroubleshoot","tvTroubleshoot","voiceTroubleshoot","activation","reminders"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["purchaseStop"],"condition":[{"message.context":["buyFlow"]}]},{"value":["purchaseStop"],"condition":[{"message.context":["buyFlow2"]}]}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["identity","internetTroubleshoot","tvTroubleshoot","voiceTroubleshoot","activation","reminders"]}],"value":true},{"value":false}]}},"message.feature.numberOfSteps":{"venonaKey":"featureNumberOfSteps","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"min":[{"value":0}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentAmountUsd":{"venonaKey":"paymentAmountUsd","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentDate":{"venonaKey":"paymentDate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentDueDate":{"venonaKey":"paymentDueDate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentMethod":{"venonaKey":"paymentMethod","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["autoPayCC","autoPayACH","creditDebitCard","checkingAccount","savingsAccount","newPaymentCC","newPaymentEFT","existingCreditDebitCard","existingEFT"]}]}},"operation.billing.statementAge":{"venonaKey":"statementAge","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"impressionStart":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.impression.campaignId":{"venonaKey":"impressionCampaignId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.impression.height":{"venonaKey":"impressionHeight","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.impression.id":{"venonaKey":"impressionId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.impression.impressionType":{"venonaKey":"impressionType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["iOS","AppleTV","OVP","Android","Roku","SpecGuide"]}],"value":false},{"value":true}],"restrictedTo":[{"value":["TIG","appLaunch"]}]}},"state.impression.location":{"venonaKey":"impressionLocation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.impression.locationTmsGuideId":{"venonaKey":"impressionLocationTmsGuideId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.impression.tmsProgramId":{"venonaKey":"impressionProgramId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.impression.tmsSeriesId":{"venonaKey":"impressionSeriesId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.impression.width":{"venonaKey":"impressionWidth","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"impressionStop":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.impression.id":{"venonaKey":"impressionId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.impression.interaction":{"venonaKey":"impressionInteraction","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["selected","none"]}]}},"state.impression.location":{"venonaKey":"impressionLocation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.impression.locationTmsGuideId":{"venonaKey":"impressionLocationTmsGuideId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"inVisitOauthRefresh":{"application.error.clientErrorCode":{"venonaKey":"clientErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorCode":{"venonaKey":"errorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras":{"venonaKey":"errorExtras","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password","sensitive"]},"application.error.errorExtras.nativeErrorCode":{"venonaKey":"nativeErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.nativeErrorName":{"venonaKey":"nativeErrorName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorMessage":{"venonaKey":"errorMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password"]},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"oAuthToken":{"venonaKey":"oAuthToken","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"tokenType":{"venonaKey":"tokenType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.login.oauthExpirationTimestamp":{"venonaKey":"oAuthExpirationTimestamp","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"loginStart":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.operationType":{"venonaKey":"operationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["biometricAuth","manualAuth","verifierAuth"],"condition":[{"visit.applicationDetails.applicationName":["MySpectrum"],"visit.applicationDetails.applicationType":["Android","iOS"]}]},{"value":["autoAccess","manualAuth"],"condition":[{"visit.applicationDetails.applicationName":["SelfInstall"],"visit.applicationDetails.applicationType":["Web"]}]},{"value":["biometricAuth","manualAuth"],"condition":[{"visit.applicationDetails.applicationName":["SpecMobile"],"visit.applicationDetails.applicationType":["iOS","Android"]}]},{"value":["autoAccess","manualAuth","verifierAuth"],"condition":[{"visit.applicationDetails.applicationName":["SpecNet"],"visit.applicationDetails.applicationType":["Web"]}]},{"value":["tokenExchange"],"condition":[{"visit.applicationDetails.applicationName":["SpectrumPaymentPlan"],"visit.applicationDetails.applicationType":["Web"]}]},{"value":["autoAccess","manualAuth","trustedAuth"],"condition":[{"visit.applicationDetails.applicationName":["TVEverywhere"],"visit.applicationDetails.applicationType":["Web"]}]},{"value":["manualAuth"],"condition":[{"visit.applicationDetails.applicationName":["SMB","SpectrumOffer","SpectrumWiFi","VoiceManager","VoiceZone"],"visit.applicationDetails.applicationType":["Web"]}]},{"value":["manualAuth","ssoAuth"],"condition":[{"visit.applicationDetails.applicationName":["IDManagement"],"visit.applicationDetails.applicationType":["Web"]}]},{"value":["manualAuth","autoAccess","resumeAuth","verifierAuth","tokenExchange","ssoAuth","appAuthorize","trustedAuth","biometricAuth","tvEverywhere"]}]}},"operation.userEntry.text":{"venonaKey":"entryText","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["manualAuth"],"visit.applicationDetails.applicationType":["Xbox"],"visit.applicationDetails.technologyType":["anullValue"]}],"value":false},{"condition":[{"operation.operationType":["manualAuth"]}],"value":true},{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.appIdentifier":{"venonaKey":"appIdentifier","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["AuthContext"],"operation.operationType":["appAuthorize"]}],"value":true},{"value":false}]}},"visit.applicationDetails.referrerApp.applicationName":{"venonaKey":"referrerAppName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["OneApp","TVGo","Loader","UNKNOWN","Forums","SMB","SpecNet","IDManagement","community_portal","SpecCom","spectrumCommunityServices"]}]}},"visit.applicationDetails.referrerApp.applicationType":{"venonaKey":"referrerAppType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["Web","iOS","OVP","Android","AppleTV","com.apple.purplebuddy","com.apple.TVSettings","com.apple.VSViewService","Xbox","SamsungTV","Roku","FireTV"]}]}},"visit.applicationDetails.referrerApp.visitId":{"venonaKey":"referrerAppVisitId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["AuthContext"],"operation.operationType":["appAuthorize"]}],"value":true},{"value":false}]}},"visit.applicationDetails.referrerLink":{"venonaKey":"referrerLink","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"loginStop":{"application.error.clientErrorCode":{"venonaKey":"clientErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorCode":{"venonaKey":"errorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras":{"venonaKey":"errorExtras","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password","sensitive"]},"application.error.errorExtras.nativeErrorCode":{"venonaKey":"nativeErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.nativeErrorName":{"venonaKey":"nativeErrorName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorMessage":{"venonaKey":"errorMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password"]},"application.error.errorType":{"venonaKey":"errorType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["authentication","deviceAvailability","msoAvailability"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"oAuthToken":{"venonaKey":"oAuthToken","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"tokenType":{"venonaKey":"tokenType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountBillingDivision":{"venonaKey":"accountBillingDivision","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountBillingDivisionId":{"venonaKey":"accountBillingDivisionId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountBillingId":{"venonaKey":"accountBillingId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountCompany":{"venonaKey":"accountCompany","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountFranchise":{"venonaKey":"accountFranchise","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountGUID":{"venonaKey":"accountGUID","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountNumber":{"venonaKey":"accountNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.login.oauthExpirationTimestamp":["anullValue"],"!visit.applicationDetails.environment.environmentName":["sita","sitb","dev","staging"]}],"value":true},{"value":false}]}},"visit.account.accountSiteId":{"venonaKey":"accountSiteId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.configurationFactors":{"venonaKey":"configurationFactors","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.mso":{"venonaKey":"mso","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions":{"venonaKey":"serviceSubscriptions","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.customerType":{"venonaKey":"serviceSubscriptionsCustType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.mobile":{"venonaKey":"serviceSubscriptionsMobile","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.mobileAccountNumber":{"venonaKey":"mobileAccountNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.paymentRestrictions":{"venonaKey":"paymentRestrictions","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.systemAgent":{"venonaKey":"systemAgent","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.systemPrin":{"venonaKey":"systemPrin","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.systemSys":{"venonaKey":"systemSys","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.trustedAuthId":{"venonaKey":"trustedAuthId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.applicationName":{"venonaKey":"referrerAppName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["SpecNet","SMB","SpectrumForums","MySpectrum"],"operation.operationType":["ssoAppAuthorize"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["OneApp","TVGo","Loader","UNKNOWN","Forums","SMB","SpecNet","IDManagement","community_portal","SpecCom","spectrumCommunityServices"]}]}},"visit.applicationDetails.referrerApp.applicationType":{"venonaKey":"referrerAppType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["SpecNet","SMB","SpectrumForums","MySpectrum"],"operation.operationType":["ssoAppAuthorize"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["Web","iOS","OVP","Android","AppleTV","com.apple.purplebuddy","com.apple.TVSettings","com.apple.VSViewService","Xbox","SamsungTV","Roku","FireTV"]}]}},"visit.applicationDetails.referrerApp.visitId":{"venonaKey":"referrerAppVisitId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["SpecNet","SMB","SpectrumForums","MySpectrum"],"operation.operationType":["ssoAppAuthorize"]}],"value":true},{"value":false}]}},"visit.applicationDetails.referrerLink":{"venonaKey":"referrerLink","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["SpecNet","SMB","SpectrumForums","MySpectrum"],"operation.operationType":["ssoAppAuthorize"]}],"value":true},{"value":false}]}},"visit.login.authAttemptId":{"venonaKey":"authAttemptId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.login.oauthExpirationTimestamp":{"venonaKey":"oAuthExpirationTimestamp","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.login.userToken":{"venonaKey":"userToken","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.user.role":{"venonaKey":"userRole","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["primary","admin","standard","customerFormer","customerCurrent","customerNever","secondaryAdmin","user"]}]}}},"logout":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"modalCancel":{"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["tvodFlow","cdvr","parentalControlFlow","dvr","onDemandFlow","rdvr","reminders","promos","billPay"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.currentStep":{"venonaKey":"featureCurrentStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"value":false}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"message.feature.numberOfSteps":{"venonaKey":"featureNumberOfSteps","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"min":[{"value":0}]}},"message.feature.previousStep":{"venonaKey":"featurePreviousStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"modalClose":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"modalView":{"application.error.clientErrorCode":{"venonaKey":"clientErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorCode":{"venonaKey":"errorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!state.view.modal.modalType":["error"]}],"value":false},{"value":true}]}},"application.error.errorExtras":{"venonaKey":"errorExtras","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password","sensitive"]},"application.error.errorExtras.nativeErrorCode":{"venonaKey":"nativeErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.nativeErrorName":{"venonaKey":"nativeErrorName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorMessage":{"venonaKey":"errorMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password"]},"application.error.errorType":{"venonaKey":"errorType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!state.view.modal.modalType":["error"]}],"value":false},{"value":true}],"restrictedTo":[{"value":["authentication","playback","api","generic","application","cyclops","cdvr","tdcs","deviceAvailability","networkDisconnected","msoAvailability","nonFatalPlayerError","rdvr","switchScreen","tvod","billPay","applicationCrash","identity","settings","chromecast","buyFlow","kochava","nielsenSDK","downloadError","webSocket"]}]}},"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["tvodFlow","cdvr","parentalControlFlow","dvr","onDemandFlow","rdvr","reminders","billPay","identity","settingsPurchaseControls","promos","buyFlow","buyFlow2","equipmentSelfInstall"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.buyflow.offerId":{"venonaKey":"buyflowOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[419392,419400,419401,419394,419398,419396,419391,419399,419402,419393,419397,419395,"FreePreview-419391","FreePreview-419399","FreePreview-419402","FreePreview-419393","FreePreview-419397","FreePreview-419395","UEXSILVER","UEXGOLD","UEXSILVER5350","UEXGOLD5351"],"condition":[{"!visit.applicationDetails.applicationName":["SpecCom"]}]}]}},"message.feature.clientCart":{"venonaKey":"featureClientCart","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.currentStep":{"venonaKey":"featureCurrentStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["tvodFlow"],"state.view.modal.modalType":["options","message"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"value":false}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["tvodFlow"],"state.view.modal.modalType":["options","message"]}],"value":true},{"value":false}]}},"message.feature.numberOfSteps":{"venonaKey":"featureNumberOfSteps","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"min":[{"value":0}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.modal.loadTimeMs":{"venonaKey":"loadTimeMs","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.modal.modalType":{"venonaKey":"modalType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["options","message","error","confirmation","notification"]}]}},"state.view.modal.name":{"venonaKey":"modalName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.view.modal.text":{"venonaKey":"modalText","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!state.view.modal.modalType":["options"],"!visit.applicationDetails.applicationName":["MySpectrum","SpecNet","SpecMobile","SMB","IDManagement"]}],"value":true},{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.user.role":{"venonaKey":"userRole","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["primary","admin","standard","customerFormer","customerCurrent","customerNever","secondaryAdmin","user"]}]}}},"pageView":{"application.error.errorExtras.nativeErrorCode":{"venonaKey":"nativeErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.nativeErrorName":{"venonaKey":"nativeErrorName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["reminders","featureTour","tvodFlow","cdvr","parentalControlFlow","dvr","rdvr","billPay","identity","buyFlow","buyFlow2","activation","promos","equipTroubleshoot"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.accountNumber":{"venonaKey":"featureAccountNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["ServiceManagement"]}],"value":false},{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.appSection":{"venonaKey":"appSection","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.view.currentPage.billing.billDueDate":{"venonaKey":"billDueDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.billEndDate":{"venonaKey":"billEndDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.billProgress":{"venonaKey":"billProgress","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.billStartDate":{"venonaKey":"billStartDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.ccVendor":{"venonaKey":"ccVendor","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["amex","discover","visa","masterCard","noneOnFile","other"]}]}},"state.view.currentPage.billing.core.billDueDate":{"venonaKey":"coreBillDueDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.core.billEndDate":{"venonaKey":"coreBillEndDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.core.billStartDate":{"venonaKey":"coreBillStartDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.mobile.billDueDate":{"venonaKey":"mobileBillDueDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.account.mobileAccountNumber":["","anullValue"]}],"value":true},{"value":false}]}},"state.view.currentPage.billing.mobile.billEndDate":{"venonaKey":"mobileBillEndDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.account.mobileAccountNumber":["","anullValue"]}],"value":true},{"value":false}]}},"state.view.currentPage.billing.mobile.billStartDate":{"venonaKey":"mobileBillStartDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.account.mobileAccountNumber":["","anullValue"]}],"value":true},{"value":false}]}},"state.view.currentPage.billing.paymentMethod":{"venonaKey":"paymentMethod","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["autoPayCC","autoPayACH","manualPay","creditDebitCard"]}]}},"state.view.currentPage.billing.recentCharges":{"venonaKey":"recentCharges","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.childMarket":{"venonaKey":"viewChildMarket","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["RegionalSportsNetwork","Hawaii"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationName":["SpectrumLocal"],"visit.applicationDetails.applicationType":["Web"]}],"value":true},{"value":false}]}},"state.view.currentPage.components":{"venonaKey":"components","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.orders":{"venonaKey":"currentPageOrders","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageDisplayType":{"venonaKey":"pageDisplayType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageId":{"venonaKey":"pageId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageName":{"venonaKey":"pageName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.view.currentPage.pageSection.allDisplayed":{"venonaKey":"sectionAllDisplayed","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSection.numberOfItems":{"venonaKey":"pageSectionNumberOfItems","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSubSection.allDisplayed":{"venonaKey":"subSectionAllDisplayed","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageTitle":{"venonaKey":"pageTitle","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"state.view.currentPage.pageName":["supportArticle"]}],"value":true},{"value":false}]}},"state.view.currentPage.pageType":{"venonaKey":"pageType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageUrl":{"venonaKey":"pageUrl","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageViewType":{"venonaKey":"pageViewType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["refresh","refocus","normal","overlayVisible"]}]}},"state.view.currentPage.parentMarket":{"venonaKey":"viewParentMarket","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["RegionalSportsNetwork","Hawaii"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationName":["SpectrumLocal"],"visit.applicationDetails.applicationType":["Web"]}],"value":true},{"value":false}]}},"state.view.currentPage.renderDetails.isLazyLoad":{"venonaKey":"isLazyLoad","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.sortAndFilter.appliedFilters":{"venonaKey":"appliedFilters","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"],"state.view.currentPage.pageName":["guideOptions"]}],"value":true},{"condition":[{"visit.applicationDetails.applicationType":["SamsungTV","Xbox","Roku"],"state.view.currentPage.pageName":["guide","liveTvMiniGuide"]}],"value":true},{"value":false}]}},"state.view.currentPage.sortAndFilter.appliedSorts":{"venonaKey":"appliedSorts","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"],"state.view.currentPage.pageName":["guideOptions"]}],"value":true},{"condition":[{"visit.applicationDetails.applicationType":["SamsungTV","Xbox","Roku"],"state.view.currentPage.pageName":["guide","liveTvMiniGuide"]}],"value":true},{"value":false}]}},"state.view.currentPage.uiResponsiveBreakpoint":{"venonaKey":"uiResponsiveBreakpoint","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Web"],"message.name":["pageView"],"visit.applicationDetails.applicationName":["SpecNet","SMB","SpecMobile","SpecCom"]}],"value":true},{"value":false}],"min":[{"value":1}]}},"state.view.currentPage.userSubJourney":{"venonaKey":"userSubJourney","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.device.deviceModel":{"venonaKey":"viewDeviceModel","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.device.deviceType":{"venonaKey":"viewDeviceType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.device.macAddress":{"venonaKey":"viewDeviceMacAddress","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.device.status":{"venonaKey":"viewDeviceStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.equipment.activationStatus":{"venonaKey":"equipmentActivationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerLink":{"venonaKey":"referrerLink","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerLocation":{"venonaKey":"referrerLocation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.user.role":{"venonaKey":"userRole","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["primary","admin","standard","customerFormer","customerCurrent","customerNever","secondaryAdmin","user"]}]}}},"pageViewCompleted":{"application.error.clientErrorCode":{"venonaKey":"clientErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorCode":{"venonaKey":"errorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras":{"venonaKey":"errorExtras","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password","sensitive"]},"application.error.errorMessage":{"venonaKey":"errorMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password"]},"application.error.errorType":{"venonaKey":"errorType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["authentication","playback","api","generic","application","cyclops","cdvr","tdcs","deviceAvailability","networkDisconnected","msoAvailability","nonFatalPlayerError","rdvr","switchScreen","tvod","billPay","applicationCrash","identity","settings","chromecast","buyFlow","kochava","nielsenSDK","downloadError","webSocket"]}]}},"message.feature.buyflow.offerId":{"venonaKey":"buyflowOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[419392,419400,419401,419394,419398,419396,419391,419399,419402,419393,419397,419395,"FreePreview-419391","FreePreview-419399","FreePreview-419402","FreePreview-419393","FreePreview-419397","FreePreview-419395","UEXSILVER","UEXGOLD","UEXSILVER5350","UEXGOLD5351"],"condition":[{"!visit.applicationDetails.applicationName":["SpecCom"]}]}]}},"message.feature.clientCart":{"venonaKey":"featureClientCart","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.currentStep":{"venonaKey":"featureCurrentStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"condition":[{"state.view.currentPage.pageName":["featureTour"]},{"message.context":["tvodFlow"]}],"value":false},{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"state.view.currentPage.pageName":["featureTour"]},{"message.context":["tvodFlow"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"value":false}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"state.view.currentPage.pageName":["featureTour"]},{"message.context":["tvodFlow"]}],"value":true},{"value":false}]}},"message.feature.numberOfSteps":{"venonaKey":"featureNumberOfSteps","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"condition":[{"state.view.currentPage.pageName":["featureTour"]},{"message.context":["tvodFlow"]}],"value":false},{"value":false}],"min":[{"value":0}]}},"message.feature.previousStep":{"venonaKey":"featurePreviousStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billerType":{"venonaKey":"billerType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["ICOMS","CSG","UNKNOWN","arterra"]}]}},"state.view.currentPage.billing.core.billStatus":{"venonaKey":"coreBillStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.core.currentBalanceAmount":{"venonaKey":"coreCurrentBalanceAmount","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.core.pastDueAmount":{"venonaKey":"corePastDueAmount","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.core.totalAmountDue":{"venonaKey":"coreTotalAmountDue","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.billing.mobile.billStatus":{"venonaKey":"mobileBillStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.account.mobileAccountNumber":["","anullValue"]}],"value":true},{"value":false}]}},"state.view.currentPage.billing.mobile.currentBalanceAmount":{"venonaKey":"mobileCurrentBalanceAmount","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.account.mobileAccountNumber":["","anullValue"]}],"value":true},{"value":false}]}},"state.view.currentPage.billing.mobile.pastDueAmount":{"venonaKey":"mobilePastDueAmount","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.account.mobileAccountNumber":["","anullValue"]}],"value":true},{"value":false}]}},"state.view.currentPage.billing.mobile.totalAmountDue":{"venonaKey":"mobileTotalAmountDue","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.account.mobileAccountNumber":["","anullValue"]}],"value":true},{"value":false}]}},"state.view.currentPage.campaign.pageViewCampaignId":{"venonaKey":"pageViewCampaignId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.currentBalanceAmount":{"venonaKey":"currentBalanceAmount","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pastDueAmount":{"venonaKey":"pastDueAmount","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.totalAmountDue":{"venonaKey":"totalAmountDue","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"pageViewPerformance":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.block":{"venonaKey":"block","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.eventsDispached.instances":{"venonaKey":"eventsInstances","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.eventsDispached.maxTimeDetails":{"venonaKey":"eventsMaxTimeDetails","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.eventsDispached.totalInstances":{"venonaKey":"eventsTotalInstances","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.eventsDispached.totalTimeMs":{"venonaKey":"eventsTotalTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.networkCalls.maxTimeMs":{"venonaKey":"networkMaxTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.networkCalls.totalCalls":{"venonaKey":"networkTotalCalls","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.networkCalls.totalTimeMs":{"venonaKey":"networkTotalTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.pageLaunchTimeMs":{"venonaKey":"pageLaunchTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.pairedFunctions.instances":{"venonaKey":"pairedFunctionsInstances","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.pairedFunctions.maxTimeDetails":{"venonaKey":"pairedFunctionsMaxTimeDetails","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.pairedFunctions.maxTimeMs":{"venonaKey":"pairedFunctionsMaxTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.pairedFunctions.totalInstances":{"venonaKey":"pairedFunctionsTotalInstances","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.pairedFunctions.totalTimeMs":{"venonaKey":"pairedFunctionsTotalTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.tag":{"venonaKey":"tag","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.timeInActionMs":{"venonaKey":"timeInActionMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsLoaded.instances":{"venonaKey":"viewsLoadedInstances","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsLoaded.maxTimeDetails":{"venonaKey":"viewsLoadedMaxTimeDetails","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsLoaded.maxTimeMs":{"venonaKey":"viewsLoadedMaxTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsLoaded.totalInstances":{"venonaKey":"viewsLoadedTotalInstances","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsLoaded.totalTimeMs":{"venonaKey":"viewsLoadedTotalTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsUpdated.instances":{"venonaKey":"viewsUpdatedInstances","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsUpdated.maxTimeDetails":{"venonaKey":"viewsUpdatedMaxTimeDetails","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsUpdated.maxTimeMs":{"venonaKey":"viewsUpdatedMaxTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsUpdated.totalInstances":{"venonaKey":"viewsUpdatedTotalInstances","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"performance.viewsUpdated.totalTimeMs":{"venonaKey":"viewsUpdatedTotalTimeMs","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"purchaseStart":{"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["billPay"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.buyflow.offerId":{"venonaKey":"buyflowOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[419392,419400,419401,419394,419398,419396,419391,419399,419402,419393,419397,419395,"FreePreview-419391","FreePreview-419399","FreePreview-419402","FreePreview-419393","FreePreview-419397","FreePreview-419395","UEXSILVER","UEXGOLD","UEXSILVER5350","UEXGOLD5351"],"condition":[{"!visit.applicationDetails.applicationName":["SpecCom"]}]}]}},"message.feature.clientCart":{"venonaKey":"featureClientCart","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.currentStep":{"venonaKey":"featureCurrentStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["tvodFlow"]}],"value":false},{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["tvodFlow"]}],"value":true},{"condition":[{"message.context":["billPay"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"condition":[{"message.context":["tvodFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow","buyFlow2"]}],"value":true},{"condition":[{"message.context":["billPay"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["purchaseStart"],"condition":[{"message.context":["buyFlow","buyFlow2"]}]}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["tvodFlow"]}],"value":true},{"condition":[{"message.context":["billPay"]}],"value":true},{"value":false}]}},"message.feature.numberOfSteps":{"venonaKey":"featureNumberOfSteps","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["tvodFlow"]}],"value":false},{"value":false}],"min":[{"value":0}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"purchaseStop":{"application.error.clientErrorCode":{"venonaKey":"clientErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorCode":{"venonaKey":"errorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras":{"venonaKey":"errorExtras","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password","sensitive"]},"application.error.errorExtras.nativeErrorCode":{"venonaKey":"nativeErrorCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorExtras.nativeErrorName":{"venonaKey":"nativeErrorName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"application.error.errorMessage":{"venonaKey":"errorMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]},"blacklists":["password"]},"application.error.errorType":{"venonaKey":"errorType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["tvod","buyFlow"]}]}},"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["billPay"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.buyflow.offerId":{"venonaKey":"buyflowOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[419392,419400,419401,419394,419398,419396,419391,419399,419402,419393,419397,419395,"FreePreview-419391","FreePreview-419399","FreePreview-419402","FreePreview-419393","FreePreview-419397","FreePreview-419395","UEXSILVER","UEXGOLD","UEXSILVER5350","UEXGOLD5351"],"condition":[{"!visit.applicationDetails.applicationName":["SpecCom"]}]}]}},"message.feature.clientCart":{"venonaKey":"featureClientCart","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.currentStep":{"venonaKey":"featureCurrentStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["billPay"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"condition":[{"message.context":["billPay"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["purchaseStop"],"condition":[{"message.context":["buyFlow"]}]},{"value":["purchaseStop"],"condition":[{"message.context":["buyFlow2"]}]}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["billPay"]}],"value":true},{"value":false}]}},"message.feature.numberOfSteps":{"venonaKey":"featureNumberOfSteps","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"min":[{"value":0}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentAmountUsd":{"venonaKey":"paymentAmountUsd","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentDate":{"venonaKey":"paymentDate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentDueDate":{"venonaKey":"paymentDueDate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentMethod":{"venonaKey":"paymentMethod","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["autoPayCC","autoPayACH","creditDebitCard","checkingAccount","savingsAccount","newPaymentCC","newPaymentEFT","existingCreditDebitCard","existingEFT"]}]}},"operation.billing.statementAge":{"venonaKey":"statementAge","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"pushNotification":{"message.category":{"venonaKey":"category","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["feedback","billing","marketing","appointment"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.notification.notificationCode":{"venonaKey":"notificationCode","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"message.notification.notificationMessage":{"venonaKey":"notificationMessage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"searchClosed":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"searched":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"message.triggeredUsing":{"venonaKey":"triggeredUsing","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["remote","backButton"]}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.search.numberOfSearchResults":{"venonaKey":"numberOfSearchResults","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.search.queryId":{"venonaKey":"queryId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!state.search.numberOfSearchResults":[0],"!visit.applicationDetails.applicationType":["Web"]}],"value":true},{"value":false}]}},"state.search.results":{"venonaKey":"results","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!state.search.numberOfSearchResults":[0],"!visit.applicationDetails.applicationType":["iOS","Android","SamsungTV","OVP","Roku","Web","AppleTV","Xbox","FireTV"]}],"value":true},{"value":false}],"maxLength":[{"value":5,"condition":[{"!state.search.numberOfSearchResults":[0],"!visit.applicationDetails.applicationType":["iOS","Android","SamsungTV","OVP","Roku","Web","AppleTV","Xbox","FireTV"]}]}]}},"state.search.resultsMs":{"venonaKey":"resultsMs","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":true}],"min":[{"value":0}],"max":[{"value":60000}]}},"state.search.searchId":{"venonaKey":"searchId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.search.searchResults":{"venonaKey":"searchResults","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"condition":[{"!state.search.numberOfSearchResults":[0],"!state.search.searchType":["university"],"!state.view.currentPage.pageName":["viewAllScreen"],"!visit.applicationDetails.applicationType":["SpecGuide"]}],"value":true},{"value":false}],"maxLength":[{"value":10,"condition":[{"!state.search.numberOfSearchResults":[0],"!state.search.searchType":["university"],"!state.view.currentPage.pageName":["viewAllScreen"],"!visit.applicationDetails.applicationType":["SpecGuide"]}]}]}},"state.search.searchType":{"venonaKey":"searchType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["predictive","keyword","default","university"]}]}},"state.search.text":{"venonaKey":"searchText","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.applicationDetails.applicationType":["Xbox"],"!state.search.searchType":["default"]}],"value":true},{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"selectAction":{"message.category":{"venonaKey":"category","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["navigation","search","contentDiscovery","authentication","activation"]}]}},"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["tvodFlow","cdvr","parentalControlFlow","dvr","rdvr","reminders","onDemandFlow","featureTour","billPay","identity","settingsPurchaseControls","voiceTroubleshoot","Standard","Administrator","promos","buyFlow","buyFlow2","activation","equipmentSelfInstall","preBuyFlow","postBuyFlow"]}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.buyflow.offerId":{"venonaKey":"buyflowOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":[419392,419400,419401,419394,419398,419396,419391,419399,419402,419393,419397,419395,"FreePreview-419391","FreePreview-419399","FreePreview-419402","FreePreview-419393","FreePreview-419397","FreePreview-419395","UEXSILVER","UEXGOLD","UEXSILVER5350","UEXGOLD5351"],"condition":[{"!visit.applicationDetails.applicationName":["SpecCom"]}]}]}},"message.feature.clientCart":{"venonaKey":"featureClientCart","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.currentStep":{"venonaKey":"featureCurrentStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"value":false}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"message.feature.numberOfSteps":{"venonaKey":"featureNumberOfSteps","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"min":[{"value":0}]}},"message.feature.previousStep":{"venonaKey":"featurePreviousStep","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.triggeredBy":{"venonaKey":"triggeredBy","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["user","application"]}]}},"message.triggeredUsing":{"venonaKey":"triggeredUsing","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Android"],"state.view.currentPage.elements.elementType":["volumeControl"]}],"value":true},{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentAmountUsd":{"venonaKey":"paymentAmountUsd","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentDate":{"venonaKey":"paymentDate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentDueDate":{"venonaKey":"paymentDueDate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.billing.paymentMethod":{"venonaKey":"paymentMethod","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["autoPayCC","autoPayACH","creditDebitCard","checkingAccount","savingsAccount","newPaymentCC","newPaymentEFT","existingCreditDebitCard","existingEFT"]}]}},"operation.billing.statementAge":{"venonaKey":"statementAge","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.device.macAddress":{"venonaKey":"opDeviceMacAddress","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.operationType":{"venonaKey":"operationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["accessibilityToggle","actionTileSelect","autoCollapse","autoDismiss","autoPayToggle","autoplayToggle","buttonClick","closedCaptionLanguage","closedCaptionStyle","closedCaptionTextSize","closedCaptionToggle","collapseClick","curatedCatalogCastAndCrew","curatedSearchCastAndCrew","curatedSearchEvents","curatedSearchNetworks","curatedSearchSports","curatedSearchTeam","dataNoticeToggle","dataReset","doubleTap","expandClick","favoritesUpdated","favoriteToggle","filterApplied","guideNarrationToggle","infoBarActivation","letterPicker","modalLaunch","navigationClick","networkSelection","paginationClick","paperlessToggle","parentalControlNetworkToggle","parentalControlToggle","picker","pinch","playButtonClicked","ratingRestrictionsUpdated","relatedArticleSelection","remoteControlBack","remoteControlClick","sapToggle","searchStarted","secondaryAudioToggle","singleTap","sortApplied","swipe","toolTipLaunch","unpinch","volumeChange","watchListAdd","watchListRemove","wideScreenToggle","toggleFlip","dropDown","blockedNetworksUpdated","textField"]}]}},"operation.settingsUpdates":{"venonaKey":"settingsUpdates","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.toggleState":{"venonaKey":"toggleState","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["favoriteToggle","closedCaptionToggle","dataNoticeToggle","sapToggle","guideNarrationToggle","accessiblityToggle","wideScreenToggle","secondaryAudioToggle","parentalControlToggle","parentalControlNetworkToggle"]}],"value":true},{"value":false}]}},"operation.userEntry.accountNumber":{"venonaKey":"accountNumber","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.email":{"venonaKey":"email","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.entryType":{"venonaKey":"entryType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["picker"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["username","ccSettingsText","ccSettingsTextTransparency","ccSettingsFont","ccSettingsFontSize","ccSettingsFontEdge","ccSettingsBackground","ccSettingsBackgroundTransparency","ccSettingsWindow","ccSettingsWindowTransparency","chatActivity","feedbackForm"]}]}},"operation.userEntry.phoneNumber":{"venonaKey":"phoneNumber","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.securityCode":{"venonaKey":"securityCode","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.text":{"venonaKey":"entryText","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["picker"]}],"value":true},{"value":false}]}},"operation.userEntry.zipcode":{"venonaKey":"zipcode","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userPreferenceCategory":{"venonaKey":"userPreferenceCategory","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["clearHistory","ratingsLocked","networksBlocked","networkFavorites","surferGuideFiltersApplied","addOnsDeleted","addOnsSelected","notifications","guideNarrationVoice","guideNarrationSpeed"]}]}},"operation.userPreferencesSelections":{"venonaKey":"userPreferencesSelections","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.search.searchId":{"venonaKey":"searchId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["searchStarted"]}],"value":true},{"value":false}]}},"state.search.searchType":{"venonaKey":"searchType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["searchStarted"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["predictive","keyword","default","university"]}]}},"state.view.currentPage.elements.elementIndex":{"venonaKey":"elementIndex","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.elementIntValue":{"venonaKey":"elementIntValue","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.elementStringValue":{"venonaKey":"elementStringValue","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.elementType":{"venonaKey":"elementType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.elementUrl":{"venonaKey":"elementUrl","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.numberOfItems":{"venonaKey":"elementNumberOfItems","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.selectedOptions":{"venonaKey":"selectedOptions","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.standardizedName":{"venonaKey":"elementStandardizedName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"state.view.currentPage.elements.uiName":{"venonaKey":"elementUiName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.xCoordinate":{"venonaKey":"elementXCoordinate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.elements.yCoordinate":{"venonaKey":"elementYCoordinate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSection.index":{"venonaKey":"pageSectionIndex","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSection.name":{"venonaKey":"pageSectionName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSection.numberOfItems":{"venonaKey":"pageSectionNumberOfItems","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSection.onSiteCampaignId":{"venonaKey":"onSiteCampaignId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSubSection.index":{"venonaKey":"pageSubSectionIndex","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSubSection.name":{"venonaKey":"pageSubSectionName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.pageSubSection.numberOfItems":{"venonaKey":"pageSubSectionNumberOfItems","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"state.view.currentPage.sortAndFilter.appliedFilters":{"venonaKey":"appliedFilters","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["filterApplied"]}],"value":true},{"value":false}]}},"state.view.currentPage.sortAndFilter.appliedSorts":{"venonaKey":"appliedSorts","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"operation.operationType":["sortApplied"]}],"value":true},{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.user.role":{"venonaKey":"userRole","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["primary","admin","standard","customerFormer","customerCurrent","customerNever","secondaryAdmin","user"]}]}}},"setAccessibilitySettings":{"visit.device.settings.closedCaption":{"venonaKey":"closedCaptionSetting","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["true","false"]}]}},"visit.device.settings.descriptiveVideoServices":{"venonaKey":"descriptiveVideoSetting","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.settings.voiceover":{"venonaKey":"voiceoverSetting","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Android","iOS"]}],"value":true},{"value":false}]}}},"setAdBlockerInfo":{"visit.device.browser.adBlockerDetected":{"venonaKey":"adBlockerDetected","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.browser.adBlockerEnabled":{"venonaKey":"adBlockerEnabled","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setBuyflowPromotionFields":{"visit.promotion.buyflow.appPromoState":{"venonaKey":"appPromoState","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.blacklistedFromFreePreview":{"venonaKey":"blacklistedFromFreePreview","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.blacklistedFromFreeTrial":{"venonaKey":"blacklistedFromFreeTrial","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.eligible":{"venonaKey":"buyflowEligible","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.householdFoundInMarketingFile":{"venonaKey":"householdFoundInMarketingFile","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.offerPriority":{"venonaKey":"offerPriority","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.presentedOffers":{"venonaKey":"presentedOffers","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.requestedFreePreviewDisabled":{"venonaKey":"requestedFreePreviewDisabled","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.requestedOfferId":{"venonaKey":"requestedOfferId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.requestedOfferIsReturned":{"venonaKey":"requestedOfferIsReturned","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.requestedOfferMatchedTargeted":{"venonaKey":"requestedOfferMatchedTargeted","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.buyflow.scenarioNumber":{"venonaKey":"scenarioNumber","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}],"min":[{"value":-99}],"max":[{"value":318}]}},"visit.promotion.buyflow.singleOfferReturned":{"venonaKey":"singleOfferReturned","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["true","false","unknown"]}]}},"visit.promotion.buyflow.targetedOfferFound":{"venonaKey":"targetedOfferFound","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setClientLocation":{"visit.location.clientLatitude":{"venonaKey":"clientLatitude","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.location.clientLongitude":{"venonaKey":"clientLongitude","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setDevicePerformance":{"visit.device.performance.cpuUsagePercent":{"venonaKey":"cpuUsagePercent","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.performance.ramUsageMb":{"venonaKey":"ramUsageMb","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setExperimentConfigurations":{"visit.experimentUuids":{"venonaKey":"experimentUuids","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.variantUuids":{"venonaKey":"variantUuids","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setLocationStatus":{"visit.permissionSettings.bleLocationStatus":{"venonaKey":"bleLocationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["notPresent","notUsable","usable"]}]}},"visit.permissionSettings.gpsLocationStatus":{"venonaKey":"gpsLocationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["notPresent","notUsable","usable"]}]}},"visit.permissionSettings.locationStatus":{"venonaKey":"locationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["notPresent","notUsable","usable"]}]}},"visit.permissionSettings.networkLocationStatus":{"venonaKey":"networkLocationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["notPresent","notUsable","usable"]}]}}},"setPackageInformation":{"visit.account.lineOfBusiness.internet.equipment":{"venonaKey":"accountInternetEquipment","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.internet.packageName":{"venonaKey":"accountInternetPackageName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.internet.premiumOrAddOn":{"venonaKey":"accountInternetPremiumOrAddOn","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.internet.productId":{"venonaKey":"accountInternetProductId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.phone.equipment":{"venonaKey":"accountPhoneEquipment","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.phone.packageName":{"venonaKey":"accountPhonePackageName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.phone.premiumOrAddOn":{"venonaKey":"accountPhonePremiumOrAddOn","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.phone.productId":{"venonaKey":"accountPhoneProductId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.tv.equipment":{"venonaKey":"accountTVEquipment","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.tv.packageName":{"venonaKey":"accountTVPackageName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.tv.premiumOrAddOn":{"venonaKey":"accountTVPremiumOrAddOn","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.lineOfBusiness.tv.productId":{"venonaKey":"accountTVProductId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setPageAdditionalInfo":{"state.view.currentPage.additionalInformation":{"venonaKey":"currentPageAdditionalInfo","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setRemoteModel":{"visit.device.remoteModel":{"venonaKey":"remoteModel","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setTrafficOriginId":{"visit.isp.trafficOriginId":{"venonaKey":"trafficOriginId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"setUserInteraction":{"visit.permissionSettings.userInteraction":{"venonaKey":"userInteraction","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"startSession":{"customer":{"venonaKey":"customer","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["Charter"]}]}},"domain":{"venonaKey":"domain","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountNumber":{"venonaKey":"accountNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.login.oauthExpirationTimestamp":["anullValue"],"!visit.applicationDetails.environment.environmentName":["sita","sitb","dev","staging"]}],"value":true},{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"]}],"value":true},{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.analytics.libraryInitTimeMs":{"venonaKey":"libraryInitTimeMs","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.analytics.libraryVersion":{"venonaKey":"libraryVersion","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.analytics.requirementsResponseTimeMs":{"venonaKey":"requirementsResponseTimeMs","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.analytics.requirementsSource":{"venonaKey":"requirementsSource","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["remote","local","embedded","cache"]}]}},"visit.analytics.requirementsVersion":{"venonaKey":"requirementsVersion","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.appDisplayDefinition":{"venonaKey":"appDisplayDefinition","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["sd","hd"]}]}},"visit.applicationDetails.appVersion":{"venonaKey":"appVersion","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.applicationDetails.applicationName":{"venonaKey":"applicationName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["RTDashboard","SpecNet","SMB","MySpectrum","SpecMobile","SpectrumWiFi","IDManagement","ServiceManagement","PrivacyMicrosite","SpectrumEnterprise","SpectrumOffer","WebMail","TVEverywhere","SpectrumForums","SpectrumPaymentPlan","WifiCaptivePortal","VoiceManager","VoiceZone","SelfInstall","CharterPublicPolicy","SelfCare","MobileOnboardingMicrosite","SolutionMappingTool","SpectrumCommunityServices","SpecCom"]}]}},"visit.applicationDetails.applicationType":{"venonaKey":"applicationType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["Web","iOS","Android"]}]}},"visit.applicationDetails.buildTimestamp":{"venonaKey":"buildTimestamp","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["OneApp","BulkMDU"],"visit.applicationDetails.applicationType":["Xbox"]}],"value":true},{"value":false}]}},"visit.applicationDetails.campaign.campaignId":{"venonaKey":"campaignId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.environment":{"venonaKey":"environment","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.applicationDetails.environment.environmentName":{"venonaKey":"environment.environmentName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["prod","dev","dev2","sita","sitb","pidev","staging","reno","virtual-dev","virtual-qa","pistaging","figaro-prod","engprod","engprod2","engnew","figaro-engnew","dev_mock","dev_mg_int","dev_audi_sst","dev_bmw_sit","qa","specbiz_dev","specbiz_prod","spectrum_mobile_dev","spectrum_mobile_prod","mock","ci","stage","local","ephem","figaro-dev","figaro-2-production","figaro-complete-mock","figaro-sit-b","ctecpi","N/A","vas","portalslocal","preprod","portalsengprod","portalsdev","portalsqa","portalsuat","portalsfe","qaportal","ephemeral","fe","uat","prod_eft"]}]}},"visit.applicationDetails.packageVersion":{"venonaKey":"packageVersion","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["OneApp","BulkMDU"],"visit.applicationDetails.applicationType":["Xbox"]}],"value":true},{"value":false}]}},"visit.applicationDetails.referrerApp.appIdentifier":{"venonaKey":"appIdentifier","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.applicationName":{"venonaKey":"referrerAppName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"],"visit.device.deviceType":["BROWSER"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationType":["Chromecast"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["OneApp","TVGo","Loader","UNKNOWN","Forums","SMB","SpecNet","IDManagement","community_portal","SpecCom","spectrumCommunityServices"]}]}},"visit.applicationDetails.referrerApp.applicationType":{"venonaKey":"referrerAppType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Chromecast"]}],"value":true},{"condition":[{"visit.applicationDetails.applicationType":["AuthContext"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["Web","iOS","OVP","Android","AppleTV","com.apple.purplebuddy","com.apple.TVSettings","com.apple.VSViewService","Xbox","SamsungTV","Roku","FireTV"]}]}},"visit.applicationDetails.referrerApp.connection.ipAddress":{"venonaKey":"referrerAppIpAddress","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.connection.port":{"venonaKey":"referrerAppConnectionPort","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.connection.secure":{"venonaKey":"referrerAppConnectionSecure","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.connection.type":{"venonaKey":"referrerAppConnectionType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.device.displayPPI":{"venonaKey":"referrerAppDeviceDisplayPPI","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.device.displaySize":{"venonaKey":"referrerAppDeviceDisplaySize","validationRules":{"type":[{"value":"double"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.device.id":{"venonaKey":"referrerAppDeviceId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.device.operatingSystem":{"venonaKey":"referrerAppOperatingSystem","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.device.type":{"venonaKey":"referrerAppDeviceType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.isActive":{"venonaKey":"referrerAppIsActive","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Chromecast"]}],"value":true},{"value":false}]}},"visit.applicationDetails.referrerApp.secondaryIdentifier":{"venonaKey":"referrerAppSecondaryIdentifier","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerApp.visitId":{"venonaKey":"referrerAppVisitId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Chromecast"]}],"value":true},{"value":false}]}},"visit.applicationDetails.referrerLink":{"venonaKey":"referrerLink","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.applicationDetails.referrerLocation":{"venonaKey":"referrerLocation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.connection.connectionType":{"venonaKey":"connectionType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.applicationDetails.applicationType":["Roku","Android"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["wifi","wired","cell","offline","unknown"]}]}},"visit.connection.networkCellCarrier":{"venonaKey":"networkCellCarrier","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.connection.networkCellNetworkType":{"venonaKey":"networkCellNetworkType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.connection.networkStatus":{"venonaKey":"networkStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["RTDashboard","SpecNet","SMB","MySpectrum","SpecMobile"]}],"value":false},{"value":false}],"restrictedTo":[{"value":["onNet","offNet","unknown"]}]}},"visit.device.androidDeviceId":{"venonaKey":"androidDeviceId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.availableStorage":{"venonaKey":"availableStorage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.controllerType":{"venonaKey":"controllerType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["OneApp","BulkMDU"],"visit.applicationDetails.applicationType":["Xbox"]}],"value":true},{"value":false}]}},"visit.device.deviceBuild":{"venonaKey":"deviceBuild","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["SamsungTV"]}],"value":true},{"value":false}]}},"visit.device.deviceFormFactor":{"venonaKey":"formFactor","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Xbox","SamsungTV"]}],"value":false},{"condition":[{"!visit.applicationDetails.applicationType":["Android","iOS","AppleTV"]}],"value":true},{"value":false}],"restrictedTo":[{"value":["tablet","phone"],"condition":[{"visit.applicationDetails.applicationType":["iOS","Android"]}]},{"value":["tv"],"condition":[{"visit.applicationDetails.applicationType":["AppleTV","Xbox","Roku","SpecGuide","SamsungTV","Chromecast"]}]},{"value":["tablet","phone","pc"],"condition":[{"visit.applicationDetails.applicationType":["OVP","Web"]}]},{"value":["pc","phone","tablet","tv"]}]}},"visit.device.deviceType":{"venonaKey":"deviceType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}],"restrictedTo":[{"value":["webBrowser","iPhone","iPad","iPod touch","simulator","iPhone Simulator","iPad Simulator","androidTablet","androidPhone","webBrowser"]}]}},"visit.device.displayRefreshRateHz":{"venonaKey":"displayRefreshRateHz","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.manufacturer":{"venonaKey":"manufacturer","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Android"]}],"value":true},{"value":false}]}},"visit.device.model":{"venonaKey":"deviceModel","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["Chromecast"]}],"value":false},{"value":true}]}},"visit.device.operatingSystem":{"venonaKey":"operatingSystem","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":true}]}},"visit.device.secondaryUuid":{"venonaKey":"deviceSecondaryUUID","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.usedStorage":{"venonaKey":"usedStorage","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.uuid":{"venonaKey":"deviceUUID","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.applicationDetails.applicationType":["Roku","Android"]}],"value":true},{"value":false}]}},"visit.device.vendorId":{"venonaKey":"vendorId","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.device.vendorId.vendorId":{"venonaKey":"vendorId.vendorId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.externalApps":{"venonaKey":"externalApps","validationRules":{"type":[{"value":"array"}],"elementType":[{"value":"object"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"],"visit.device.browser.name":["Chrome"],"visit.device.deviceType":["webBrowser"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"]}],"value":true},{"condition":[{"visit.applicationDetails.applicationType":["SpecGuide"]}],"value":true},{"value":false}]}},"visit.features.backgroundAudioEnabled":{"venonaKey":"backgroundAudioEnabled","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["on","off","headphonesOrExternalAudio"]}]}},"visit.inFocus":{"venonaKey":"inFocus","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.login.authCookieName":{"venonaKey":"authCookieName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["CHTR","TWC","BHN","No Cookie"]}]}},"visit.login.userToken":{"venonaKey":"userToken","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.permissionSettings.bleLocationStatus":{"venonaKey":"bleLocationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["notPresent","notUsable","usable"]}]}},"visit.permissionSettings.gpsLocationStatus":{"venonaKey":"gpsLocationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["notPresent","notUsable","usable"]}]}},"visit.permissionSettings.limitAdTracking":{"venonaKey":"limitAdTracking","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["true","false","unknown","restricted"]}]}},"visit.permissionSettings.locationStatus":{"venonaKey":"locationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["notPresent","notUsable","usable"]}]}},"visit.permissionSettings.networkLocationStatus":{"venonaKey":"networkLocationStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["notPresent","notUsable","usable"]}]}},"visit.previousVisitId":{"venonaKey":"previousVisitId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.screenResolution":{"venonaKey":"screenResolution","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings":{"venonaKey":"settings","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings.appliedConfigs":{"venonaKey":"appliedConfigs","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings.previousVisitQueuedMessageCount":{"venonaKey":"previousVisitQueuedMessageCount","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings.previousVisitRejectedMessageCount":{"venonaKey":"previousVisitRejectedMessageCount","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings.privateAppliedConfigs":{"venonaKey":"privateAppliedConfigs","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.settings.reinitVersion":{"venonaKey":"reinitVersion","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.thirdPartyAccess.requesterId":{"venonaKey":"requesterId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["TVGo"]}],"value":true},{"value":false}]}},"visit.thirdPartyAccess.resourceId":{"venonaKey":"resourceId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["TVGo"]}],"value":true},{"value":false}]}},"visit.visitId":{"venonaKey":"visitId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"temporaryView":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}},"userConfigSet":{"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountBillingDivision":{"venonaKey":"accountBillingDivision","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountBillingDivisionId":{"venonaKey":"accountBillingDivisionId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountBillingId":{"venonaKey":"accountBillingId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountCompany":{"venonaKey":"accountCompany","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountFeatures.accessibility":{"venonaKey":"accessibility","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationType":["OVP"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationName":["SpectrumLocal","RegionalSportsNetwork","Hawaii"],"visit.applicationDetails.applicationType":["Android","iOS","Web"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationName":["OneApp"],"visit.applicationDetails.applicationType":["Chromecast"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationName":["RTDashboard","SpecNet","SMB","MySpectrum","SpecMobile"]}],"value":false},{"value":true}]}},"visit.account.accountFranchise":{"venonaKey":"accountFranchise","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountGUID":{"venonaKey":"accountGUID","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.accountNumber":{"venonaKey":"accountNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"!visit.login.oauthExpirationTimestamp":["anullValue"],"!visit.applicationDetails.environment.environmentName":["sita","sitb","dev","staging"]}],"value":true},{"condition":[{"!visit.applicationDetails.applicationName":["MySpectrum"]}],"value":true},{"value":false}]}},"visit.account.accountSiteId":{"venonaKey":"accountSiteId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.clientLocationNumber":{"venonaKey":"clientLocationNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.configurationFactors":{"venonaKey":"configurationFactors","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.billingServices":{"venonaKey":"accountDetailsBillServices","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["sps","legacy","unknown"]}]}},"visit.account.details.bulkMduClass":{"venonaKey":"bulkMduClass","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["BulkMdu"],"visit.applicationDetails.applicationType":["Android","iOS","OVP"]}],"value":true},{"value":false}]}},"visit.account.details.mso":{"venonaKey":"mso","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions":{"venonaKey":"serviceSubscriptions","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.customerType":{"venonaKey":"serviceSubscriptionsCustType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.internet":{"venonaKey":"serviceSubscriptionsInternet","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.mobile":{"venonaKey":"serviceSubscriptionsMobile","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.multiAp":{"venonaKey":"serviceSubscriptionsMultiAP","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.scp":{"venonaKey":"serviceSubscriptionsSCP","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.secureConnect":{"venonaKey":"serviceSubscriptionsSecureConnect","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.tv":{"venonaKey":"serviceSubscriptionsTv","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.voice":{"venonaKey":"serviceSubscriptionsVoice","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.serviceSubscriptions.wifi":{"venonaKey":"serviceSubscriptionsWifi","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.details.softDisconnectDate":{"venonaKey":"softDisconnectDate","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.entitlements":{"venonaKey":"entitlements","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["OneApp"],"visit.applicationDetails.applicationType":["Chromecast"]}],"value":false},{"value":false}]}},"visit.account.mobileServiceStatus":{"venonaKey":"mobileServiceStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["INACTIVE","ACTIVE","PR","AC","TD","DA","NA","HL"]}]}},"visit.account.paymentRestrictions":{"venonaKey":"paymentRestrictions","validationRules":{"type":[{"value":"map"}],"elementType":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.soloLocationNumber":{"venonaKey":"soloLocationNumber","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.systemAgent":{"venonaKey":"systemAgent","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.systemPrin":{"venonaKey":"systemPrin","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.systemSys":{"venonaKey":"systemSys","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.account.timeZone":{"venonaKey":"timeZone","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["RTDashboard","SpecNet","SMB","MySpectrum","SpecMobile"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationName":["SpectrumLocal","RegionalSportsNetwork"],"visit.applicationDetails.applicationType":["iOS","Android"]}],"value":true},{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.connection.deviceLocation":{"venonaKey":"connectionDeviceLocation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["inMarket","outOfMarket","inHome","unknown"]}]}},"visit.connection.networkStatus":{"venonaKey":"networkStatus","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"visit.applicationDetails.applicationName":["SpectrumLocal","RegionalSportsNetwork"],"visit.applicationDetails.applicationType":["iOS","Android"]}],"value":false},{"condition":[{"visit.applicationDetails.applicationName":["RTDashboard","SpecNet","SMB","MySpectrum","SpecMobile"]}],"value":false},{"value":true}],"restrictedTo":[{"value":["onNet","offNet","unknown"]}]}},"visit.device.powerState":{"venonaKey":"powerState","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.endDate":{"venonaKey":"promoEndDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.offerId":{"venonaKey":"offerId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.promoId":{"venonaKey":"promoId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.promoType":{"venonaKey":"promoType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.promotion.startDate":{"venonaKey":"promoStartDate","validationRules":{"type":[{"value":"long"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.user.role":{"venonaKey":"userRole","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["primary","admin","standard","customerFormer","customerCurrent","customerNever","secondaryAdmin","user"]}]}}},"userFeedback":{"message.context":{"venonaKey":"context","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.eventCaseId":{"venonaKey":"eventCaseId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"message.feature.featureName":{"venonaKey":"featureName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"message.feature.featureStepName":{"venonaKey":"featureStepName","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"condition":[{"message.context":["buyFlow2"]}],"value":true},{"value":false}]}},"message.feature.featureType":{"venonaKey":"featureType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"condition":[{"message.context":["buyFlow"]}],"value":true},{"value":false}]}},"operation.additionalInformation":{"venonaKey":"additionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.success":{"venonaKey":"success","validationRules":{"type":[{"value":"boolean"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.category":{"venonaKey":"entryCategory","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.entryType":{"venonaKey":"entryType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["username","ccSettingsText","ccSettingsTextTransparency","ccSettingsFont","ccSettingsFontSize","ccSettingsFontEdge","ccSettingsBackground","ccSettingsBackgroundTransparency","ccSettingsWindow","ccSettingsWindowTransparency","chatActivity","feedbackForm","equipmentSelfInstall"]}]}},"operation.userEntry.feedback":{"venonaKey":"userFeedback","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.feedbackId":{"venonaKey":"feedbackId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.feedbackTarget":{"venonaKey":"feedbackTarget","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.numeric":{"venonaKey":"entryNumeric","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.questionId":{"venonaKey":"questionId","validationRules":{"type":[{"value":"int"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.questionType":{"venonaKey":"questionType","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}],"restrictedTo":[{"value":["csat","successRate","nps","ces","starRating"]}]}},"operation.userEntry.strValue":{"venonaKey":"entryStrValue","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.surveyId":{"venonaKey":"surveyId","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"operation.userEntry.text":{"venonaKey":"entryText","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}},"visit.additionalInformation":{"venonaKey":"visitAdditionalInformation","validationRules":{"type":[{"value":"string"}],"allowed":[{"value":true}],"required":[{"value":false}]}}}},"fields":{"apiCall":["application.api","message","operation.additionalInformation","operation.success","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"applicationActivity":["message","operation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"applicationPerformance":["message","operation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"assetDisplayed":["message","operation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"connectionChange":["message","operation.additionalInformation","operation.operationType","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"customEvent":["custom","message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"deeplinkStart":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"deeplinkStop":["application.error","message","operation.additionalInformation","operation.success","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"deviceConfigSet":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"error":["application","message","operation.additionalInformation","operation.success","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"featureStart":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"featureStop":["application.error","message","operation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"impressionStart":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.impression","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"impressionStop":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.impression","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"inVisitOauthRefresh":["application.error","message","operation.additionalInformation","operation.operationType","operation.success","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"loginStart":["message","operation.additionalInformation","operation.operationType","operation.userEntry.entryType","operation.userEntry.text","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"loginStop":["application.error","message","operation.additionalInformation","operation.operationType","operation.success","operation.userEntry.entryType","operation.userEntry.text","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"logout":["message","operation.additionalInformation","operation.operationType","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"modalCancel":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"modalClose":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"modalView":["application.error","message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"pageView":["application.error","message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view"],"pageViewPerformance":["message","operation.additionalInformation","operation.operationType","performance","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view"],"purchaseStart":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"purchaseStop":["application.error","message","operation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"pushNotification":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"searchClosed":["message","operation.additionalInformation","operation.operationType","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.search","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"searched":["message","operation.additionalInformation","operation.operationType","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.search","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"selectAction":["message","operation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.search","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"startSession":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"temporaryView":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"userConfigSet":["message","operation.additionalInformation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"],"userFeedback":["message","operation","state.activeStates","state.currentVideoPosition","state.entryTimestamp","state.entryVideoPosition","state.name","state.previousState","state.referrer","state.view.currentPage.additionalInformation","state.view.currentPage.appSection","state.view.currentPage.billerType","state.view.currentPage.billing","state.view.currentPage.campaign","state.view.currentPage.childMarket","state.view.currentPage.components","state.view.currentPage.currentBalanceAmount","state.view.currentPage.elements","state.view.currentPage.orders","state.view.currentPage.pageDisplayType","state.view.currentPage.pageId","state.view.currentPage.pageName","state.view.currentPage.pageSection","state.view.currentPage.pageSequenceNumber","state.view.currentPage.pageSubSection","state.view.currentPage.pageTitle","state.view.currentPage.pageType","state.view.currentPage.pageUrl","state.view.currentPage.pageViewType","state.view.currentPage.parentMarket","state.view.currentPage.pastDueAmount","state.view.currentPage.renderDetails","state.view.currentPage.sortAndFilter","state.view.currentPage.temporaryViewedTimeMs","state.view.currentPage.totalAmountDue","state.view.currentPage.uiResponsiveBreakpoint","state.view.currentPage.userSubJourney","state.view.device","state.view.mirroring","state.view.modal","state.view.previousPage"]},"blacklists":{"password":["\\\\\\\\?\\"?password\\\\\\\\?\\"?\\\\s*:"],"sensitive":["\\\\\\\\?\\"?operation.userEntry.text\\\\\\\\?\\"?\\\\s*:","\\\\\\\\?\\"?visit.account.accountNumber\\\\\\\\?\\"?\\\\s*:","\\\\\\\\?\\"?visit.device.uuid\\\\\\\\?\\"?\\\\s*:","\\\\\\\\?\\"?visit.account.accountBillingId\\\\\\\\?\\"?\\\\s*:"]},"errorCodes":{"internal":{"generic":"AN-2000","specsFetch":"AN-2001","specsParse":"AN-2002","eventBeforeInit":"AN-2003","rateLimit":"AN-2004","intenalTrackMethod":"AN-2005","badBitrate":"AN-2006","noStreamId":"AN-2007"},"state":{"playback":{"default":"AN-2500"},"ads":{"default":"AN-2500"},"login":{"default":"AN-2300"},"default":"AN-2100"},"application":{"generic":"AN-2800","missingProgramData":"AN-2801"}},"persistenceRules":{"after":{"any":["application","operation","performance","custom","message","state.view.currentPage.navigation","state.view.currentPage.elements","state.view.currentPage.pageSection","state.view.currentPage.pageSubSection"],"logout":["visit.account","visit.login","visit.promotion","visit.settings.privateAppliedConfigs","visit.connection.deviceLocation"],"searchClosed":["state.search"],"deeplinkStop":["state.referrer.instanceLink","state.referrer.instanceLocation"],"modalClose":["state.view.modal"],"selectContent":["state.search.selectedResultName","state.search.selectedResultFacet"]}}}');
    }, function (e, t, a) {
      e.exports = a(63);
    }, function (e, t, a) {
      var r = a(135).default;
      e.exports = r;
    }, function (e, t) {
      function a(t, r) {
        return e.exports = a = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        }, a(t, r);
      }

      e.exports = a;
    }, function (e, t) {
      e.exports = function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      };
    }, function (e, t, a) {
      var r = function (e) {
        "use strict";

        var t = Object.prototype,
            a = t.hasOwnProperty,
            r = "function" == typeof Symbol ? Symbol : {},
            i = r.iterator || "@@iterator",
            n = r.asyncIterator || "@@asyncIterator",
            o = r.toStringTag || "@@toStringTag";

        function s(e, t, a) {
          return Object.defineProperty(e, t, {
            value: a,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }), e[t];
        }

        try {
          s({}, "");
        } catch (e) {
          s = function s(e, t, a) {
            return e[t] = a;
          };
        }

        function l(e, t, a, r) {
          var i = t && t.prototype instanceof v ? t : v,
              n = Object.create(i.prototype),
              o = new S(r || []);
          return n._invoke = function (e, t, a) {
            var r = "suspendedStart";
            return function (i, n) {
              if ("executing" === r) throw new Error("Generator is already running");

              if ("completed" === r) {
                if ("throw" === i) throw n;
                return {
                  value: void 0,
                  done: !0
                };
              }

              for (a.method = i, a.arg = n;;) {
                var o = a.delegate;

                if (o) {
                  var s = b(o, a);

                  if (s) {
                    if (s === c) continue;
                    return s;
                  }
                }

                if ("next" === a.method) a.sent = a._sent = a.arg;else if ("throw" === a.method) {
                  if ("suspendedStart" === r) throw r = "completed", a.arg;
                  a.dispatchException(a.arg);
                } else "return" === a.method && a.abrupt("return", a.arg);
                r = "executing";
                var l = u(e, t, a);

                if ("normal" === l.type) {
                  if (r = a.done ? "completed" : "suspendedYield", l.arg === c) continue;
                  return {
                    value: l.arg,
                    done: a.done
                  };
                }

                "throw" === l.type && (r = "completed", a.method = "throw", a.arg = l.arg);
              }
            };
          }(e, a, o), n;
        }

        function u(e, t, a) {
          try {
            return {
              type: "normal",
              arg: e.call(t, a)
            };
          } catch (e) {
            return {
              type: "throw",
              arg: e
            };
          }
        }

        e.wrap = l;
        var c = {};

        function v() {}

        function p() {}

        function d() {}

        var g = {};

        g[i] = function () {
          return this;
        };

        var y = Object.getPrototypeOf,
            f = y && y(y(k([])));
        f && f !== t && a.call(f, i) && (g = f);
        var m = d.prototype = v.prototype = Object.create(g);

        function w(e) {
          ["next", "throw", "return"].forEach(function (t) {
            s(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }

        function h(e, t) {
          var r;

          this._invoke = function (i, n) {
            function o() {
              return new t(function (r, o) {
                !function r(i, n, o, s) {
                  var l = u(e[i], e, n);

                  if ("throw" !== l.type) {
                    var c = l.arg,
                        v = c.value;
                    return v && "object" == typeof v && a.call(v, "__await") ? t.resolve(v.__await).then(function (e) {
                      r("next", e, o, s);
                    }, function (e) {
                      r("throw", e, o, s);
                    }) : t.resolve(v).then(function (e) {
                      c.value = e, o(c);
                    }, function (e) {
                      return r("throw", e, o, s);
                    });
                  }

                  s(l.arg);
                }(i, n, r, o);
              });
            }

            return r = r ? r.then(o, o) : o();
          };
        }

        function b(e, t) {
          var a = e.iterator[t.method];

          if (void 0 === a) {
            if (t.delegate = null, "throw" === t.method) {
              if (e.iterator.return && (t.method = "return", t.arg = void 0, b(e, t), "throw" === t.method)) return c;
              t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return c;
          }

          var r = u(a, e.iterator, t.arg);
          if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, c;
          var i = r.arg;
          return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, c) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, c);
        }

        function P(e) {
          var t = {
            tryLoc: e[0]
          };
          1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
        }

        function T(e) {
          var t = e.completion || {};
          t.type = "normal", delete t.arg, e.completion = t;
        }

        function S(e) {
          this.tryEntries = [{
            tryLoc: "root"
          }], e.forEach(P, this), this.reset(!0);
        }

        function k(e) {
          if (e) {
            var t = e[i];
            if (t) return t.call(e);
            if ("function" == typeof e.next) return e;

            if (!isNaN(e.length)) {
              var r = -1,
                  n = function t() {
                for (; ++r < e.length;) {
                  if (a.call(e, r)) return t.value = e[r], t.done = !1, t;
                }

                return t.value = void 0, t.done = !0, t;
              };

              return n.next = n;
            }
          }

          return {
            next: R
          };
        }

        function R() {
          return {
            value: void 0,
            done: !0
          };
        }

        return p.prototype = m.constructor = d, d.constructor = p, p.displayName = s(d, o, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
          var t = "function" == typeof e && e.constructor;
          return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
        }, e.mark = function (e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, d) : (e.__proto__ = d, s(e, o, "GeneratorFunction")), e.prototype = Object.create(m), e;
        }, e.awrap = function (e) {
          return {
            __await: e
          };
        }, w(h.prototype), h.prototype[n] = function () {
          return this;
        }, e.AsyncIterator = h, e.async = function (t, a, r, i, n) {
          void 0 === n && (n = Promise);
          var o = new h(l(t, a, r, i), n);
          return e.isGeneratorFunction(a) ? o : o.next().then(function (e) {
            return e.done ? e.value : o.next();
          });
        }, w(m), s(m, o, "Generator"), m[i] = function () {
          return this;
        }, m.toString = function () {
          return "[object Generator]";
        }, e.keys = function (e) {
          var t = [];

          for (var a in e) {
            t.push(a);
          }

          return t.reverse(), function a() {
            for (; t.length;) {
              var r = t.pop();
              if (r in e) return a.value = r, a.done = !1, a;
            }

            return a.done = !0, a;
          };
        }, e.values = k, S.prototype = {
          constructor: S,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(T), !e) for (var t in this) {
              "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
            }
          },
          stop: function stop() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var t = this;

            function r(a, r) {
              return o.type = "throw", o.arg = e, t.next = a, r && (t.method = "next", t.arg = void 0), !!r;
            }

            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var n = this.tryEntries[i],
                  o = n.completion;
              if ("root" === n.tryLoc) return r("end");

              if (n.tryLoc <= this.prev) {
                var s = a.call(n, "catchLoc"),
                    l = a.call(n, "finallyLoc");

                if (s && l) {
                  if (this.prev < n.catchLoc) return r(n.catchLoc, !0);
                  if (this.prev < n.finallyLoc) return r(n.finallyLoc);
                } else if (s) {
                  if (this.prev < n.catchLoc) return r(n.catchLoc, !0);
                } else {
                  if (!l) throw new Error("try statement without catch or finally");
                  if (this.prev < n.finallyLoc) return r(n.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(e, t) {
            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var i = this.tryEntries[r];

              if (i.tryLoc <= this.prev && a.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                var n = i;
                break;
              }
            }

            n && ("break" === e || "continue" === e) && n.tryLoc <= t && t <= n.finallyLoc && (n = null);
            var o = n ? n.completion : {};
            return o.type = e, o.arg = t, n ? (this.method = "next", this.next = n.finallyLoc, c) : this.complete(o);
          },
          complete: function complete(e, t) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), c;
          },
          finish: function finish(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var a = this.tryEntries[t];
              if (a.finallyLoc === e) return this.complete(a.completion, a.afterLoc), T(a), c;
            }
          },
          catch: function _catch(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var a = this.tryEntries[t];

              if (a.tryLoc === e) {
                var r = a.completion;

                if ("throw" === r.type) {
                  var i = r.arg;
                  T(a);
                }

                return i;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, t, a) {
            return this.delegate = {
              iterator: k(e),
              resultName: t,
              nextLoc: a
            }, "next" === this.method && (this.arg = void 0), c;
          }
        }, e;
      }(e.exports);

      try {
        regeneratorRuntime = r;
      } catch (e) {
        Function("r", "regeneratorRuntime = r")(r);
      }
    }, function (e, t, a) {
      var r = a(34),
          i = a(73),
          n = a(21),
          o = a(76),
          s = a(77),
          l = a(36),
          u = a(26),
          c = a(81),
          v = a(83),
          p = a(85),
          d = a(37),
          g = a(86),
          y = a(87),
          f = a(88),
          m = a(38),
          w = a(10),
          h = a(40),
          b = a(91),
          P = a(13),
          T = a(92),
          S = a(35),
          k = {};
      k["[object Arguments]"] = k["[object Array]"] = k["[object ArrayBuffer]"] = k["[object DataView]"] = k["[object Boolean]"] = k["[object Date]"] = k["[object Float32Array]"] = k["[object Float64Array]"] = k["[object Int8Array]"] = k["[object Int16Array]"] = k["[object Int32Array]"] = k["[object Map]"] = k["[object Number]"] = k["[object Object]"] = k["[object RegExp]"] = k["[object Set]"] = k["[object String]"] = k["[object Symbol]"] = k["[object Uint8Array]"] = k["[object Uint8ClampedArray]"] = k["[object Uint16Array]"] = k["[object Uint32Array]"] = !0, k["[object Error]"] = k["[object Function]"] = k["[object WeakMap]"] = !1, e.exports = function e(t, a, R, E, q, O) {
        var I,
            x = 1 & a,
            A = 2 & a,
            C = 4 & a;
        if (R && (I = q ? R(t, E, q, O) : R(t)), void 0 !== I) return I;
        if (!P(t)) return t;
        var D = w(t);

        if (D) {
          if (I = y(t), !x) return u(t, I);
        } else {
          var K = g(t),
              N = "[object Function]" == K || "[object GeneratorFunction]" == K;
          if (h(t)) return l(t, x);

          if ("[object Object]" == K || "[object Arguments]" == K || N && !q) {
            if (I = A || N ? {} : m(t), !x) return A ? v(t, s(I, t)) : c(t, o(I, t));
          } else {
            if (!k[K]) return q ? t : {};
            I = f(t, K, x);
          }
        }

        O || (O = new r());
        var V = O.get(t);
        if (V) return V;
        O.set(t, I), T(t) ? t.forEach(function (r) {
          I.add(e(r, a, R, r, t, O));
        }) : b(t) && t.forEach(function (r, i) {
          I.set(i, e(r, a, R, i, t, O));
        });
        var F = C ? A ? d : p : A ? keysIn : S,
            M = D ? void 0 : F(t);
        return i(M || t, function (r, i) {
          M && (r = t[i = r]), n(I, i, e(r, a, R, i, t, O));
        }), I;
      };
    }, function (e, t) {
      e.exports = function () {
        this.__data__ = [], this.size = 0;
      };
    }, function (e, t, a) {
      var r = a(17),
          i = Array.prototype.splice;

      e.exports = function (e) {
        var t = this.__data__,
            a = r(t, e);
        return !(a < 0 || (a == t.length - 1 ? t.pop() : i.call(t, a, 1), --this.size, 0));
      };
    }, function (e, t, a) {
      var r = a(17);

      e.exports = function (e) {
        var t = this.__data__,
            a = r(t, e);
        return a < 0 ? void 0 : t[a][1];
      };
    }, function (e, t, a) {
      var r = a(17);

      e.exports = function (e) {
        return r(this.__data__, e) > -1;
      };
    }, function (e, t, a) {
      var r = a(17);

      e.exports = function (e, t) {
        var a = this.__data__,
            i = r(a, e);
        return i < 0 ? (++this.size, a.push([e, t])) : a[i][1] = t, this;
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        for (var a = -1, r = null == e ? 0 : e.length; ++a < r && !1 !== t(e[a], a, e);) {
          ;
        }

        return e;
      };
    }, function (e, t, a) {
      var r = a(75),
          i = function () {
        try {
          var e = r(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch (e) {}
      }();

      e.exports = i;
    }, function (e, t) {
      e.exports = function (e, t) {
        return null == e ? void 0 : e[t];
      };
    }, function (e, t, a) {
      var r = a(14),
          i = a(35);

      e.exports = function (e, t) {
        return e && r(t, i(t), e);
      };
    }, function (e, t, a) {
      var r = a(14),
          i = a(24);

      e.exports = function (e, t) {
        return e && r(t, i(t), e);
      };
    }, function (e, t) {
      e.exports = function (e) {
        return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function get() {
            return e.l;
          }
        }), Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function get() {
            return e.i;
          }
        }), e.webpackPolyfill = 1), e;
      };
    }, function (e, t, a) {
      (function (t) {
        var a = "object" == typeof t && t && t.Object === Object && t;
        e.exports = a;
      }).call(this, a(80));
    }, function (e, t) {
      var a;

      a = function () {
        return this;
      }();

      try {
        a = a || new Function("return this")();
      } catch (e) {
        "object" == typeof window && (a = window);
      }

      e.exports = a;
    }, function (e, t, a) {
      var r = a(14),
          i = a(82);

      e.exports = function (e, t) {
        return r(e, i(e), t);
      };
    }, function (e, t) {
      e.exports = function () {
        return [];
      };
    }, function (e, t, a) {
      var r = a(14),
          i = a(84);

      e.exports = function (e, t) {
        return r(e, i(e), t);
      };
    }, function (e, t) {
      e.exports = function () {
        return [];
      };
    }, function (e, t, a) {
      var r = a(23)(Object.keys, Object);
      e.exports = r;
    }, function (e, t) {
      var a = Object.prototype.toString;

      e.exports = function (e) {
        return a.call(e);
      };
    }, function (e, t) {
      var a = Object.prototype.hasOwnProperty;

      e.exports = function (e) {
        var t = e.length,
            r = new e.constructor(t);
        return t && "string" == typeof e[0] && a.call(e, "index") && (r.index = e.index, r.input = e.input), r;
      };
    }, function (e, t) {
      e.exports = function (e) {
        return e;
      };
    }, function (e, t, a) {
      var r = a(13),
          i = Object.create,
          n = function () {
        function e() {}

        return function (t) {
          if (!r(t)) return {};
          if (i) return i(t);
          e.prototype = t;
          var a = new e();
          return e.prototype = void 0, a;
        };
      }();

      e.exports = n;
    }, function (e, t) {
      e.exports = function () {
        return !1;
      };
    }, function (e, t) {
      e.exports = function () {
        return !1;
      };
    }, function (e, t) {
      e.exports = function () {
        return !1;
      };
    }, function (e, t, a) {
      var r = a(94),
          i = a(95),
          n = a(96),
          o = a(28),
          s = a(41),
          l = a(97);

      e.exports = function (e, t, a, u) {
        var c = -1,
            v = i,
            p = !0,
            d = e.length,
            g = [],
            y = t.length;
        if (!d) return g;
        a && (t = o(t, s(a))), u ? (v = n, p = !1) : t.length >= 200 && (v = l, p = !1, t = new r(t));

        e: for (; ++c < d;) {
          var f = e[c],
              m = null == a ? f : a(f);

          if (f = u || 0 !== f ? f : 0, p && m == m) {
            for (var w = y; w--;) {
              if (t[w] === m) continue e;
            }

            g.push(f);
          } else v(t, m, u) || g.push(f);
        }

        return g;
      };
    }, function (e, t, a) {
      var r = a(10);

      e.exports = function () {
        if (!arguments.length) return [];
        var e = arguments[0];
        return r(e) ? e : [e];
      };
    }, function (e, t, a) {
      var r = a(27);

      e.exports = function (e, t) {
        return !(null == e || !e.length) && r(e, t, 0) > -1;
      };
    }, function (e, t) {
      e.exports = function (e, t, a) {
        for (var r = -1, i = null == e ? 0 : e.length; ++r < i;) {
          if (a(t, e[r])) return !0;
        }

        return !1;
      };
    }, function (e, t, a) {
      var r = a(27);

      e.exports = function (e, t) {
        return !(null == e || !e.length) && r(e, t, 0) > -1;
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        for (var a = -1, r = t.length, i = e.length; ++a < r;) {
          e[i + a] = t[a];
        }

        return e;
      };
    }, function (e, t, a) {
      var r = a(100),
          i = a(29),
          n = a(10),
          o = r ? r.isConcatSpreadable : void 0;

      e.exports = function (e) {
        return n(e) || i(e) || !!(o && e && e[o]);
      };
    }, function (e, t, a) {
      var r = a(25).Symbol;
      e.exports = r;
    }, function (e, t) {
      e.exports = function (e) {
        return e;
      };
    }, function (e, t) {
      e.exports = function (e, t, a) {
        switch (a.length) {
          case 0:
            return e.call(t);

          case 1:
            return e.call(t, a[0]);

          case 2:
            return e.call(t, a[0], a[1]);

          case 3:
            return e.call(t, a[0], a[1], a[2]);
        }

        return e.apply(t, a);
      };
    }, function (e, t, a) {
      var r = a(46),
          i = a(48);

      e.exports = function (e) {
        return null != e && i(e.length) && !r(e);
      };
    }, function (e, t, a) {
      var r = a(10),
          i = a(105),
          n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
          o = /^\w*$/;

      e.exports = function (e, t) {
        if (r(e)) return !1;
        var a = typeof e;
        return !("number" != a && "symbol" != a && "boolean" != a && null != e && !i(e)) || o.test(e) || !n.test(e) || null != t && e in Object(t);
      };
    }, function (e, t) {
      e.exports = function () {
        return !1;
      };
    }, function (e, t, a) {
      var r = a(107),
          i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
          n = /\\(\\)?/g,
          o = r(function (e) {
        var t = [];
        return 46 === e.charCodeAt(0) && t.push(""), e.replace(i, function (e, a, r, i) {
          t.push(r ? i.replace(n, "$1") : a || e);
        }), t;
      });
      e.exports = o;
    }, function (e, t) {
      e.exports = function (e) {
        return e;
      };
    }, function (e, t) {
      e.exports = function (e) {
        return e;
      };
    }, function (e, t) {
      e.exports = function (e) {
        return e;
      };
    }, function (e, t, a) {
      var r = a(53),
          i = a(111);

      e.exports = function (e, t) {
        return r(e, t, function (t, a) {
          return i(e, a);
        });
      };
    }, function (e, t, a) {
      var r = a(112),
          i = a(113);

      e.exports = function (e, t) {
        return null != e && i(e, t, r);
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        return null != e && t in Object(e);
      };
    }, function (e, t, a) {
      var r = a(18),
          i = a(29),
          n = a(10),
          o = a(51),
          s = a(48),
          l = a(31);

      e.exports = function (e, t, a) {
        for (var u = -1, c = (t = r(t, e)).length, v = !1; ++u < c;) {
          var p = l(t[u]);
          if (!(v = null != e && a(e, p))) break;
          e = e[p];
        }

        return v || ++u != c ? v : !!(c = null == e ? 0 : e.length) && s(c) && o(p, c) && (n(e) || i(e));
      };
    }, function (e, t, a) {
      var r = a(115),
          i = a(43),
          n = a(44);

      e.exports = function (e) {
        return n(i(e, void 0, r), e + "");
      };
    }, function (e, t, a) {
      var r = a(42);

      e.exports = function (e) {
        return null != e && e.length ? r(e, 1) : [];
      };
    }, function (e, t) {
      e.exports = function (e) {
        if (Array.isArray(e)) return e;
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var a = [],
              r = !0,
              i = !1,
              n = void 0;

          try {
            for (var o, s = e[Symbol.iterator](); !(r = (o = s.next()).done) && (a.push(o.value), !t || a.length !== t); r = !0) {
              ;
            }
          } catch (e) {
            i = !0, n = e;
          } finally {
            try {
              r || null == s.return || s.return();
            } finally {
              if (i) throw n;
            }
          }

          return a;
        }
      };
    }, function (e, t, a) {
      var r = a(119);

      e.exports = function (e, t) {
        if (e) {
          if ("string" == typeof e) return r(e, t);
          var a = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? r(e, t) : void 0;
        }
      };
    }, function (e, t) {
      e.exports = function (e, t) {
        (null == t || t > e.length) && (t = e.length);

        for (var a = 0, r = new Array(t); a < t; a++) {
          r[a] = e[a];
        }

        return r;
      };
    }, function (e, t) {
      e.exports = function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      };
    }, function (e, t, a) {
      var r = a(122);

      e.exports = function (e, t) {
        return e && e.length && t && t.length ? r(e, t) : e;
      };
    }, function (e, t, a) {
      var r = a(28),
          i = a(27),
          n = a(123),
          o = a(41),
          s = a(26),
          l = Array.prototype.splice;

      e.exports = function (e, t, a, u) {
        var c = u ? n : i,
            v = -1,
            p = t.length,
            d = e;

        for (e === t && (t = s(t)), a && (d = r(e, o(a))); ++v < p;) {
          for (var g = 0, y = t[v], f = a ? a(y) : y; (g = c(d, f, g, u)) > -1;) {
            d !== e && l.call(d, g, 1), l.call(e, g, 1);
          }
        }

        return e;
      };
    }, function (e, t) {
      e.exports = function (e, t, a, r) {
        for (var i = a - 1, n = e.length; ++i < n;) {
          if (r(e[i], t)) return i;
        }

        return -1;
      };
    }, function (e, t, a) {
      var r = a(34),
          i = a(54),
          n = a(125),
          o = a(127),
          s = a(13),
          l = a(24),
          u = a(55);

      e.exports = function e(t, a, c, v, p) {
        t !== a && n(a, function (n, l) {
          if (p || (p = new r()), s(n)) o(t, a, l, c, e, v, p);else {
            var d = v ? v(u(t, l), n, l + "", t, a, p) : void 0;
            void 0 === d && (d = n), i(t, l, d);
          }
        }, l);
      };
    }, function (e, t, a) {
      var r = a(126)();
      e.exports = r;
    }, function (e, t) {
      e.exports = function (e) {
        return function (t, a, r) {
          for (var i = -1, n = Object(t), o = r(t), s = o.length; s--;) {
            var l = o[e ? s : ++i];
            if (!1 === a(n[l], l, n)) break;
          }

          return t;
        };
      };
    }, function (e, t, a) {
      var r = a(54),
          i = a(36),
          n = a(128),
          o = a(26),
          s = a(38),
          l = a(29),
          u = a(10),
          c = a(45),
          v = a(40),
          p = a(46),
          d = a(13),
          g = a(6),
          y = a(131),
          f = a(55),
          m = a(132);

      e.exports = function (e, t, a, w, h, b, P) {
        var T = f(e, a),
            S = f(t, a),
            k = P.get(S);
        if (k) r(e, a, k);else {
          var R = b ? b(T, S, a + "", e, t, P) : void 0,
              E = void 0 === R;

          if (E) {
            var q = u(S),
                O = !q && v(S),
                I = !q && !O && y(S);
            R = S, q || O || I ? u(T) ? R = T : c(T) ? R = o(T) : O ? (E = !1, R = i(S, !0)) : I ? (E = !1, R = n(S, !0)) : R = [] : g(S) || l(S) ? (R = T, l(T) ? R = m(T) : d(T) && !p(T) || (R = s(S))) : E = !1;
          }

          E && (P.set(S, R), h(R, S, w, b, P), P.delete(S)), r(e, a, R);
        }
      };
    }, function (e, t, a) {
      var r = a(129);

      e.exports = function (e, t) {
        var a = t ? r(e.buffer) : e.buffer;
        return new e.constructor(a, e.byteOffset, e.length);
      };
    }, function (e, t, a) {
      var r = a(130);

      e.exports = function (e) {
        var t = new e.constructor(e.byteLength);
        return new r(t).set(new r(e)), t;
      };
    }, function (e, t, a) {
      var r = a(25).Uint8Array;
      e.exports = r;
    }, function (e, t) {
      e.exports = function () {
        return !1;
      };
    }, function (e, t, a) {
      var r = a(14),
          i = a(24);

      e.exports = function (e) {
        return r(e, i(e));
      };
    }, function (e, t, a) {
      var r = a(30),
          i = a(134);

      e.exports = function (e) {
        return r(function (t, a) {
          var r = -1,
              n = a.length,
              o = n > 1 ? a[n - 1] : void 0,
              s = n > 2 ? a[2] : void 0;

          for (o = e.length > 3 && "function" == typeof o ? (n--, o) : void 0, s && i(a[0], a[1], s) && (o = n < 3 ? void 0 : o, n = 1), t = Object(t); ++r < n;) {
            var l = a[r];
            l && e(t, l, r, o);
          }

          return t;
        });
      };
    }, function (e, t) {
      e.exports = function () {
        return !1;
      };
    }, function (e, t, a) {
      "use strict";

      a.r(t);
      var r = {};
      a.r(r), a.d(r, "onBeforeEvent", function () {
        return qe;
      }), a.d(r, "onAfterEvent", function () {
        return Oe;
      }), a.d(r, "onBeforePlaybackSelect", function () {
        return Ie;
      }), a.d(r, "onBeforePlaybackStreamUriAcquired", function () {
        return xe;
      }), a.d(r, "onBeforePlaybackStart", function () {
        return Ae;
      }), a.d(r, "onAfterPlaybackStart", function () {
        return Ce;
      }), a.d(r, "onBeforePlaybackStartAfterRetry", function () {
        return De;
      }), a.d(r, "onBeforePlaybackStop", function () {
        return Ke;
      }), a.d(r, "onBeforePlaybackExitBeforeStart", function () {
        return Ne;
      }), a.d(r, "onBeforeBufferingStart", function () {
        return Ve;
      }), a.d(r, "onBeforeBufferingStop", function () {
        return Fe;
      }), a.d(r, "onBeforePlaybackUnpause", function () {
        return Me;
      }), a.d(r, "onBeforePlaybackTrickPlayRateChange", function () {
        return je;
      }), a.d(r, "onBeforePlaybackTrickPlayStop", function () {
        return Be;
      }), a.d(r, "onBeforePlaybackBitRateChange", function () {
        return Le;
      }), a.d(r, "onBeforePlaybackFailure", function () {
        return Ue;
      }), a.d(r, "onAfterPlaybackFailure", function () {
        return _e;
      }), a.d(r, "onBeforePlaybackFailureBeforeRetry", function () {
        return Ge;
      }), a.d(r, "onBeforeAttemptRestart", function () {
        return He;
      }), a.d(r, "onBeforeTick", function () {
        return ze;
      });
      var i = {};
      a.r(i), a.d(i, "onBeforeApiCall", function () {
        return it;
      });
      var n = {};
      a.r(n), a.d(n, "onBeforeError", function () {
        return nt;
      }), a.d(n, "onBeforeApplicationCrash", function () {
        return ot;
      });
      var o = {};
      a.r(o), a.d(o, "onBeforeEvent", function () {
        return ut;
      }), a.d(o, "onChangeState", function () {
        return ct;
      }), a.d(o, "onAfterEvent", function () {
        return vt;
      }), a.d(o, "onBeforeCustomEvent", function () {
        return pt;
      }), a.d(o, "onInvalidEvent", function () {
        return dt;
      }), a.d(o, "onEventBeforeInit", function () {
        return gt;
      });
      var s = {};
      a.r(s), a.d(s, "onBeforeLoginStart", function () {
        return mt;
      }), a.d(s, "onBeforeLoginStop", function () {
        return wt;
      }), a.d(s, "onAfterLoginStop", function () {
        return ht;
      }), a.d(s, "onBeforeInVisitOauthRefresh", function () {
        return bt;
      }), a.d(s, "onBeforeLogout", function () {
        return Pt;
      }), a.d(s, "onAfterLogout", function () {
        return Tt;
      });
      var l = {};
      a.r(l), a.d(l, "onBeforePageViewInit", function () {
        return kt;
      }), a.d(l, "onBeforePageViewCompleteAwaitingAction", function () {
        return Rt;
      }), a.d(l, "onBeforeTemporaryView", function () {
        return Et;
      }), a.d(l, "onBeforePageViewPartiallyRendered", function () {
        return qt;
      }), a.d(l, "onBeforePageView", function () {
        return Ot;
      }), a.d(l, "onAfterPageView", function () {
        return It;
      }), a.d(l, "onBeforeModalView", function () {
        return xt;
      }), a.d(l, "onBeforePurchaseStart", function () {
        return At;
      }), a.d(l, "onBeforePurchaseStop", function () {
        return Ct;
      }), a.d(l, "onAfterPurchaseStop", function () {
        return Dt;
      }), a.d(l, "onBeforeFeatureStart", function () {
        return Kt;
      }), a.d(l, "onBeforeFeatureStop", function () {
        return Nt;
      }), a.d(l, "onAfterFeatureStop", function () {
        return Vt;
      }), a.d(l, "onBeforeApplicationActivity", function () {
        return Ft;
      }), a.d(l, "onAfterApplicationActivity", function () {
        return Mt;
      }), a.d(l, "onBeforeModalClose", function () {
        return jt;
      }), a.d(l, "onBeforePageViewPerformance", function () {
        return Bt;
      }), a.d(l, "onBeforeUserFeedback", function () {
        return Lt;
      }), a.d(l, "onBeforeDeeplinkStart", function () {
        return Ut;
      }), a.d(l, "onBeforeDeeplinkStop", function () {
        return _t;
      }), a.d(l, "onBeforeAssetDisplayed", function () {
        return Gt;
      }), a.d(l, "onBeforeImpressionStart", function () {
        return Ht;
      }), a.d(l, "onBeforeImpressionStop", function () {
        return zt;
      });
      var u = {};
      a.r(u), a.d(u, "onBeforeSearched", function () {
        return Jt;
      }), a.d(u, "onBeforeSearchClosed", function () {
        return Wt;
      });
      var c = {};
      a.r(c), a.d(c, "onBeforeSelectAction", function () {
        return Qt;
      });
      var v = {};
      a.r(v), a.d(v, "onBeforeStartSession", function () {
        return Xt;
      }), a.d(v, "onBeforeUserConfigSet", function () {
        return Yt;
      }), a.d(v, "onBeforeConnectionChange", function () {
        return Zt;
      }), a.d(v, "onBeforeApplicationPerformance", function () {
        return $t;
      });
      var p = {};
      a.r(p), a.d(p, "onBeforeLoginStop", function () {
        return aa;
      }), a.d(p, "onAfterLogout", function () {
        return ra;
      });
      var d = {};
      a.r(d), a.d(d, "onBeforeStartSession", function () {
        return ia;
      }), a.d(d, "onBeforeDeviceConfigSet", function () {
        return na;
      });
      var g = {};
      a.r(g), a.d(g, "onBeforeModalCancel", function () {
        return oa;
      }), a.d(g, "onAfterModalCancel", function () {
        return sa;
      }), a.d(g, "onBeforePushNotification", function () {
        return la;
      });

      var y = a(2),
          f = a.n(y),
          m = a(0),
          w = a.n(m),
          h = a(1),
          b = a.n(h),
          P = a(56),
          T = a.n(P),
          S = a(57),
          k = a.n(S),
          R = a(33),
          E = a.n(R),
          q = a(5),
          O = a.n(q),
          I = a(7),
          x = a.n(I),
          A = a(4),
          C = a.n(A),
          D = a(15),
          K = a.n(D),
          N = a(6),
          V = a.n(N),
          F = a(8),
          M = a.n(F),
          j = a(3),
          B = a.n(j),
          L = a(19),
          U = a.n(L),
          _ = a(11),
          G = a.n(_);

      function H(e) {
        return e[0].toUpperCase() + e.slice(1);
      }

      var z = a(58),
          J = a.n(z),
          W = {
        debug: 0,
        info: 10,
        warning: 20,
        error: 30,
        critical: 40
      },
          Q = {
        debug: "DEBUG",
        info: "INFO",
        warning: "WARNING",
        error: "ERROR",
        critical: "CRITICAL"
      },
          X = {
        debug: console.log.bind(console),
        info: console.log.bind(console),
        warning: console.warn ? console.warn.bind(console) : console.log.bind(console),
        error: console.error ? console.error.bind(console) : console.log.bind(console),
        critical: console.error ? console.error.bind(console) : console.log.bind(console)
      },
          Y = new (function () {
        function e() {
          var t = this;
          w()(this, e), this._level = W.info, Object.entries(W).forEach(function (e) {
            var a = J()(e, 1)[0];

            t[a] = function (e) {
              return t.write(a, e);
            };
          });
        }

        return b()(e, [{
          key: "setLevel",
          value: function value(e) {
            e in W && (this._level = W[e]);
          }
        }, {
          key: "setCustomHandler",
          value: function value(e) {
            this.logHandler = e;
          }
        }, {
          key: "clearCustomHandler",
          value: function value() {
            this.logHandler = void 0;
          }
        }, {
          key: "write",
          value: function value(e, t) {
            if (W[e] >= this._level) {
              var a = new Date().toISOString(),
                  r = Q[e];
              this.logHandler ? this.logHandler(a, r, t) : X[e]("[".concat(a, "] (").concat(r, ") Analytics::").concat(t));
            }
          }
        }]), e;
      }())(),
          Z = function () {
        function e(t) {
          w()(this, e), this.initial = t.initial, this.current = t.initial, this.transitions = t.transitions, this.ignored = {}, this.callbacks = t.callbacks, this.name = t.name || "default";
        }

        return b()(e, [{
          key: "trigger",
          value: function value(e, t) {
            var a = t.options && t.options.forceTransitionTo;
            if (this.transitions[e] && !this.isIgnored(e)) if (!this.cannot(e) || a) {
              var r = this.current,
                  i = a || this.transitions[e][r] || this.transitions[e]["*"];
              "*" === i && (i = this.current), r !== i && this.beforeLeaveState(e, r, i, t), this.beforeEvent(e, r, i, t), r !== i && (this.current = i, this.changeState(e, r, i, t)), this.afterEvent(e, r, i, t), r !== i && this.afterEnterState(e, r, i, t);
            } else this.current === this.initial ? this.hadInitError || (this.eventBeforeInit(e, this.current, i, t), this.hadInitError = !0) : "DISABLED" !== this.current && (this.invalidEvent(e, this.current, i, t), this.current = "DISABLED");
          }
        }, {
          key: "reset",
          value: function value() {
            this.current = this.initial, this.hadInitError = !1;
          }
        }, {
          key: "is",
          value: function value(e) {
            return e === this.current;
          }
        }, {
          key: "can",
          value: function value(e) {
            return !!this.transitions[e] && (this.current === this.initial ? this.transitions[e][this.current] && "*" !== this.transitions[e][this.current] || this.transitions[e]["*"] && "*" !== this.transitions[e]["*"] : this.transitions[e][this.current] || this.transitions[e]["*"]);
          }
        }, {
          key: "cannot",
          value: function value(e) {
            return !this.can(e);
          }
        }, {
          key: "isIgnored",
          value: function value(e) {
            return this.ignored[this.current] && -1 !== this.ignored[this.current].indexOf(e);
          }
        }, {
          key: "setIgnored",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            this.ignored = e;
          }
        }, {
          key: "invalidEvent",
          value: function value(e, t, a, r) {
            this.callbacks.onInvalidEvent && this.callbacks.onInvalidEvent(e, t, a, r);
          }
        }, {
          key: "eventBeforeInit",
          value: function value(e, t, a, r) {
            this.callbacks.onEventBeforeInit && this.callbacks.onEventBeforeInit(e, t, a, r);
          }
        }, {
          key: "beforeEvent",
          value: function value(e, t, a, r) {
            this.beforeAnyEvent(e, t, a, r), this.beforeThisEvent(e, t, a, r);
          }
        }, {
          key: "beforeAnyEvent",
          value: function value(e, t, a, r) {
            this.callbacks.onBeforeEvent && this.callbacks.onBeforeEvent(e, t, a, r);
          }
        }, {
          key: "beforeThisEvent",
          value: function value(e, t, a, r) {
            var i = "onBefore".concat(H(e));
            this.callbacks[i] && this.callbacks[i](e, t, a, r);
          }
        }, {
          key: "afterEvent",
          value: function value(e, t, a, r) {
            this.afterAnyEvent(e, t, a, r), this.afterThisEvent(e, t, a, r);
          }
        }, {
          key: "afterAnyEvent",
          value: function value(e, t, a, r) {
            this.callbacks.onAfterEvent && this.callbacks.onAfterEvent(e, t, a, r);
          }
        }, {
          key: "afterThisEvent",
          value: function value(e, t, a, r) {
            var i = "onAfter".concat(H(e));
            this.callbacks[i] && this.callbacks[i](e, t, a, r);
          }
        }, {
          key: "beforeLeaveState",
          value: function value(e, t, a, r) {
            var i = "onBeforeLeave".concat(H(t));
            this.callbacks[i] && this.callbacks[i](e, t, a, r);
          }
        }, {
          key: "changeState",
          value: function value(e, t, a, r) {
            this.callbacks.onChangeState && this.callbacks.onChangeState(e, t, a, r);
          }
        }, {
          key: "afterEnterState",
          value: function value(e, t, a, r) {
            var i = "onAfterEnter".concat(H(a));
            this.callbacks[i] && this.callbacks[i](e, t, a, r);
          }
        }]), e;
      }(),
          $ = function () {
        function e() {
          w()(this, e), f()(this, "data", {});
        }

        return b()(e, [{
          key: "set",
          value: function value(e, t) {
            M()(this.data, e, t);
          }
        }, {
          key: "get",
          value: function value(e) {
            return B()(this.data, e);
          }
        }, {
          key: "reset",
          value: function value(e) {
            M()(this.data, e, void 0);
          }
        }, {
          key: "batchSet",
          value: function value(e) {
            var t = this;
            Object.keys(e).forEach(function (a) {
              t.set(a, e[a]);
            });
          }
        }, {
          key: "getData",
          value: function value() {
            return this.data;
          }
        }]), e;
      }(),
          ee = function () {
        function e(t, a) {
          w()(this, e), this.onFlush = a, this.buffer = [], this.currentSize = 0, this.maxSize = t;
        }

        return b()(e, [{
          key: "push",
          value: function value(e) {
            var t = JSON.stringify(e).length;
            this.buffer.push(e), this.currentSize += t, this.currentSize >= this.maxSize && this.flush();
          }
        }, {
          key: "setMaxSize",
          value: function value(e) {
            this.maxSize = e;
          }
        }, {
          key: "flush",
          value: function value() {
            var e = this.buffer;
            this.buffer = [], this.currentSize = 0, this.onFlush(e);
          }
        }]), e;
      }(),
          te = a(32),
          ae = a.n(te),
          re = a(59),
          ie = a.n(re);

      function ne(e) {
        return function e(t) {
          return Object.keys(t).forEach(function (a) {
            var r = t[a];
            (null == r || "number" == typeof r && Number.isNaN(r) || "" === r || "object" === ae()(r) && 0 === Object.keys(e(r)).length) && delete t[a];
          }), Array.isArray(t) && ie()(t, void 0), t;
        }(C()(e));
      }

      var oe = function () {
        function e(t, a) {
          w()(this, e), this.id = null, this.callback = t, this.interval = a;
        }

        return b()(e, [{
          key: "start",
          value: function value(e) {
            this.delay = this.delay || e, this.clear(), this.run();
          }
        }, {
          key: "pause",
          value: function value() {
            this.clear(), this.delay = this.interval - (Date.now() - this.startTime);
          }
        }, {
          key: "stop",
          value: function value() {
            this.clear(), this.delay = null, this.startTime = null;
          }
        }, {
          key: "changeInterval",
          value: function value(e) {
            this.interval = e;
          }
        }, {
          key: "run",
          value: function value() {
            var e = this,
                t = this.delay || this.interval;
            this.id = setTimeout(function () {
              e.delay = null, e.run(), e.callback();
            }, t), this.startTime = Date.now();
          }
        }, {
          key: "clear",
          value: function value() {
            clearTimeout(this.id), this.id = null;
          }
        }]), e;
      }(),
          se = {
        required: function required(e, t, a) {
          var r = {
            success: !0
          };
          return void 0 === e && (r.break = !0, !0 === a.value && (r.success = !1, r.message = "REQUIRED: attribute [".concat(t, "] is required"))), r;
        },
        allowed: function allowed(e, t, a) {
          var r = {
            success: !0
          };
          return void 0 !== e && !1 === a.value && (r.success = !1, r.message = "ALLOWED: attribute [".concat(t, "] is not allowed")), r;
        },
        type: function type(e, t, a) {
          var r = {
            success: !0
          };
          return void 0 !== e && (le(e, a.value) || (r.success = !1, r.message = "TYPE: Input value [".concat(e, "] for attribute [").concat(t, "] is should be of type: [").concat(a.value, "]"))), r;
        },
        elementType: function elementType(e, t, a) {
          var r = {
            success: !0
          };

          if (void 0 !== e) {
            var i;
            if (Array.isArray(e)) i = e;else {
              if (!V()(e)) throw new Error("Input value [".concat(e, "] for attribute [").concat(t, "] is not an array or object!"));
              i = Object.values(e);
            }
            i.every(function (e) {
              return le(e, a.value);
            }) || (r.success = !1, r.message = "ELEMENT TYPE: All values [".concat(i.join(), "] for attribute [").concat(t, "] should be of type [").concat(a.value, "]"));
          }

          return r;
        },
        restrictedTo: function restrictedTo(e, t, a) {
          var r = {
            success: !0
          };
          return void 0 !== e && -1 === a.value.indexOf(e) && (r.success = !1, r.message = "RESTRICTED: Input value [".concat(e, "] for attribute [").concat(t, "] is not allowed. Must be one of: [").concat(a.value.join(), "]")), r;
        },
        min: function min(e, t, a) {
          var r = {
            success: !0
          };

          if (void 0 !== e) {
            if ("number" != typeof e) throw new Error("Input value [".concat(e, "] for attribute [").concat(t, "] is not a number!"));
            e < a.value && (r.success = !1, r.message = "MIN: Value [".concat(e, "] for attribute [").concat(t, "] expected to be more than [").concat(a.value, "]"));
          }

          return r;
        },
        max: function max(e, t, a) {
          var r = {
            success: !0
          };

          if (void 0 !== e) {
            if ("number" != typeof e) throw new Error("Input value [".concat(e, "] for attribute [").concat(t, "] is not a number!"));
            e > a.value && (r.success = !1, r.message = "MAX: Value [".concat(e, "] for attribute [").concat(t, "] expected to be less than [").concat(a.value, "]"));
          }

          return r;
        },
        minLength: function minLength(e, t, a) {
          var r = {
            success: !0
          };

          if (void 0 !== e) {
            if ("string" != typeof e && !Array.isArray(e)) throw new Error("Input value [".concat(e, "] for [").concat(t, "] is not an array or string!"));

            if (e.length < a.value) {
              var i = "string" == typeof e ? e : e.join();
              r.success = !1, r.message = "MIN LENGTH: Input value [".concat(i, "] for attribute [").concat(t, "] expected to be at least of length [").concat(a.value, "]");
            }
          }

          return r;
        },
        maxLength: function maxLength(e, t, a) {
          var r = {
            success: !0
          };

          if (void 0 !== e) {
            if ("string" != typeof e && !Array.isArray(e)) throw new Error("Input value [".concat(e, "] for [").concat(t, "] is not an array or string!"));

            if (e.length > a.value) {
              var i = "string" == typeof e ? e : e.join();
              r.success = !1, r.message = "MAX LENGTH: Input value [".concat(i, "] for attribute [").concat(t, "] expected to be at most of length [").concat(a.value, "]");
            }
          }

          return r;
        }
      };

      function le(e, t) {
        switch (t) {
          case "int":
          case "integer":
          case "long":
            return "number" == typeof e && Number.isInteger(e);

          case "double":
            return "number" == typeof e;

          case "string":
            return "string" == typeof e;

          case "boolean":
            return "boolean" == typeof e;

          case "array":
            return Array.isArray(e);

          case "object":
          case "map":
            return V()(e);

          default:
            throw new Error("Unknown data type ".concat(t, "!"));
        }
      }

      var ue,
          ce,
          ve,
          pe = function () {
        function e(t, a) {
          w()(this, e), this.rules = t, this.model = a;
        }

        return b()(e, [{
          key: "validate",
          value: function value(e, t) {
            var a = this,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            if (!t) throw new Error("No data for ".concat(e, " provided for validation"));
            var i = this.rules[e];
            if (!i) throw new Error("No event ".concat(e, " in validation rules"));
            var n = {},
                o = [],
                s = [],
                l = this.getRemovedKeys(e, t, i, r);
            return l.length && s.push("".concat(e, ": Removed unexpected keys [").concat(l.join(", "), "] from event ").concat(e)), Object.keys(i).forEach(function (s) {
              var l = a.getDataPath(e, s);
              if (void 0 === l) o.push("MISSING PATH MAPPING: ".concat(e, ": ").concat(s));else {
                if (r && r.safe && -1 !== r.safe.indexOf(l)) return;
                var u = B()(t, l),
                    c = !0;

                for (var v in se) {
                  var p = i[s].validationRules[v];

                  if (p) {
                    var d = a.chooseRule(p, t, e);

                    if (d) {
                      var g = se[v](u, l, d);

                      if (!1 === g.success) {
                        c = !1;
                        var y = g.message;
                        d.condition && (y = "".concat(y, " if ").concat(a.formatConditionError(t, d.condition, e))), o.push(y);
                        break;
                      }
                    }
                  }
                }

                c && void 0 !== u && M()(n, l, u);
              }
            }), r && r.safe && r.safe.forEach(function (e) {
              M()(n, e, t[e]);
            }), {
              sanitized: n,
              errors: o,
              warnings: s
            };
          }
        }, {
          key: "getDataPath",
          value: function value(e, t) {
            return this.rules[e][t] && this.rules[e][t].venonaKey ? this.rules[e][t].venonaKey : t;
          }
        }, {
          key: "getRemovedKeys",
          value: function value(e, t, a, r) {
            var i = this;
            return K()(Object.keys(t).filter(function (e) {
              return void 0 !== t[e];
            }), Object.keys(a).map(function (t) {
              return i.getDataPath(e, t);
            }).concat(r.safe || []));
          }
        }, {
          key: "chooseRule",
          value: function value(e, t, a) {
            var r = this;
            return e.find(function (e) {
              return !e.condition || e.condition.some(function (e) {
                return r.checkCondition(t, e, a);
              });
            });
          }
        }, {
          key: "checkCondition",
          value: function value(e, t, a) {
            var r = this;
            return Object.keys(t).every(function (i) {
              var n = "!" === i[0],
                  o = n ? i.slice(1) : i,
                  s = r.getDataPath(a, o),
                  l = void 0 !== B()(e, s) ? B()(e, s) : r.model.get(o);
              return n ? t[i].every(function (e) {
                return r.compare(l, e, n);
              }) : t[i].some(function (e) {
                return r.compare(l, e, n);
              });
            });
          }
        }, {
          key: "formatConditionError",
          value: function value(e, t, a) {
            var r = this;
            return t.map(function (t) {
              var i = Object.keys(t).map(function (i) {
                var n = "!" === i[0],
                    o = n ? i.slice(1) : i,
                    s = r.getDataPath(a, o),
                    l = void 0 === B()(e, s),
                    u = n ? t[i].map(function (e) {
                  return "" === e ? '" "' : e;
                }).join(" and ") : t[i].map(function (e) {
                  return "" === e ? '" "' : e;
                }).join(" or "),
                    c = n ? "".concat(o, " != ").concat(u) : "".concat(o, " = ").concat(u);
                return l ? "MODEL::".concat(c) : c;
              });
              return "(".concat(i.join(" and "), ")");
            }).join(" or ");
          }
        }, {
          key: "compare",
          value: function value(e, t, a) {
            return a ? "anullValue" === t ? void 0 !== e : e !== t : "anullValue" === t ? void 0 === e : e === t;
          }
        }]), e;
      }(),
          de = a(16),
          ge = a(12),
          ye = a(60),
          fe = (ue = "undefined" != typeof window && window.fetch && window.AbortController, ve = (ce = "undefined" != typeof navigator && navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)) && Number(ce[2]) >= 84, ue && ve);

      function me() {
        return fe ? we.apply(void 0, arguments) : be.apply(void 0, arguments);
      }

      function we(e, t, a) {
        return he.apply(this, arguments);
      }

      function he() {
        return (he = x()(O.a.mark(function e(t, a, r) {
          var i, n, o, s, l, u;
          return O.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return i = t.url, n = t.data, o = t.token, s = t.tokenType, l = {
                    "Content-Type": "application/json"
                  }, o && (l.Authorization = "OAuth oauth_token=".concat(o), s && (l.AuthType = s)), e.prev = 3, e.next = 6, Pe(i, {
                    method: "POST",
                    headers: l,
                    body: n,
                    keepalive: Boolean(r)
                  }, a);

                case 6:
                  if ((u = e.sent).ok) {
                    e.next = 9;
                    break;
                  }

                  throw new Error(u.status);

                case 9:
                  e.next = 16;
                  break;

                case 11:
                  if (e.prev = 11, e.t0 = e.catch(3), "AbortError" !== e.t0.name) {
                    e.next = 15;
                    break;
                  }

                  throw new Error("timeout");

                case 15:
                  throw e.t0;

                case 16:
                case "end":
                  return e.stop();
              }
            }
          }, e, null, [[3, 11]]);
        }))).apply(this, arguments);
      }

      function be(e, t) {
        var a = e.url,
            r = e.data,
            i = e.token,
            n = e.tokenType;
        return new Promise(function (e, o) {
          var s = new XMLHttpRequest();
          t && (s.timeout = t), s.onreadystatechange = function () {
            4 === s.readyState && (200 === s.status ? e() : o(s.status));
          }, s.open("post", a, !0), s.setRequestHeader("Content-Type", "application/json;charset=UTF-8"), i && s.setRequestHeader("Authorization", "OAuth oauth_token=".concat(i)), i && n && s.setRequestHeader("AuthType", n), s.send(r);
        });
      }

      function Pe(e, t, a) {
        var r = new AbortController(),
            i = r.signal;
        return t.signal = i, a && setTimeout(function () {
          return r.abort();
        }, a), fetch(e, t);
      }

      var Te = new (function () {
        function e() {
          w()(this, e);
        }

        var t;
        return b()(e, [{
          key: "init",
          value: function value(e) {
            this.pendingRequests = {}, this.config(e);
          }
        }, {
          key: "config",
          value: function value(e) {
            this.sendRetryInterval = e.sendRetryInterval, this.sendTimeout = e.sendTimeout;
          }
        }, {
          key: "send",
          value: function value(e, t, a) {
            var r = this,
                i = me(e, this.sendTimeout, a);
            this.pendingRequests[t] = i, i.catch(function (i) {
              (0 === i || i >= 500) && setTimeout(function () {
                var i = me(e, r.sendTimeout, a);
                r.pendingRequests["".concat(t, "_retry")] = i, i.catch(function () {}).finally(function () {
                  delete r.pendingRequests["".concat(t, "_retry")];
                });
              }, r.sendRetryInterval);
            }).finally(function () {
              delete r.pendingRequests[t];
            });
          }
        }, {
          key: "finishRequests",
          value: (t = x()(O.a.mark(function e() {
            return O.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, Promise.allSettled(Object.values(this.pendingRequests));

                  case 2:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function () {
            return t.apply(this, arguments);
          })
        }]), e;
      }())(),
          Se = function () {
        function e(t) {
          var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            exceptions: []
          };
          w()(this, e), this.timesPerSecond = t, this.exceptions = a.exceptions, this.exceptionCount = {}, this.reset();
        }

        return b()(e, [{
          key: "changeRate",
          value: function value(e) {
            this.timesPerSecond = e;
          }
        }, {
          key: "reset",
          value: function value() {
            var e = this;
            this.count = 0, this.exceptions.forEach(function (t) {
              return e.exceptionCount[t] = 0;
            });
          }
        }, {
          key: "wrap",
          value: function value(e) {
            var t = this;
            return setInterval(function () {
              t.reset();
            }, 1e3), function (a) {
              for (var r = t.exceptions.includes(a), i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) {
                n[o - 1] = arguments[o];
              }

              return r && t.exceptionCount[a] < t.timesPerSecond ? (t.exceptionCount[a]++, e.apply(void 0, [a].concat(n))) : !r && t.count < t.timesPerSecond && (t.count++, e.apply(void 0, [a].concat(n)));
            };
          }
        }]), e;
      }();

      function ke() {
        var e = new Date().getTime();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
          var a = (e + 16 * Math.random()) % 16 | 0;
          return e = Math.floor(e / 16), ("x" === t ? a : 3 & a | 8).toString(16);
        });
      }

      function Re(e, t) {
        return !e || "BulkMDU" !== e.toLowerCase() && "SpecU" !== e.toLowerCase() || (e = "OneApp"), "".concat(e, "@").concat(t);
      }

      var Ee = function () {
        function e() {
          w()(this, e), this.playbackType = void 0, this.uriObtainedMs = 0, this.tuneTimeMs = 0, this.lastBufferingTime = 0, this.retryTimeMs = void 0, this.currentVideoPosition = 0, this.contentElapsedMs = 0, this.clockTimeElapsedMs = 0, this.bookmarkPosition = 0, this.runningTotalContentElapsedMs = 0, this.currentBitRate = 0, this.previousBitRate = void 0, this.contentElapsedAtCurrentBitRate = 0, this.contentElapsedAtPreviousBitRate = void 0, this.currentAudioBitRateBps = 0, this.previousAudioBitRateBps = void 0, this.playbackSelectedTimestamp = 0, this.playbackStartedTimestamp = 0, this.lastEventTimestamp = 0, this.lastHeartbeatEventTimestamp = 0, this.bufferingTimestamp = 0, this.playbackFailTimestamp = 0, this.playPointTimestamp = 0, this.attemptRestartTimestamp = 0;
        }

        return b()(e, [{
          key: "reset",
          value: function value() {
            this.currentVideoPosition = 0, this.playPointTimestamp = 0, this.contentElapsedMs = 0, this.runningTotalContentElapsedMs = 0, this.clockTimeElapsedMs = 0, this.contentElapsedAtCurrentBitRate = 0, this.currentBitRate = 0, this.lastEventTimestamp = 0, this.lastHeartbeatEventTimestamp = 0, this.playbackStartedTimestamp = 0, this.attemptRestartTimestamp = 0, this.retryTimeMs = void 0;
          }
        }, {
          key: "refreshHeartbeat",
          value: function value(e) {
            this.contentElapsedMs = 0, this.contentElapsedAtCurrentBitRate = 0, this.clockTimeElapsedMs = e - this.lastHeartbeatEventTimestamp;
          }
        }, {
          key: "calculateHeartbeat",
          value: function value(e) {
            var t = e - this.lastEventTimestamp,
                a = e - this.lastHeartbeatEventTimestamp;
            this.contentElapsedMs = a, this.runningTotalContentElapsedMs += this.contentElapsedMs, this.clockTimeElapsedMs = a, "linear" === this.playbackType && 0 === this.bufferingTimestamp && (this.playPointTimestamp = this.playPointTimestamp + t);
          }
        }, {
          key: "calculateCurrentVideoPosition",
          value: function value(e, t) {
            this.currentVideoPosition = void 0 !== t ? t : this.currentVideoPosition + Math.round((e - this.lastEventTimestamp) / 1e3);
          }
        }]), e;
      }();

      function qe(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        n.contentElapsedMs = 0, n.clockTimeElapsedMs = 0, n.retryTimeMs = void 0, "playbackBitRateChange" !== e && (n.contentElapsedAtCurrentBitRate = 0), "playing" === t && ("tick" !== e && (n.contentElapsedAtCurrentBitRate = i.timestamp - n.lastHeartbeatEventTimestamp, n.calculateHeartbeat(i.timestamp)), "vod" !== n.playbackType && "dvr" !== n.playbackType && "sizzle" !== n.playbackType && "videoClip" !== n.playbackType || n.calculateCurrentVideoPosition(i.timestamp));
      }

      function Oe(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        "playbackBitRateChange" !== e && (delete n.previousBitRate, delete n.contentElapsedAtPreviousBitRate, delete n.previousAudioBitRateBps), "tick" !== e && "playbackSelect" !== e && "playbackStreamUriAcquired" !== e && "playbackStop" !== e && "attemptRestart" !== e && (n.lastHeartbeatEventTimestamp = i.timestamp), n.lastEventTimestamp = i.timestamp;
      }

      function Ie(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.data,
            n = r.options,
            o = Ye.model;
        o.reset(), o.playbackType = i.playbackType, "vod" !== o.playbackType && "dvr" !== o.playbackType && "sizzle" !== o.playbackType && "videoClip" !== o.playbackType || void 0 !== i.position && (o.bookmarkPosition = i.position), o.playbackSelectedTimestamp = n.timestamp;
      }

      function xe(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model,
            o = 0 !== n.attemptRestartTimestamp ? n.attemptRestartTimestamp : n.playbackSelectedTimestamp;
        n.uriObtainedMs = i.timestamp - o;
      }

      function Ae(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.data,
            n = r.options,
            o = Ye.model;
        "linear" === o.playbackType && (void 0 !== i.playPointTimestamp ? o.playPointTimestamp = i.playPointTimestamp : o.playPointTimestamp = n.timestamp), "vod" !== o.playbackType && "dvr" !== o.playbackType && "sizzle" !== o.playbackType && "videoClip" !== o.playbackType || o.calculateCurrentVideoPosition(n.timestamp, o.bookmarkPosition), delete o.bookmarkPosition, o.currentBitRate = i.bitrate, o.currentAudioBitRateBps = i.audioBitrate, o.tuneTimeMs = n.timestamp - o.playbackSelectedTimestamp, o.playbackStartedTimestamp = n.timestamp, 0 !== o.attemptRestartTimestamp && (o.retryTimeMs = n.timestamp - o.attemptRestartTimestamp);
      }

      function Ce() {
        Ye.model.attemptRestartTimestamp = 0;
      }

      function De(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.data,
            n = r.options,
            o = Ye.model;
        "linear" === o.playbackType && (void 0 !== i.playPointTimestamp ? o.playPointTimestamp = i.playPointTimestamp : o.playPointTimestamp = n.timestamp), o.currentBitRate = i.bitrate, 0 !== o.attemptRestartTimestamp && (o.retryTimeMs = n.timestamp - o.attemptRestartTimestamp);
      }

      function Ke() {
        var e = Ye.model;
        e.playbackStartedTimestamp = 0, e.lastEventTimestamp = 0, e.lastHeartbeatEventTimestamp = 0;
      }

      function Ne() {
        Ye.model.lastEventTimestamp = 0;
      }

      function Ve(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        n.bufferingTimestamp = i.timestamp;
      }

      function Fe(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        n.refreshHeartbeat(i.timestamp), n.lastBufferingTime = i.timestamp - n.bufferingTimestamp, n.bufferingTimestamp = 0;
      }

      function Me(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        n.refreshHeartbeat(i.timestamp), n.pauseTimestamp = 0;
      }

      function je(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        n.refreshHeartbeat(i.timestamp);
      }

      function Be(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.data,
            n = r.options,
            o = Ye.model;
        o.refreshHeartbeat(n.timestamp), o.calculateCurrentVideoPosition(n.timestamp, i.contentPosition), o.trickplayTimestamp = 0;
      }

      function Le(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.data,
            n = r.options,
            o = Ye.model;
        o.contentElapsedAtPreviousBitRate = o.contentElapsedAtCurrentBitRate, o.contentElapsedAtCurrentBitRate = 0, o.previousBitRate = o.currentBitRate, o.previousAudioBitRateBps = o.currentAudioBitRateBps, o.currentBitRate = i.bitrate, o.currentAudioBitRateBps = i.audioBitrate, o.clockTimeElapsedMs = n.timestamp - o.lastHeartbeatEventTimestamp;
      }

      function Ue(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        n.clockTimeElapsedMs = i.timestamp - n.lastHeartbeatEventTimestamp, 0 !== n.attemptRestartTimestamp && (n.retryTimeMs = i.timestamp - n.attemptRestartTimestamp);
      }

      function _e(e, t, a) {
        Ye.model.playbackStartedTimestamp = 0;
      }

      function Ge(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        n.clockTimeElapsedMs = i.timestamp - n.lastHeartbeatEventTimestamp, 0 !== n.attemptRestartTimestamp && (n.retryTimeMs = i.timestamp - n.attemptRestartTimestamp);
      }

      function He(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        n.contentElapsedAtCurrentBitRate = 0, n.attemptRestartTimestamp = i.timestamp;
      }

      function ze(e, t, a) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          data: {},
          options: {}
        },
            i = r.options,
            n = Ye.model;
        0 === n.bufferingTimestamp && "linear" === n.playbackType && (n.playPointTimestamp += i.timestamp - n.lastEventTimestamp);
      }

      function Je(e, t) {
        var a = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), a.push.apply(a, r);
        }

        return a;
      }

      function We(e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = null != arguments[t] ? arguments[t] : {};
          t % 2 ? Je(Object(a), !0).forEach(function (t) {
            f()(e, t, a[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Je(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
          });
        }

        return e;
      }

      var Qe = G()(de, ["playbackSelect", "playbackStreamUriAcquired", "playbackStart", "playbackStartAfterRetry", "playbackStop", "playbackHeartbeat", "bufferingStart", "bufferingStop", "playbackPause", "playbackUnpause", "playbackFailure", "playbackFailureBeforeRetry", "attemptRestart", "playbackTrickPlayStart", "playbackTrickPlayRateChange", "playbackTrickPlayStop", "playbackExitBeforeStart"]);
      Qe.playbackSelect = We(We({}, Qe.playbackSelect), {}, {
        blank: "initiating"
      }), Qe.tick = {
        "*": "*"
      }, Qe.playbackBitRateChange = de.playbackBitRateUpshift;

      var Xe = Qe,
          Ye = new (function () {
        function e() {
          w()(this, e), this.model = new Ee(), this.sm = new Z({
            initial: "blank",
            callbacks: r,
            transitions: Xe,
            name: "VideoPlayer"
          });
        }

        return b()(e, [{
          key: "playbackSelect",
          value: function value(e, t, a) {
            this.sm.trigger("playbackSelect", {
              data: {
                playbackType: t,
                position: a
              },
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackStreamUriAcquired",
          value: function value(e) {
            this.sm.trigger("playbackStreamUriAcquired", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackStart",
          value: function value(e, t, a, r) {
            this.sm.trigger("playbackStart", {
              data: {
                bitrate: t,
                playPointTimestamp: a,
                audioBitrate: r
              },
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackStartAfterRetry",
          value: function value(e, t, a) {
            this.sm.trigger("playbackStartAfterRetry", {
              data: {
                bitrate: t,
                playPointTimestamp: a
              },
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackStop",
          value: function value(e) {
            this.sm.trigger("playbackStop", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackExitBeforeStart",
          value: function value(e) {
            this.sm.trigger("playbackExitBeforeStart", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackHeartbeat",
          value: function value(e) {
            this.sm.trigger("playbackHeartbeat", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "bufferingStart",
          value: function value(e) {
            this.sm.trigger("bufferingStart", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "bufferingStop",
          value: function value(e) {
            this.sm.trigger("bufferingStop", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackPause",
          value: function value(e) {
            this.sm.trigger("playbackPause", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackUnpause",
          value: function value(e) {
            this.sm.trigger("playbackUnpause", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackTrickPlayStart",
          value: function value(e) {
            this.sm.trigger("playbackTrickPlayStart", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackTrickPlayRateChange",
          value: function value(e) {
            this.sm.trigger("playbackTrickPlayRateChange", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackTrickPlayStop",
          value: function value(e, t) {
            this.sm.trigger("playbackTrickPlayStop", {
              data: {
                contentPosition: t
              },
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackFailure",
          value: function value(e) {
            this.sm.trigger("playbackFailure", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackFailureBeforeRetry",
          value: function value(e) {
            this.sm.trigger("playbackFailureBeforeRetry", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "attemptRestart",
          value: function value(e) {
            this.sm.trigger("attemptRestart", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "playbackBitRateChange",
          value: function value(e, t, a) {
            this.sm.trigger("playbackBitRateChange", {
              data: {
                bitrate: t,
                audioBitrate: a
              },
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "tick",
          value: function value(e) {
            this.sm.trigger("tick", {
              options: {
                timestamp: e
              }
            });
          }
        }, {
          key: "isActive",
          value: function value() {
            return 0 !== this.model.playbackStartedTimestamp;
          }
        }, {
          key: "getVideoPlayerState",
          value: function value() {
            var e = {
              playbackType: this.model.playbackType,
              uriObtainedMs: this.model.uriObtainedMs,
              tuneTimeMs: this.model.tuneTimeMs,
              currentVideoPosition: this.model.currentVideoPosition,
              lastBufferingTime: this.model.lastBufferingTime,
              retryTimeMs: this.model.retryTimeMs,
              heartBeat: {
                contentElapsedMs: this.model.contentElapsedMs,
                clockTimeElapsedMs: this.model.clockTimeElapsedMs,
                playPointTimestamp: this.model.playPointTimestamp,
                runningTotalContentElapsedMs: this.model.runningTotalContentElapsedMs
              },
              bitRate: {
                currentBitRate: this.model.currentBitRate,
                previousBitRate: this.model.previousBitRate,
                contentElapsedAtCurrentBitRate: this.model.contentElapsedAtCurrentBitRate,
                contentElapsedAtPreviousBitRate: this.model.contentElapsedAtPreviousBitRate,
                currentAudioBitRateBps: this.model.currentAudioBitRateBps,
                previousAudioBitRateBps: this.model.previousAudioBitRateBps
              }
            };
            return "linear" === this.model.playbackType && delete e.currentVideoPosition, "linear" !== this.model.playbackType && delete e.heartBeat.playPointTimestamp, e;
          }
        }, {
          key: "reset",
          value: function value() {
            this.model = new Ee(), this.sm.current = "blank";
          }
        }]), e;
      }())(),
          Ze = function () {
        function e(t) {
          w()(this, e), f()(this, "expirationSuffix", "expkey"), this.isSession = t, this.storageType = t ? "sessionStorage" : "localStorage", this.storage = this.getStorage();
        }

        return b()(e, [{
          key: "set",
          value: function value(e, t, a) {
            if (this.storage && (this.storage.setItem(e, t), a && !this.isSession)) {
              var r = Date.now() + a;
              this.storage.setItem(this.getExpirationKeyName(e), r);
            }
          }
        }, {
          key: "get",
          value: function value(e) {
            if (this.storage) {
              if (this.isSession) return this.storage.getItem(e);
              var t = this.storage.getItem(this.getExpirationKeyName(e));
              return t && Date.now() > t ? (this.storage.removeItem(e), this.storage.removeItem(this.getExpirationKeyName(e)), null) : this.storage.getItem(e);
            }

            return null;
          }
        }, {
          key: "reset",
          value: function value(e) {
            this.storage && (this.storage.removeItem(e), this.storage.removeItem(this.getExpirationKeyName(e)));
          }
        }, {
          key: "getStorage",
          value: function value() {
            try {
              if (!window && window[this.storageType]) return !1;
              var e = "test-".concat(Date.now());
              return window[this.storageType].setItem(e, "test"), window[this.storageType].removeItem(e), window[this.storageType];
            } catch (e) {
              return null;
            }
          }
        }, {
          key: "getExpirationKeyName",
          value: function value(e) {
            return "".concat(e, "-").concat(this.expirationSuffix);
          }
        }]), e;
      }(),
          $e = function () {
        function e() {
          w()(this, e), f()(this, "internal", {}), f()(this, "persistenceEnabled", !1), this.useDefaultPersisted();
        }

        return b()(e, [{
          key: "useDefaultPersisted",
          value: function value() {
            this.session = new Ze(!0), this.permanent = new Ze();
          }
        }, {
          key: "setCustomPersisted",
          value: function value(e) {
            this.session = e, this.permanent = e;
          }
        }, {
          key: "enablePersistence",
          value: function value() {
            this.persistenceEnabled = !0;
          }
        }, {
          key: "disablePersistence",
          value: function value() {
            this.persistenceEnabled = !1;
          }
        }, {
          key: "checkStorage",
          value: function value(e) {
            var t = "key-".concat(Date.now()),
                a = "value-".concat(Date.now());
            if (e.set(t, a), e.get(t) !== a) throw new Error("Storage: provided storage object API not working");
            if (e.reset(t), null !== e.get(t)) throw new Error("Storage: provided storage object API not working");
          }
        }, {
          key: "setInternal",
          value: function value(e) {
            V()(e) && (this.internal = e);
          }
        }]), e;
      }(),
          et = function () {
        function e(t, a) {
          var r = this;
          w()(this, e), this.eventChecks = a.checks, this.eventFields = a.fields, this.venonaRequirementsVersion = a.version, this.blacklists = a.blacklists, this.flushedEvents = ye, this.errorCodes = a.errorCodes, this.persistenceRules = a.persistenceRules, this.currentFlow = void 0, this.isUnloading = !1, this.eventFilters = {}, this.settings = {
            endpoint: "https://collector-dev.pi-charter.net/api/collector",
            sendInterval: 1e4,
            maxMessageSize: 5e3,
            heartBeatInterval: 6e4,
            maxBulkQueueSize: 50,
            bulkMessageTTL: 18e5,
            validation: !1,
            filterFields: !0,
            storageDuration: 18e5,
            backgroundedVisitTTL: 18e5,
            isOnline: !0,
            sendRetryInterval: 6e4,
            sendTimeout: 1e4,
            resetStateOnResume: !0,
            maxEventsPerSecond: 20,
            verifyAppNameOnResume: !0,
            renamePlaybackStartDuringRetry: !1
          }, this.onSetCallbacks = {
            maxMessageSize: function maxMessageSize(e) {
              return r.queue.setMaxSize(e);
            },
            isOnline: function isOnline(e, t) {
              return r.connectionChanged(e, t);
            },
            sendInterval: function sendInterval(e) {
              return r.sendTimer.changeInterval(e);
            },
            heartBeatInterval: function heartBeatInterval(e) {
              return r.heartBeatTimer.changeInterval(e);
            },
            maxEventsPerSecond: function maxEventsPerSecond(e) {
              return r.rateLimiter.changeRate(e);
            },
            sendRetryInterval: function sendRetryInterval() {
              return Te.config(r.settings);
            },
            sendTimeout: function sendTimeout() {
              return Te.config(r.settings);
            }
          }, this.libraryVersion = "6.13.0", this.sm = new Z({
            initial: "blank",
            callbacks: t,
            transitions: de,
            name: "Core"
          }), this.queue = new ee(this.settings.maxMessageSize, this.sendMessages.bind(this)), this.bulkQueue = [], this.model = new $(), this.validator = new pe(this.eventChecks, this.model), this.storage = new $e(), this.timestamp = void 0, this.messageId = 0, this.sendTimer = new oe(function () {
            r.queue.flush();
          }, this.settings.sendInterval), this.heartBeatTimer = new oe(function () {
            r.track("playbackHeartbeat");
          }, this.settings.heartBeatInterval), this.features = {
            playback: !0,
            login: !0,
            navigation: !0,
            select: !0,
            search: !0,
            ads: !0,
            error: !0,
            apiCall: !0
          }, this.rateLimiter = new Se(this.settings.maxEventsPerSecond, {
            exceptions: ["customEvent"]
          }), this.handleEvent = this.rateLimiter.wrap(this.handleEvent.bind(this)), this.pendingRequests = [], Te.init(this.settings);
        }

        var t;
        return b()(e, [{
          key: "get",
          value: function value(e) {
            return this.settings[e];
          }
        }, {
          key: "set",
          value: function value(e, t) {
            var a = this.settings[e];
            this.settings[e] = t, this.onSetCallbacks[e] && this.onSetCallbacks[e](t, a), this.saveState();
          }
        }, {
          key: "setFeatures",
          value: function value(e) {
            var t = this;
            Object.keys(e).forEach(function (a) {
              void 0 !== t.features[a] && (t.features[a] = e[a]);
            }), this.saveState();
          }
        }, {
          key: "setEventFilters",
          value: function value(e) {
            this.eventFilters = e;
          }
        }, {
          key: "isDisabled",
          value: function value(e) {
            var t = ge[e];
            return !1 === this.features[t];
          }
        }, {
          key: "connectionChanged",
          value: function value(e, t) {
            !t && e && this.sendBulkMessages();
          }
        }, {
          key: "handleSet",
          value: function value(e, t) {
            var a = this.prepareData(e, C()(t));
            Object.keys(a).some(function (e) {
              return e.includes("visit");
            }) && this.queue.flush(), "setSegment" === e && (this.storage.internal.segmentStorage || (this.storage.internal.segmentStorage = []), this.storage.internal.segmentStorage.push(a)), "setAudioBitRate" === e ? Ye.model.currentAudioBitRateBps = a["state.playback.bitRate.currentAudioBitRateBps"] : this.model.batchSet(a);
          }
        }, {
          key: "handleEvent",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                r = this.prepareData(e, C()(t));
            r && this.track(e, r, a);
          }
        }, {
          key: "track",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            this.isDisabled(e) || this.sm.trigger(e, {
              data: t,
              options: a,
              analytics: this
            });
          }
        }, {
          key: "prepareData",
          value: function value(e, t) {
            var a,
                r = this;

            if (this.eventChecks[e]) {
              var i = this.checkValidation(e, t);
              a = this.mapFields(e, i), Object.keys(a).forEach(function (t) {
                var i = r.eventChecks[e][t].validationRules;
                "string" === i.type[0].value && "string" != typeof a[t] ? a[t] = String(a[t]) : "map" === i.type[0].value && "string" === i.elementType[0].value && Object.keys(a[t]).forEach(function (e) {
                  "string" != typeof a[t][e] && (a[t][e] = String(a[t][e]));
                });
              });
            } else a = {};

            if (!Object.keys(this.eventFilters) || !this.eventFilters[e] || this.checkEventFilterCondition(e, t)) return this.applyBlacklists(e, a), a;
          }
        }, {
          key: "applyBlacklists",
          value: function value(e, t) {
            var a = this;
            Object.keys(t).forEach(function (r) {
              var i = a.eventChecks[e][r].blacklists;
              i && i.forEach(function (e) {
                return a.blacklists[e].forEach(function (e) {
                  var a = new RegExp(e, "i");
                  Array.isArray(t[r]) ? t[r] = t[r].map(function (e) {
                    return a.test(JSON.stringify(e)) ? "[REDACTED]" : e;
                  }) : V()(t[r]) ? Object.keys(t[r]).forEach(function (e) {
                    a.test("".concat(e, ":").concat(JSON.stringify(t[r][e]))) && (t[r][e] = "[REDACTED]");
                  }) : a.test(t[r]) && (t[r] = "[REDACTED]");
                });
              });
            });
          }
        }, {
          key: "checkValidation",
          value: function value(e, t, a) {
            return this.settings.validation && Y.warning("Validation will not work in production build"), t;
          }
        }, {
          key: "mapFields",
          value: function value(e, t) {
            var a = this.eventChecks[e];
            return Object.keys(a).reduce(function (e, r) {
              return void 0 !== t[a[r].venonaKey] && (e[r] = t[a[r].venonaKey]), e;
            }, {});
          }
        }, {
          key: "sendMessages",
          value: function value(e) {
            if (this.sendTimer.start(), 0 !== e.length) {
              var t = function (e, t) {
                var a = ne({
                  domain: t.domain,
                  customer: t.customer,
                  visit: t.visit,
                  messages: e
                });
                return JSON.stringify(a);
              }(e, this.model.getData());

              this.bulkQueue.length > this.settings.maxBulkQueueSize - 1 && this.bulkQueue.shift(), this.bulkQueue.push({
                data: t,
                id: ke(),
                timestamp: Date.now()
              }), this.saveState(), this.sendBulkMessages();
            }
          }
        }, {
          key: "sendBulkMessages",
          value: function value() {
            var e = this;

            if (this.settings.isOnline) {
              var t = Date.now();
              this.bulkQueue.forEach(function (a) {
                t - a.timestamp <= e.settings.bulkMessageTTL && e.handlePost(e.settings.endpoint, a.data, a.id, e.storage.internal.oAuthToken, e.storage.internal.tokenType);
              }), this.bulkQueue = [], this.saveState();
            }
          }
        }, {
          key: "handlePost",
          value: function value(e, t, a, r, i) {
            var n = {
              url: e,
              data: t,
              token: r,
              tokenType: i
            };
            return Te.send(n, a, this.isUnloading);
          }
        }, {
          key: "flush",
          value: (t = x()(O.a.mark(function e() {
            return O.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return this.queue.flush(), e.next = 4, Te.finishRequests();

                  case 4:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function () {
            return t.apply(this, arguments);
          })
        }, {
          key: "isPlayback",
          value: function value(e) {
            return ge[e] && ("playback" === ge[e] || "ads" === ge[e]);
          }
        }, {
          key: "isFeatureFlowEvent",
          value: function value(e) {
            return "pageViewInit" === e || B()(this.eventChecks, [e, "message.context"]);
          }
        }, {
          key: "getStateToPersist",
          value: function value() {
            var e = this.model.getData(),
                t = G()(e, ["domain", "customer", "visit", "state.previousState", "state.view", "state.name", "state.entryTimestamp"]);
            t.state.name = "navigating";
            var a = this.model.get("visit.applicationDetails.applicationName"),
                r = this.model.get("visit.applicationDetails.applicationType");
            return {
              model: ne(t),
              settings: this.settings,
              features: this.features,
              sm: {
                current: "navigating",
                ignored: this.sm.ignored
              },
              messageQueue: {
                buffer: ne(this.queue.buffer),
                currentSize: this.queue.currentSize
              },
              bulkQueue: this.bulkQueue,
              internalStorage: ne(this.storage.internal),
              messageId: this.messageId,
              platform: Re(a, r)
            };
          }
        }, {
          key: "saveState",
          value: function value() {
            if ("blank" !== this.sm.current && this.storage.persistenceEnabled) {
              var e = this.getStateToPersist(),
                  t = e.platform;
              this.storage.session.set("library-state", JSON.stringify(e));
              var a = G()(e.model, ["visit.account", "visit.device", "visit.applicationDetails.appVersion", "visit.applicationDetails.venonaVersion"]);
              M()(a, "visit.previousVisitId", B()(e.model, "visit.visitId")), this.storage.permanent.set("library-state-".concat(t), JSON.stringify(a), this.settings.storageDuration);
            }
          }
        }, {
          key: "removeStoredState",
          value: function value() {
            this.storage.session.reset("library-state");
            var e = Re(this.model.get("visit.applicationDetails.applicationName"), this.model.get("visit.applicationDetails.applicationType"));
            this.storage.permanent.reset("library-state-".concat(e));
          }
        }, {
          key: "getStoredState",
          value: function value(e) {
            var t = e.applicationName,
                a = e.applicationType;

            if (this.storage.persistenceEnabled) {
              var r = Re(t, a);
              return {
                state: this.storage.session.get("library-state"),
                seed: this.storage.permanent.get("library-state-".concat(r))
              };
            }

            return null;
          }
        }, {
          key: "loadPersistedState",
          value: function value(e, t) {
            var a = JSON.parse(e),
                r = a.model.visit.applicationDetails.appVersion,
                i = a.model.visit.applicationDetails.applicationName,
                n = a.model.visit.applicationDetails.venonaVersion;
            return !(r !== t.appVersion || n !== this.libraryVersion || this.settings.verifyAppNameOnResume && i !== t.applicationName || (this.settings = a.settings, this.features = a.features, this.sm.current = a.sm.current, this.sm.setIgnored(a.sm.ignored), this.queue.maxSize = a.settings.maxMessageSize, this.queue.buffer = a.messageQueue.buffer || [], this.queue.currentSize = a.messageQueue.currentSize, this.bulkQueue = a.bulkQueue, this.storage.setInternal(a.internalStorage), this.messageId = a.messageId, this.model.data = a.model, 0));
          }
        }, {
          key: "loadSeedData",
          value: function value(e, t) {
            var a = JSON.parse(e),
                r = a.visit.applicationDetails.appVersion,
                i = a.visit.applicationDetails.venonaVersion;
            return !(r !== t.appVersion || i !== this.libraryVersion || !this.isReferrerValid() || (delete a.visit.applicationDetails, delete t.previousVisitId, this.model.data = a, 0));
          }
        }, {
          key: "isReferrerValid",
          value: function value() {
            return !("undefined" == typeof window || "undefined" == typeof document || !document.referrer) && document.referrer.split("/")[2] === window.location.href.split("/")[2];
          }
        }, {
          key: "checkFlushCondition",
          value: function value(e, t) {
            return !(e.length > 0) || e.some(function (e) {
              return Object.keys(e).every(function (a) {
                var r = "!" === a[0],
                    i = r ? a.slice(1) : a,
                    n = t[i];
                return r ? e[a].every(function (e) {
                  return n !== e;
                }) : e[a].some(function (e) {
                  return n === e;
                });
              });
            });
          }
        }, {
          key: "checkEventFilterCondition",
          value: function value(e, t) {
            var a = this;
            return !this.eventFilters[e].some(function (r) {
              return Object.keys(r).every(function (i) {
                var n = a.eventChecks[e][i].venonaKey,
                    o = t[n];
                return r[i].some(function (e) {
                  return o === e;
                });
              });
            });
          }
        }, {
          key: "setupListeners",
          value: function value() {
            var e = this;
            "undefined" != typeof window && (window.performance && ("complete" === document.readyState ? this.reportPageLoadPerformance() : window.addEventListener("load", this.reportPageLoadPerformance.bind(this))), fe && (window.addEventListener("unload", function () {
              e.isUnloading = !0, e.flush();
            }), window.addEventListener("beforeunload", function () {
              e.isUnloading = !0, e.flush();
            })));
          }
        }, {
          key: "reportPageLoadPerformance",
          value: function value() {
            var e = window.performance.timing;
            if (e) if (this.storage.internal.onPage) {
              var t = {
                "message.eventCaseId": "pageViewPerformance",
                "message.triggeredBy": "analytics",
                "state.view.currentPage.performanceTiming": U()(e, function (e) {
                  return e && "number" == typeof e;
                }),
                "operation.operationType": "domComplete"
              };
              this.track("pageViewPerformance", t);
            } else this.storage.internal.performanceTiming = e;
          }
        }]), e;
      }();

      function tt(e, t) {
        var a = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), a.push.apply(a, r);
        }

        return a;
      }

      function at(e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = null != arguments[t] ? arguments[t] : {};
          t % 2 ? tt(Object(a), !0).forEach(function (t) {
            f()(e, t, a[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : tt(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
          });
        }

        return e;
      }

      var rt = function () {
        function e(t, a) {
          var r = this;
          w()(this, e), this.callbacks = t, this.specs = a, this.core = new et(t, a), this.log = Y, this.errorCodes = this.core.errorCodes.application;
          var i = Object.keys(a.checks),
              n = Object.keys(a.fields),
              o = K()(n, ["pageView"]);
          this.setterNames = K()(i, n, ["pageViewCompleted"]), o.forEach(function (e) {
            r[e] || (r[e] = function (t, a) {
              r.core.handleEvent(e, t, a);
            });
          }), this.setterNames.forEach(function (e) {
            r[e] || (r[e] = function (t) {
              r.core.handleSet(e, t);
            });
          });
        }

        var t;
        return b()(e, [{
          key: "get",
          value: function value(e) {
            return this.core.get(e);
          }
        }, {
          key: "set",
          value: function value(e, t) {
            this.core.set(e, t);
          }
        }, {
          key: "setFeatures",
          value: function value(e) {
            this.core.setFeatures(e);
          }
        }, {
          key: "addIgnoredEvents",
          value: function value(e) {
            return !(!V()(e) || !Object.keys(e).every(function (t) {
              return Array.isArray(e[t]) && e[t].every(function (e) {
                return "string" == typeof e;
              });
            }) || (this.core.sm.setIgnored(e), 0));
          }
        }, {
          key: "setEventFilters",
          value: function value(e) {
            this.core.setEventFilters(e);
          }
        }, {
          key: "getCurrentLibraryState",
          value: function value() {
            return this.core.sm.current;
          }
        }, {
          key: "getVisitId",
          value: function value() {
            return this.core.model.get("visit.visitId");
          }
        }, {
          key: "getExperimentConfigurations",
          value: function value() {
            return {
              experimentUuids: C()(this.core.model.get("visit.experimentUuids")),
              variantUuids: C()(this.core.model.get("visit.variantUuids"))
            };
          }
        }, {
          key: "getSetterNames",
          value: function value() {
            return this.setterNames;
          }
        }, {
          key: "flush",
          value: (t = x()(O.a.mark(function e() {
            return O.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 3, this.core.flush();

                  case 3:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), function () {
            return t.apply(this, arguments);
          })
        }, {
          key: "enablePersistence",
          value: function value() {
            this.core.storage.enablePersistence();
          }
        }, {
          key: "disablePersistence",
          value: function value() {
            this.core.removeStoredState(), this.core.storage.disablePersistence();
          }
        }, {
          key: "setCustomStorage",
          value: function value(e) {
            this.core.storage.setCustomPersisted(e);
          }
        }, {
          key: "removeCustomStorage",
          value: function value() {
            this.core.storage.useDefaultPersisted();
          }
        }, {
          key: "restartFlow",
          value: function value() {
            delete this.core.currentFlow, this.core.model.reset("message.feature");
          }
        }, {
          key: "stop",
          value: function value() {
            this.core.sendTimer.stop(), this.core.heartBeatTimer.stop(), this.core.removeStoredState(), this.core = new et(this.callbacks, this.specs);
          }
        }, {
          key: "startSession",
          value: function value(e, t) {
            this.init(e, t);
          }
        }, {
          key: "init",
          value: function value(e, t) {
            if (this.getCurrentLibraryState() !== this.core.sm.initial) throw new Error("Invalid event");
            var a = this.core.getStoredState(e);
            a && (a.state || a.seed) ? a.state && this.core.loadPersistedState(a.state, e) || (a.seed && this.core.loadSeedData(a.seed, e), this.core.handleEvent("startSession", e, t)) : this.core.handleEvent("startSession", e, t), this.core.setupListeners(), this.core.sendTimer.start();
          }
        }, {
          key: "pageViewInit",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                a = this.core.model.get("state.view.currentPage.renderDetails");

            if (a) {
              var r = a.viewRenderedStatus,
                  i = ["complete", "timeout", "completeWithError", "temporary"],
                  n = !i.includes(a.viewRenderedStatus);
              void 0 !== a.renderInitTimestamp && "completeAwaitingAction" === r ? this.core.track("temporaryView", {}, t) : void 0 !== a.renderInitTimestamp && n && this.core.track("pageView", {
                "message.triggeredBy": this.core.storage.internal.pageViewTriggeredBy,
                "message.category": "navigation",
                "message.eventCaseId": this.core.storage.internal.pageViewEventCaseId
              }, t);
            }

            var o = this.core.checkValidation("pageView", e),
                s = this.core.mapFields("pageView", o);
            this.core.track("pageViewInit", s, at(at({}, t), {}, {
              noMessage: !0
            }));
          }
        }, {
          key: "pageViewPartiallyRendered",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = this.core.model.get("state.view.currentPage.renderDetails.viewRenderedStatus");
            "noRender" === t && this.core.track("pageViewPartiallyRendered", {}, at(at({}, e), {}, {
              noMessage: !0
            }));
          }
        }, {
          key: "pageViewCompleteAwaitingAction",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.core.track("pageViewCompleteAwaitingAction", {}, at(at({}, t), {}, {
              noMessage: !0
            }));
          }
        }, {
          key: "pageViewCompleted",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                a = at(at({}, e), {}, {
              context: this.core.storage.internal.pageViewContext,
              eventCaseId: this.core.storage.internal.pageViewEventCaseId
            }),
                r = this.core.checkValidation("pageViewCompleted", a, {
              safe: ["context", "eventCaseId"]
            }),
                i = this.core.mapFields("pageViewCompleted", r);
            i["state.view.currentPage.renderDetails.viewRenderedStatus"] = "complete", i["message.context"] = r.context, i["message.eventCaseId"] = r.eventCaseId, this.core.track("pageView", i, t);
          }
        }, {
          key: "pageViewTimeout",
          value: function value(e, t) {
            var a = at(at({}, e), {}, {
              context: this.core.storage.internal.pageViewContext,
              eventCaseId: this.core.storage.internal.pageViewEventCaseId
            }),
                r = this.core.checkValidation("pageViewCompleted", a, {
              safe: ["context", "eventCaseId"]
            }),
                i = this.core.mapFields("pageViewCompleted", r);
            i["state.view.currentPage.renderDetails.viewRenderedStatus"] = "timeout", i["message.context"] = r.context, i["message.eventCaseId"] = r.eventCaseId, this.core.track("pageView", i, t);
          }
        }, {
          key: "impressionStop",
          value: function value(e, t) {
            var a = [e.impressionLocation, e.impressionId, e.impressionLocationTmsGuideId].filter(function (e) {
              return e;
            }).join("|");
            a && this.core.storage.internal.impression && this.core.storage.internal.impression[a] && this.core.handleEvent("impressionStop", e, t);
          }
        }]), e;
      }();

      function it(e, t, a, r) {
        r.data["message.triggeredBy"] = "application";
      }

      function nt(e, t, a, r) {
        var i = r.data;
        i["message.triggeredBy"] = i["message.triggeredBy"] || "application", i["message.category"] = "error", i["operation.success"] = !1, i["application.error.errorCode"] || (i["application.error.errorCode"] = "unknown");
      }

      function ot(e, t, a, r) {
        var i = r.data;
        i["message.triggeredBy"] = "application", i["message.category"] = "error", i["application.error.errorType"] = "applicationCrash";
      }

      function st(e, t) {
        var a = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), a.push.apply(a, r);
        }

        return a;
      }

      function lt(e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = null != arguments[t] ? arguments[t] : {};
          t % 2 ? st(Object(a), !0).forEach(function (t) {
            f()(e, t, a[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : st(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
          });
        }

        return e;
      }

      function ut(e, t, a, r) {
        var i = r.analytics,
            n = r.data,
            o = r.options;

        if ((i.flushedEvents.before[e] && i.checkFlushCondition(i.flushedEvents.before[e], n) || "startSession" !== e && Object.keys(n).some(function (e) {
          return e.includes("visit");
        })) && i.queue.flush(), i.previousTimestamp = i.timestamp, o && void 0 !== o.timestamp ? i.timestamp = o.timestamp : i.timestamp = Date.now(), i.currentFlow && i.isFeatureFlowEvent(e) && !n["message.context"] && (Y.info("Exiting feature flow on event ".concat(e, " as we expected a [message.context] value but none was provided")), i.model.reset("message.feature"), delete i.currentFlow), n["message.context"]) {
          if (i.currentFlow !== n["message.context"]) {
            i.currentFlow ? Y.info("Exiting feature flow on event ".concat(e, " - context changed from ").concat(i.currentFlow, " to ").concat(n["message.context"])) : Y.info("Entering new feature flow - ".concat(n["message.context"])), i.currentFlow = n["message.context"];
            var s = "".concat(i.model.get("visit.visitId"), "|").concat(i.timestamp);
            n["message.feature.transactionId"] = s;
          }

          var l = n["message.feature.featureStepName"];

          if (l) {
            i.model.get("message.feature.featureStepName") !== l && (n["message.feature.featureStepChanged"] = !0);
            var u = i.model.get("message.feature.completedSteps") || [];
            u.push(l), i.model.set("message.feature.completedSteps", u);
          }
        }
      }

      function ct(e, t, a, r) {
        var i = r.analytics,
            n = i.model.get("state.name");
        n && (i.model.set("state.previousState.name", n), i.model.set("state.previousState.entryTimestamp", i.model.get("state.entryTimestamp")), i.model.set("state.previousState.exitTimestamp", i.timestamp)), i.model.set("state.name", i.sm.current), i.model.set("state.entryTimestamp", i.timestamp);
      }

      function vt(e, t, a, r) {
        var i = r.analytics,
            n = r.data,
            o = r.options;

        if (i.model.batchSet(n), !o.noMessage) {
          var s = function (e, t, a, r) {
            var i = {
              state: a.state,
              message: a.message,
              operation: a.operation,
              application: a.application,
              performance: a.performance,
              custom: a.custom
            };
            i.message.name = e, i.message.sequenceNumber = r.messageId, i.message.timestamp = r.timestamp, i.message.timeSinceLastEventMs = r.previousTimestamp ? r.timestamp - r.previousTimestamp : 0;
            var n = i;

            if (r.settings.filterFields) {
              var o = r.eventFields[e];
              o && (n = G()(i, o));
            }

            return r.messageId++, C()(n);
          }(e, r.data, i.model.getData(), i);

          i.queue.push(s), (i.flushedEvents.after[e] && i.checkFlushCondition(i.flushedEvents.after[e], n, e) || "buyFlow" === i.currentFlow || "buyFlow2" === i.currentFlow || "preBuyFlow" === i.currentFlow || "postBuyFlow" === i.currentFlow) && i.queue.flush();
          var l = i.model.get("message.feature");
          i.persistenceRules.after.any.forEach(function (e) {
            return i.model.reset(e);
          }), i.persistenceRules.after[e] && i.persistenceRules.after[e].forEach(function (e) {
            return i.model.reset(e);
          }), i.currentFlow && (!i.isFeatureFlowEvent(e) || n["message.context"] && i.currentFlow === n["message.context"]) && (i.model.set("message.feature", l), i.model.set("message.feature.featureStepChanged", !1));
        }

        i.saveState();
      }

      function pt(e, t, a, r) {
        var i = r.data;
        i["message.category"] = "custom", i["message.triggeredBy"] = "application";
      }

      function dt(e, t, a, r) {
        var i = r.analytics,
            n = r.data,
            o = r.options,
            s = {
          "application.error.errorType": "analytics",
          "application.error.errorCode": function (e, t, a) {
            var r = ge[t],
                i = B()(e, [r, a, t]);
            if (i) return i;
            var n = B()(e, [r, a, "default"]);
            return n || B()(e, [r, "default"]) || e.default;
          }(i.errorCodes.state, e, t),
          "application.error.errorMessage": "Unexpected event ".concat(e, " received in state ").concat(t, ". Analytics partially disabled until the next tune"),
          "application.error.errorExtras": n,
          "application.error.clientErrorCode": "".concat(t, ":").concat(e)
        };
        i.applyBlacklists("error", s), s["application.error.errorExtras"] = {
          inputData: JSON.stringify(s["application.error.errorExtras"])
        }, s["message.triggeredBy"] = "analytics", i.heartBeatTimer.stop(), i.track("error", s, o);
      }

      function gt(e, t, a, r) {
        var i = r.analytics,
            n = r.data,
            o = r.options,
            s = {
          "application.error.errorType": "analytics",
          "application.error.errorCode": i.errorCodes.internal.eventBeforeInit,
          "application.error.errorMessage": "Unexpected event ".concat(e, " received before library initialization."),
          "application.error.errorExtras": n
        };
        i.applyBlacklists("error", s), Y.warning("Generating visit ID for error event due to missing startSession"), i.visitIdFromInitError = ke(), (s = lt(lt({}, s), {}, {
          "message.triggeredBy": "analytics",
          "visit.applicationDetails.venonaVersion": i.libraryVersion,
          "visit.device.uuid": ke(),
          "visit.visitId": i.visitIdFromInitError
        }))["application.error.errorExtras"] = {
          inputData: JSON.stringify(s["application.error.errorExtras"])
        }, "undefined" != typeof window && (s["application.error.errorExtras"].userAgent = B()(window, "navigator.userAgent"), s["application.error.errorExtras"].url = B()(window, "location.href"), s["application.error.errorExtras"].pageTitle = B()(window, "document.title")), i.track("error", s, lt(lt({}, o), {}, {
          forceTransitionTo: t
        }));
      }

      var yt = a(9),
          ft = a.n(yt);

      function mt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "authentication", "manualAuth" === n["operation.operationType"] ? (n["message.triggeredBy"] = "user", n["operation.userEntry.entryType"] = "username") : n["message.triggeredBy"] = "application";
        var o = i.model.get("visit.login.failedAttempts");
        n["visit.login.failedAttempts"] = o || 0, i.storage.internal.loginStartTimestamp = i.timestamp, i.storage.internal.operation = {
          "operation.operationType": n["operation.operationType"],
          "operation.userEntry.text": n["operation.userEntry.text"],
          "operation.userEntry.entryType": n["operation.userEntry.entryType"]
        };
      }

      function wt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "authentication", n["message.triggeredBy"] = "application", i.storage.internal.oAuthToken = n.oAuthToken, delete n.oAuthToken, i.storage.internal.tokenType = n.tokenType, delete n.tokenType, n["visit.login.loginCompletedTimestamp"] = i.timestamp;
        var o = i.storage.internal.loginStartTimestamp,
            s = n["visit.login.loginCompletedTimestamp"] - o;

        if (n["visit.login.loginDurationMs"] = s, i.storage.internal.operation && ft()(n, i.storage.internal.operation), !1 === n["operation.success"]) {
          var l = i.model.get("visit.login.failedAttempts");
          n["visit.login.failedAttempts"] = l + 1;
        }
      }

      function ht(e, t, a, r) {
        delete r.analytics.storage.internal.operation;
      }

      function bt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "authentication", n["message.triggeredBy"] = "application", n["operation.operationType"] = "refreshAuth", i.storage.internal.oAuthToken = n.oAuthToken, delete n.oAuthToken, i.storage.internal.tokenType = n.tokenType, delete n.tokenType, !1 === n["operation.success"] && (n["application.error.errorType"] = "authentication");
      }

      function Pt(e, t, a, r) {
        var i = r.data;
        i["message.category"] = "authentication", i["message.triggeredBy"] = "user", i["operation.operationType"] = "logout";
      }

      function Tt(e, t, a, r) {
        var i = r.analytics;
        i.model.set("visit.login.failedAttempts", 0), delete i.storage.internal.loginStartTimestamp, delete i.storage.internal.oAuthToken, delete i.storage.internal.tokenType;
      }

      function St(e, t) {
        var a = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), a.push.apply(a, r);
        }

        return a;
      }

      function kt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        i.storage.internal.impression && (Object.keys(i.storage.internal.impression).forEach(function (e) {
          var t = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var a = null != arguments[t] ? arguments[t] : {};
              t % 2 ? St(Object(a), !0).forEach(function (t) {
                f()(e, t, a[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : St(Object(a)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
              });
            }

            return e;
          }({
            "message.triggeredBy": "analytics"
          }, i.storage.internal.impression[e].data);

          i.track("impressionStop", t);
        }), delete i.storage.internal.impression), i.storage.internal.onPage = !0, i.storage.internal.pageViewTriggeredBy = n["message.triggeredBy"], i.storage.internal.pageViewContext = n["message.context"], i.storage.internal.pageViewEventCaseId = n["message.eventCaseId"], delete n["message.triggeredBy"], delete n["message.context"], delete n["message.eventCaseId"];
        var o,
            s = i.model.get("state.view.currentPage.pageSequenceNumber"),
            l = void 0 !== s ? s + 1 : 0;
        n["state.view.currentPage.pageSequenceNumber"] = l, n["state.view.currentPage.renderDetails.renderInitTimestamp"] = i.timestamp, n["state.view.currentPage.renderDetails.viewRenderedStatus"] = "noRender";
        var u = i.model.get("state.view.currentPage.renderDetails.renderInitTimestamp");
        void 0 !== u && (o = i.timestamp - u), i.model.reset("state.view.modal"), i.model.reset("state.view.device"), "temporary" !== i.model.get("state.view.currentPage.renderDetails.viewRenderedStatus") && (i.model.reset("state.view.previousPage"), i.model.set("state.view.previousPage", i.model.get("state.view.currentPage")), i.model.reset("state.view.previousPage.channelLineup"), i.model.reset("state.view.previousPage.elements"), i.model.reset("state.view.previousPage.navigation"), i.model.reset("state.view.previousPage.renderDetails")), i.model.reset("state.view.currentPage"), i.currentFlow || "productPage" === n["state.view.currentPage.pageName"] || i.model.reset("state.view.content"), void 0 !== o && i.model.set("state.view.previousPage.pageViewedTimeMs", o);
      }

      function Rt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["state.view.currentPage.renderDetails.viewRenderedStatus"] = "completeAwaitingAction";
        var o = i.timestamp - i.model.get("state.view.currentPage.renderDetails.renderInitTimestamp");
        n["state.view.currentPage.renderDetails.fullyRenderedMs"] = o, n["state.view.currentPage.renderDetails.fullyRenderedTimestamp"] = i.timestamp;
      }

      function Et(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "navigation", n["state.view.currentPage.renderDetails.viewRenderedStatus"] = "temporary";
        var o = i.timestamp - i.model.get("state.view.currentPage.renderDetails.renderInitTimestamp");
        n["state.view.currentPage.temporaryViewedTimeMs"] = o;
      }

      function qt(e, t, a, r) {
        var i = r.analytics,
            n = r.data,
            o = i.timestamp - i.model.get("state.view.currentPage.renderDetails.renderInitTimestamp");
        n["state.view.currentPage.renderDetails.partialRenderedMs"] = o, n["state.view.currentPage.renderDetails.partialRenderedTimestamp"] = i.timestamp, n["state.view.currentPage.renderDetails.viewRenderedStatus"] = "partial";
      }

      function Ot(e, t, a, r) {
        var i = r.analytics,
            n = r.data;

        if (n["message.category"] = "navigation", n["message.triggeredBy"] = i.storage.internal.pageViewTriggeredBy, "complete" === n["state.view.currentPage.renderDetails.viewRenderedStatus"]) {
          var o = i.model.get("state.view.currentPage.renderDetails.viewRenderedStatus"),
              s = i.timestamp - i.model.get("state.view.currentPage.renderDetails.renderInitTimestamp");
          "completeAwaitingAction" !== o && (n["state.view.currentPage.renderDetails.fullyRenderedTimestamp"] = i.timestamp, n["state.view.currentPage.renderDetails.fullyRenderedMs"] = s);
          var l = i.model.get("state.view.currentPage.renderDetails.isLazyLoad"),
              u = i.model.get("state.view.currentPage.renderDetails.partialRenderedTimestamp") || i.model.get("state.view.currentPage.renderDetails.partialRenderedMs");
          l && u || (n["state.view.currentPage.renderDetails.partialRenderedTimestamp"] = i.timestamp, n["state.view.currentPage.renderDetails.partialRenderedMs"] = s);
        }

        if ("search" === i.model.get("state.view.currentPage.pageName") && i.storage.internal.searchObject) {
          var c = i.storage.internal.searchObject;
          ft()(n, c);
        }
      }

      function It(e, t, a, r) {
        var i = r.analytics,
            n = i.storage.internal.performanceTiming;

        if (n) {
          var o = {
            "message.eventCaseId": "pageViewPerformance",
            "message.triggeredBy": "analytics",
            "state.view.currentPage.performanceTiming": U()(n, function (e) {
              return e && "number" == typeof e;
            }),
            "operation.operationType": "domContentLoaded"
          };
          i.track("pageViewPerformance", o), delete i.storage.internal.performanceTiming;
        }
      }

      function xt(e, t, a, r) {
        var i = r.data,
            n = r.analytics;
        i["message.category"] = "navigation", n.model.reset("state.view.modal");
      }

      function At(e, t, a, r) {
        var i = r.data;
        i["message.category"] = "contentDiscovery", i["message.triggeredBy"] = "user";
      }

      function Ct(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "contentDiscovery", i.storage.internal.preferences && ft()(n, i.storage.internal.preferences);
      }

      function Dt(e, t, a, r) {
        delete r.analytics.storage.internal.preferences;
      }

      function Kt(e, t, a, r) {
        r.data["message.triggeredBy"] = "user";
      }

      function Nt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        i.storage.internal.preferences && ft()(n, i.storage.internal.preferences);
      }

      function Vt(e, t, a, r) {
        delete r.analytics.storage.internal.preferences;
      }

      function Ft(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        if (n["message.category"] = "navigation", "backgrounded" === n["operation.operationType"]) i.model.set("visit.applicationDetails.appBackgroundedTimestamp", i.timestamp), i.model.set("visit.inFocus", !1);else if ("foregrounded" === n["operation.operationType"]) {
          var o = i.model.get("visit.applicationDetails.appBackgroundedTimestamp");
          i.settings.backgroundedVisitTTL && o && i.timestamp - o >= i.settings.backgroundedVisitTTL && i.track("startSession", {
            "visit.connection.connectionType": i.model.get("visit.connection.connectionType"),
            "visit.previousVisitId": i.model.get("visit.visitId")
          }, {
            forceTransitionTo: i.settings.resetStateOnResume ? "appInitializing" : i.sm.current,
            timestamp: i.timestamp
          }), i.model.set("visit.inFocus", !0);
        }
      }

      function Mt(e, t, a, r) {
        var i = r.analytics;
        "foregrounded" === r.data["operation.operationType"] && i.model.reset("visit.applicationDetails.appBackgroundedTimestamp");
      }

      function jt(e, t, a, r) {
        r.data["message.category"] = "navigation";
      }

      function Bt(e, t, a, r) {
        var i = r.data;
        i["message.category"] = "navigation", i["message.triggeredBy"] = i["message.triggeredBy"] || "application";
      }

      function Lt(e, t, a, r) {
        r.data["message.category"] = "navigation";
      }

      function Ut(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "navigation", n["message.triggeredBy"] = "user", i.model.reset("state.referrer.instanceCampaignId");
      }

      function _t(e, t, a, r) {
        r.data["message.category"] = "navigation";
      }

      function Gt(e, t, a, r) {
        r.data["message.category"] = "navigation";
      }

      function Ht(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        i.storage.internal.impression || (i.storage.internal.impression = {});
        var o = [n["state.impression.location"], n["state.impression.id"], n["state.impression.locationTmsGuideId"]].filter(function (e) {
          return e;
        }).join("|");

        if (o) {
          var s = C()(n);
          delete s["message.eventCaseId"], i.storage.internal.impression[o] = {
            timestamp: i.timestamp,
            data: s
          };
        }

        n["message.category"] = "navigation", n["message.triggeredBy"] = "application";
      }

      function zt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "navigation", n["message.triggeredBy"] = n["message.triggeredBy"] || "application";
        var o = [n["state.impression.location"], n["state.impression.id"], n["state.impression.locationTmsGuideId"]].filter(function (e) {
          return e;
        }).join("|");
        i.storage.internal.impression && i.storage.internal.impression[o] && (n["state.impression.viewedTime"] = i.timestamp - i.storage.internal.impression[o].timestamp, Object.assign(n, i.storage.internal.impression[o].data), delete i.storage.internal.impression[o]);
      }

      function Jt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "search", n["operation.operationType"] = "searchEntered", "search" === i.model.get("state.view.currentPage.pageName") && (i.storage.internal.searchObject = {
          "state.search.numberOfSearchResults": n["state.search.numberOfSearchResults"],
          "state.search.selectedResultName": n["state.search.selectedResultName"],
          "state.search.selectedResultFacet": n["state.search.selectedResultFacet"],
          "state.search.text": n["state.search.text"],
          "state.search.searchType": n["state.search.searchType"],
          "state.search.results": n["state.search.results"],
          "state.search.searchResults": n["state.search.searchResults"],
          "state.search.resultsMs": n["state.search.resultsMs"],
          "state.search.queryId": n["state.search.queryId"],
          "state.search.searchId": n["state.search.searchId"]
        });
      }

      function Wt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "search", n["message.triggeredBy"] = "user", delete i.storage.internal.searchObject, i.model.set("operation.operationType", "searchClosed");
      }

      function Qt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        (n["operation.userPreferencesSelections"] || n["operation.userPreferenceCategory"]) && (i.storage.internal.preferences = {
          "operation.userPreferencesSelections": n["operation.userPreferencesSelections"],
          "operation.userPreferenceCategory": n["operation.userPreferenceCategory"]
        });
      }

      function Xt(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "application", n["message.triggeredBy"] = "user", n["visit.visitId"] = i.visitIdFromInitError || n["visit.visitId"] || ke(), delete i.visitIdFromInitError, !n["visit.connection.connectionType"] && i.model.set("visit.connection.connectionType", "unknown"), void 0 === n["visit.inFocus"] && (n["visit.inFocus"] = !0), i.model.set("visit.appSessionId", i.model.get("visit.appSessionId") || ke()), i.model.set("visit.visitStartTimestamp", i.timestamp), i.model.set("visit.applicationDetails.venonaVersion", i.libraryVersion), i.model.set("visit.applicationDetails.venonaRequirementsVersion", i.venonaRequirementsVersion), i.storage.permanent.isAvailable && i.storage.permanent.get("library-first-launch") ? n["visit.firstLaunch"] = !1 : (Y.info("Callbacks::onBeforeStartSession(): First launch, saving token to storage"), i.storage.permanent.isAvailable && i.storage.permanent.set("library-first-launch", !0), n["visit.firstLaunch"] = !0);
      }

      function Yt(e, t, a, r) {
        var i = r.data;
        i["message.category"] = "application", i["message.triggeredBy"] = "application";
      }

      function Zt(e, t, a, r) {
        var i = r.data;
        i["message.category"] = "application", i["message.triggeredBy"] = "application";
      }

      function $t(e, t, a, r) {
        r.data["message.category"] = "application";
      }

      function ea(e, t) {
        var a = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), a.push.apply(a, r);
        }

        return a;
      }

      function ta(e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ea(Object(a), !0).forEach(function (t) {
            f()(e, t, a[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ea(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
          });
        }

        return e;
      }

      function aa(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "authentication", n["message.triggeredBy"] = "application", i.storage.internal.oAuthToken = n.oAuthToken, delete n.oAuthToken, i.storage.internal.tokenType = n.tokenType, delete n.tokenType, n["visit.login.loginCompletedTimestamp"] = i.timestamp;
        var o = i.storage.internal.loginStartTimestamp,
            s = n["visit.login.loginCompletedTimestamp"] - o;

        if (n["visit.login.loginDurationMs"] = s, i.storage.internal.operation && ft()(n, i.storage.internal.operation), !1 === n["operation.success"]) {
          var l = i.model.get("visit.login.failedAttempts");
          n["visit.login.failedAttempts"] = l + 1;
        } else n["visit.login.loggedIn"] = "true";
      }

      function ra(e, t, a, r) {
        var i = r.analytics;
        i.model.set("visit.login.failedAttempts", 0), i.model.set("visit.login.loggedIn", "false"), delete i.storage.internal.loginStartTimestamp, delete i.storage.internal.oAuthToken, delete i.storage.internal.tokenType;
      }

      function ia(e, t, a, r) {
        var i = r.analytics,
            n = r.data;
        n["message.category"] = "application", n["message.triggeredBy"] = "user", n["visit.visitId"] = i.visitIdFromInitError || n["visit.visitId"] || ke(), delete i.visitIdFromInitError, !n["visit.connection.connectionType"] && i.model.set("visit.connection.connectionType", "unknown"), n["visit.login.loggedIn"] = "false", void 0 === n["visit.inFocus"] && (n["visit.inFocus"] = !0), i.model.set("visit.appSessionId", i.model.get("visit.appSessionId") || ke()), i.model.set("visit.visitStartTimestamp", i.timestamp), i.model.set("visit.applicationDetails.venonaVersion", i.libraryVersion), i.model.set("visit.applicationDetails.venonaRequirementsVersion", i.venonaRequirementsVersion), i.storage.permanent.isAvailable && i.storage.permanent.get("library-first-launch") ? n["visit.firstLaunch"] = !1 : (Y.info("Callbacks::onBeforeStartSession(): First launch, saving token to storage"), i.storage.permanent.set("library-first-launch", !0), n["visit.firstLaunch"] = !0);
      }

      function na(e, t, a, r) {
        var i = r.data;
        i["message.category"] = "application", i["message.triggeredBy"] = "application";
      }

      function oa(e, t, a, r) {
        r.data["message.category"] = "navigation";
      }

      function sa(e, t, a, r) {
        r.analytics.model.reset("state.view.modal");
      }

      function la(e, t, a, r) {
        r.data["message.notification.notificationId"] = ke();
      }

      function ua(e, t) {
        var a = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), a.push.apply(a, r);
        }

        return a;
      }

      function ca(e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ua(Object(a), !0).forEach(function (t) {
            f()(e, t, a[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ua(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
          });
        }

        return e;
      }

      var va = ca(ca(ca(ca({}, ta(ta(ta(ta(ta(ta(ta(ta({}, i), n), o), s), l), u), c), v)), p), d), g),
          pa = a(61);

      function da(e, t) {
        var a = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t && (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), a.push.apply(a, r);
        }

        return a;
      }

      function ga(e) {
        for (var t = 1; t < arguments.length; t++) {
          var a = null != arguments[t] ? arguments[t] : {};
          t % 2 ? da(Object(a), !0).forEach(function (t) {
            f()(e, t, a[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : da(Object(a)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
          });
        }

        return e;
      }

      var ya = function (e) {
        T()(a, e);

        var t = function (e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;

            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();

          return function () {
            var a,
                r = E()(e);

            if (t) {
              var i = E()(this).constructor;
              a = Reflect.construct(r, arguments, i);
            } else a = r.apply(this, arguments);

            return k()(this, a);
          };
        }(a);

        function a() {
          return w()(this, a), t.apply(this, arguments);
        }

        return b()(a, [{
          key: "pageViewCompletedWithError",
          value: function value(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                a = ga(ga({}, e), {}, {
              context: this.core.storage.internal.pageViewContext,
              eventCaseId: this.core.storage.internal.pageViewEventCaseId
            }),
                r = this.core.checkValidation("pageViewCompleted", a, {
              safe: ["context", "eventCaseId"]
            }),
                i = this.core.mapFields("pageViewCompleted", r);
            i["state.view.currentPage.renderDetails.viewRenderedStatus"] = "completeWithError", i["message.context"] = r.context, i["message.eventCaseId"] = r.eventCaseId, this.core.track("pageView", i, t);
          }
        }]), a;
      }(rt);

      t.default = new ya(va, pa);
    }]);
  }, function (e, t, a) {
    "use strict";

    a.r(t);
    var r = a(5),
        i = a.n(r),
        n = a(0),
        o = a.n(n),
        s = a(1),
        l = a.n(s),
        u = a(7),
        c = a.n(u),
        v = a(8),
        p = a.n(v),
        d = a(4),
        g = a.n(d),
        y = a(6),
        f = a.n(y),
        m = a(2),
        w = a.n(m),
        h = a(3),
        b = a.n(h),
        P = a(9),
        T = a.n(P),
        S = a(13),
        k = a.n(S);

    function R(e, t) {
      var a = console,
          r = "",
          i = f()(t),
          n = Object.prototype.toString.call(t);

      switch (i) {
        case "boolean":
          !0 === t ? (r = "".concat(e, ": %c TRUE"), a.log(r, "color: green; font-style: italic")) : !1 === t && (r = "".concat(e, ": %c FALSE"), a.log(r, "color: red; font-style: italic"));
          break;

        case "number":
          r = "".concat(e, ": %c ").concat(t), t > 0 ? a.log(r, "color: SaddleBrown") : a.log(r, "color: Tomato; font-style: italic");
          break;

        case "string":
          r = "".concat(e, ': %c "').concat(t, '"'), a.log(r, "color: light gray");
          break;

        case "function":
          r = "%c".concat(e, "()"), a.log(r, "color: DarkCyan");
          break;

        case "undefined":
          r = "".concat(e, ": %c UNDEFINED"), a.log(r, "color: Chocolate; font-style: italic");
          break;

        case "null":
          r = "".concat(e, ": %c NULL"), a.log(r, "color: Brown; font-style: italic");
          break;

        case "object":
          !function (e, t, a, r) {
            var i = console;
            if ("[object Date]" === e) return t = "".concat(a, ": %c ").concat(r.toLocaleString(), " (date)"), void i.log(t, "color: DarkGreen");
            if (null === r) return t = "".concat(a, ": %c NULL"), void i.log(t, "color: Brown; font-style: italic");
            if ("_isAMomentObject" in r) return t = "".concat(a, ": %c ").concat(r.format("lll"), " (moment)"), void i.log(t, "color: ForestGreen");
            if (0 === Object.keys(r).length) return t = "".concat(a, ": %c ").concat(JSON.stringify(r)), void i.log(t, "color: DeepPink");

            var n = function (e) {
              try {
                JSON.stringify(e);
              } catch (e) {
                return 20;
              }

              return Object.keys(e).length;
            }(r),
                o = r,
                s = {};

            if (Object.keys(o).sort().forEach(function (e) {
              s[e] = o[e];
            }), !(n > 0 && n < 20)) return i.groupCollapsed("".concat(a, " (x)")), i.log(r), void i.groupEnd();
            i.groupCollapsed("".concat(a, " [").concat(Object.keys(r).length, "]")), Object.getOwnPropertyNames(s).forEach(function (e) {
              return R(e, r[e]);
            });
            i.groupEnd();
          }(n, r, e, t);
          break;

        default:
          a.log("*TYPE: ", i), a.log(e, ":", t);
      }
    }

    var E = {
      debug: 1,
      info: 10,
      warn: 20,
      error: 30,
      critical: 50
    },
        q = new (function () {
      function e() {
        o()(this, e), this._level = E.critical;
      }

      return l()(e, [{
        key: "setLevel",
        value: function value(e) {
          e in E && (this._level = E[e]);
        }
      }, {
        key: "write",
        value: function value(e) {
          var t = e.level,
              a = void 0 === t ? "info" : t,
              r = e.message,
              i = e.payload,
              n = e.color;

          if (console) {
            var o,
                s,
                l = console;
            if (a && !(E[a] < this._level)) if ("function" == typeof l[a]) {
              if (i && "string" != typeof i && "number" !== i) try {
                var u = {},
                    c = 0;
                Object.keys(i).sort().forEach(function (e) {
                  c++, u[e] = i[e];
                }), l.groupCollapsed("%c[Helix] %c".concat(r, " %c- %c(").concat(c, ")"), "color: gray;", "color: silver;", "color: ".concat(n, ";"), "color: white;"), o = u, 1 === (s = Object.keys(o)).length ? R(s[0], o[s[0]]) : s.forEach(function (e) {
                  return R(e, o[e]);
                }), l.groupEnd();
              } catch (e) {
                l.groupEnd(), l[a].call(i), l[a].call(e);
              } else l[a].call(l, "%c[Helix] %c".concat(r, "  %c").concat(i || ""), "color: gray;", "color: silver;", "color: ".concat(n, ";"));
            } else "function" == typeof l.log && l.log("[helix] (".concat(a.toUpperCase(), ") ").concat(r));
          }
        }
      }, {
        key: "debug",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          this.write({
            level: "debug",
            color: "blue",
            message: e,
            payload: t
          });
        }
      }, {
        key: "info",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          this.write({
            level: "info",
            color: "green",
            message: e,
            payload: t
          });
        }
      }, {
        key: "warn",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          this.write({
            level: "warn",
            color: "orange",
            message: e,
            payload: t
          });
        }
      }, {
        key: "error",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          this.write({
            level: "error",
            color: "red",
            message: e,
            payload: t
          });
        }
      }]), e;
    }())(),
        O = function () {
      function e() {
        o()(this, e);
      }

      return l()(e, null, [{
        key: "init",
        value: function value(t) {
          Object.keys(t).forEach(function (a) {
            e.dictionary[t[a]] = a;
          });
        }
      }, {
        key: "getValue",
        value: function value(e) {
          return this.dictionary[e];
        }
      }]), e;
    }();

    O.dictionary = {};

    var I = function () {
      function e() {
        o()(this, e);
      }

      return l()(e, null, [{
        key: "getField",
        value: function value(t) {
          return e.FieldEnum[t];
        }
      }]), e;
    }();

    I.FieldEnum = {
      1: "trackerType",
      2: "eventType",
      3: "properties",
      4: "type",
      5: "source",
      6: "required",
      7: "valid"
    };

    var x = function () {
      function e() {
        o()(this, e);
      }

      return l()(e, null, [{
        key: "getTrackerType",
        value: function value(t) {
          return e.TrackerTypeEnum[parseInt(t, 10)];
        }
      }, {
        key: "getEventType",
        value: function value(t) {
          return e.EventTypeEnum[parseInt(t, 10)];
        }
      }, {
        key: "getDecoderEventTypes",
        value: function value() {
          return e.EventTypeEnum;
        }
      }, {
        key: "getType",
        value: function value(t) {
          return e.TypeEnum[parseInt(t, 10)];
        }
      }, {
        key: "getSource",
        value: function value(t) {
          return e.SourceEnum[parseInt(t, 10)];
        }
      }, {
        key: "getRequired",
        value: function value(t) {
          return e.RequiredEnum[parseInt(t, 10)];
        }
      }]), e;
    }();

    x.TrackerTypeEnum = {
      1: "Venona",
      2: "RTCCA",
      3: "Adobe",
      4: "Tealium"
    }, x.EventTypeEnum = {
      1: "startSession",
      2: "loginStart",
      3: "loginStop",
      4: "apiCall",
      5: "selectAction",
      6: "pageView",
      7: "modalView",
      8: "modalCancel",
      9: "purchaseStart",
      10: "purchaseStop",
      11: "logout",
      12: "searched",
      13: "searchClosed",
      14: "error",
      15: "deviceConfigSet",
      16: "userConfigSet",
      17: "applicationActivity",
      18: "featureStart",
      19: "featureStop",
      20: "pageViewPerformance",
      21: "selectContent",
      22: "adBreakStart",
      23: "adBreakStop",
      24: "adStart",
      25: "adStop",
      26: "applicationCrash",
      27: "attemptRestart",
      28: "bufferingStart",
      29: "bufferingStop",
      30: "checkAvailableChannels",
      31: "connectionChange",
      32: "displayChange",
      33: "externalAppStateChange",
      34: "forcedLogin",
      35: "inVisitOauthRefresh",
      36: "pinEntry",
      37: "playbackBitRateDownshift",
      38: "playbackBitRateUpshift",
      39: "playbackExitBeforeStart",
      40: "playbackFailure",
      41: "playbackHeartbeat",
      42: "playbackPause",
      43: "playbackSelect",
      44: "playbackStart",
      45: "playbackStop",
      46: "playbackStreamUriAcquired",
      47: "playbackTrickPlayRateChange",
      48: "playbackTrickPlayStart",
      49: "playbackTrickPlayStop",
      50: "playbackUnpause",
      51: "requestToCancelRecording",
      52: "requestToDeleteRecording",
      53: "requestToDeleteReminder",
      54: "requestToEditRecording",
      55: "requestToEditReminder",
      56: "requestToRecord",
      57: "requestToRemind",
      58: "switchScreen",
      77: "userFeedback",
      78: "playbackFailureBeforeRetry",
      79: "assetDisplayed",
      80: "applicationPerformance",
      81: "customEvent",
      82: "impressionStart",
      83: "impressionStop",
      84: "modalClose",
      85: "deeplinkStop",
      86: "playbackStartAfterRetry",
      87: "deeplinkStart",
      88: "concurrencyChange",
      89: "pushNotification",
      90: "webSocketActivity",
      91: "webSocketError",
      92: "webSocketClose",
      93: "webSocketOpen",
      94: "temporaryView",
      95: "webSocketHeartbeat"
    }, x.TypeEnum = {
      1: "string",
      2: "int",
      3: "double",
      4: "long",
      5: "datetime",
      6: "boolean",
      7: "map",
      8: "[string]",
      9: "[int]",
      10: "[double]",
      11: "[long]",
      12: "[datetime]",
      13: "[map]",
      14: "[component]"
    }, x.SourceEnum = {
      1: "client",
      2: "sdk"
    }, x.RequiredEnum = {
      1: "null",
      2: "false",
      3: "true"
    };

    var A = function () {
      function e(t, a, r) {
        o()(this, e), this.name = t, this.type = null, this.trackerType = null, this.source = null, this.valid = [], this.populatedFields = [], this.requiredTrackers = {}, null != a && this.init(a, r);
      }

      return l()(e, [{
        key: "init",
        value: function value(t, a) {
          var r,
              i = this;
          Object.keys(t).forEach(function (n) {
            switch (r = I.getField(n), i.populatedFields.push(r), r) {
              case "type":
                i.type = x.getType(t[n]);
                break;

              case "source":
                i.source = x.getSource(t[n]);
                break;

              case "required":
                i.getRequired(t[n], a);
                break;

              case "valid":
                i.valid = e.getOptions(t[n]);
            }
          });
        }
      }, {
        key: "isSupported",
        value: function value(e) {
          return void 0 !== this.requiredTrackers[e];
        }
      }, {
        key: "getRequired",
        value: function value(e, t) {
          for (var a = 0; a < e.length; a += 1) {
            "null" !== x.getRequired(e[a]) && (this.requiredTrackers[t[a]] = "true" === x.getRequired(e[a]));
          }
        }
      }, {
        key: "inherit",
        value: function value(t) {
          var a = this,
              r = new e();
          return r.name = this.name, -1 === this.populatedFields.indexOf("type") ? r.type = t.type : r.type = this.type, -1 === this.populatedFields.indexOf("source") ? r.source = t.source : r.source = this.source, -1 === this.populatedFields.indexOf("required") ? Object.keys(t.requiredTrackers).forEach(function (e) {
            r.requiredTrackers[e] = t.requiredTrackers[e];
          }) : Object.keys(this.requiredTrackers).forEach(function (e) {
            r.requiredTrackers[e] = a.requiredTrackers[e];
          }), -1 === this.populatedFields.indexOf("valid") ? r.valid = t.valid : r.valid = this.valid, r;
        }
      }, {
        key: "clone",
        value: function value() {
          var t = this,
              a = new e(this.name, null, null);
          return a.name = this.name, a.trackerType = this.trackerType, a.type = this.type, a.source = this.source, Object.keys(this.populatedFields).forEach(function (e) {
            a.populatedFields.push(t.populatedFields[e]);
          }), Object.keys(this.requiredTrackers).forEach(function (e) {
            a.requiredTrackers[e] = t.requiredTrackers[e];
          }), a;
        }
      }, {
        key: "required",
        get: function get() {
          if (!this.isSupported(this.trackerType)) throw new Error("Property is not supported with provided tracker!");
          return this.requiredTrackers[this.trackerType];
        }
      }], [{
        key: "getOptions",
        value: function value(e) {
          var t = [];
          return Object.keys(e).forEach(function (a) {
            t.push(O.getValue(e[a]));
          }), t;
        }
      }]), e;
    }(),
        C = {},
        D = function () {
      function e(t, a) {
        o()(this, e), this.name = t, this.trackerType = [], this.eventType = null, this.properties = {}, a && this.init(a);
      }

      return l()(e, [{
        key: "init",
        value: function value(e) {
          var t,
              a,
              r,
              i = this;
          Object.keys(e).forEach(function (n) {
            if ("trackerType" === I.getField(parseInt(n, 10))) for (var o = 0; o < e[n].length; o += 1) {
              a = x.getTrackerType(e[n][o]), i.trackerType.push(a);
            } else "eventType" === I.getField(parseInt(n, 10)) ? (r = x.getEventType(e[n]), i.eventType = C[r]) : "properties" === I.getField(parseInt(n, 10)) && Object.keys(e[n]).forEach(function (a) {
              r = O.getValue(a), t = new A(r, e[n][a], i.trackerType), i.properties[r] = t;
            });
          });
        }
      }, {
        key: "isSupported",
        value: function value(e) {
          for (var t = 0; t < this.trackerType.length; t += 1) {
            if (this.trackerType[t] === e) return !0;
          }

          return !1;
        }
      }]), e;
    }();

    function K(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var a,
            r = g()(e);

        if (t) {
          var i = g()(this).constructor;
          a = Reflect.construct(r, arguments, i);
        } else a = r.apply(this, arguments);

        return p()(this, a);
      };
    }

    var N = function (e) {
      c()(a, e);
      var t = K(a);

      function a() {
        return o()(this, a), t.apply(this, arguments);
      }

      return a;
    }(D),
        V = function () {
      function e(t) {
        o()(this, e), this.eventTypes = C, this.init(t);
      }

      return l()(e, [{
        key: "init",
        value: function value(e) {
          var t = this;

          try {
            Object.keys(e).forEach(function (a) {
              t.eventTypes[a] = new N(a, e[a]);
            });
          } catch (e) {
            throw new Error("EventTypeManager.init err: ".concat(e));
          }
        }
      }, {
        key: "getEventType",
        value: function value(e) {
          return this.eventTypes[e];
        }
      }]), e;
    }();

    function F(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var a,
            r = g()(e);

        if (t) {
          var i = g()(this).constructor;
          a = Reflect.construct(r, arguments, i);
        } else a = r.apply(this, arguments);

        return p()(this, a);
      };
    }

    var M = function (e) {
      c()(a, e);
      var t = F(a);

      function a() {
        return o()(this, a), t.apply(this, arguments);
      }

      return l()(a, [{
        key: "inherit",
        value: function value(e) {
          var t,
              r = this,
              i = {},
              n = new a(this.name, null);
          n.name = this.name, n.eventType = this.eventType, n.trackerType = this.trackerType;
          var o = {};
          return Object.keys(this.eventType.properties).forEach(function (e) {
            o[e] = r.eventType.properties[e];
          }), Object.keys(this.properties).forEach(function (a) {
            void 0 === (t = o[a]) ? ((t = r.properties[a].clone()).trackerType = e, i[a] = t) : ((t = r.properties[a].inherit(t)).trackerType = e, i[a] = t);
          }), Object.keys(o).forEach(function (a) {
            void 0 === i[a] && ((t = o[a].clone()).trackerType = e, i[a] = t);
          }), Object.keys(i).forEach(function (t) {
            !i[t].isSupported(e) || "client" !== i[t].source && "client" !== i[t].source || (n.properties[t] = i[t]);
          }), n;
        }
      }]), a;
    }(D),
        j = function j(e) {
      return null == e;
    },
        B = function () {
      function e(t) {
        o()(this, e), this.eventCases = [], this.init(t);
      }

      return l()(e, [{
        key: "init",
        value: function value(e) {
          var t = this;
          Object.keys(e).forEach(function (a) {
            t.eventCases[a] = new M(a, e[a]);
          });
        }
      }, {
        key: "getNumEventCases",
        value: function value() {
          var e = 0;
          return Object.keys(this.eventCases).forEach(function () {
            e += 1;
          }), e;
        }
      }, {
        key: "getEventCase",
        value: function value(e, t) {
          var a = this.eventCases[e];

          if (!j(a) && !j(a.eventType)) {
            if (!t) return a;
            if (a.isSupported(t)) return a = a.inherit(t);
          }
        }
      }]), e;
    }(),
        L = function () {
      function e() {
        o()(this, e);
      }

      return l()(e, null, [{
        key: "init",
        value: function value(t) {
          O.init(t.keys), e.eventTypeManager = new V(t.eventTypes), e.eventCaseManager = new B(t.eventCases);
        }
      }, {
        key: "getEventType",
        value: function value(e) {
          return C[e];
        }
      }, {
        key: "getEventCase",
        value: function value(t, a) {
          return e.eventCaseManager.getEventCase(t, a);
        }
      }, {
        key: "getEventsLoaded",
        value: function value() {
          return !(!e.eventCaseManager || !e.eventCaseManager.getNumEventCases) && e.eventCaseManager.getNumEventCases() > 0;
        }
      }, {
        key: "clearTrackerManager",
        value: function value() {
          e.eventTypeManager = {}, e.eventCaseManager = {};
        }
      }]), e;
    }();

    L.eventTypeManager = {
      getEventType: function getEventType() {}
    }, L.eventCaseManager = {
      getEventCase: function getEventCase() {}
    };

    var U = a(14),
        _ = function _(e) {
      return null !== e && "object" === f()(e) && !Array.isArray(e);
    },
        G = function G(e) {
      return _(e) ? 0 === Object.keys(e).length : Array.isArray(e) ? 0 === e.length : "string" == typeof e && !e;
    },
        H = function H(e) {
      return null == e;
    },
        z = function z(e) {
      var t = {};

      try {
        if (e && e.length > 0) {
          t = k()(e, 1)[0];

          for (var a = 1; a < e.length; a += 1) {
            t = Object.assign(t, e[a]);
          }
        }
      } catch (e) {
        q.error(JSON.stringify(e));
      }

      return t;
    },
        J = function J(e) {
      return Object.keys(e).reduce(function (t, a) {
        if (Array.isArray(e[a].valid) && 1 === e[a].valid.length) {
          var r = e[a].valid[0];

          t[a] = function (e, t) {
            if (H(e)) return null;

            switch (t) {
              case "boolean":
              case "bool":
                return "true" === e;

              case "int":
              case "long":
              case "double":
              case "number":
                return Number(e);

              default:
                return e;
            }
          }(r, e[a].type);
        }

        return t;
      }, {});
    },
        W = function e() {
      for (var t = arguments.length, a = new Array(t), r = 0; r < t; r++) {
        a[r] = arguments[r];
      }

      return a.reduce(function (t, a) {
        var r = a;
        return Array.isArray(r) && (r = z(r)), _(r) ? (Object.keys(r).forEach(function (a) {
          var i,
              n = t[a],
              o = r[a];
          Array.isArray(n) && Array.isArray(o) ? t[a] = (i = t[a]).concat.apply(i, T()(o)) : _(n) && _(o) ? t[a] = e(n, o) : t[a] = H(o) ? n : o;
        }), t) : t;
      }, {});
    },
        Q = function Q() {
      return U.version;
    },
        X = function X(e) {
      return !(H(e) || H(e.eventCases) || H(e.eventTypes) || H(e["tracker-mappings"])) && !(G(e.eventCases) || G(e.eventTypes) || G(e["tracker-mappings"]));
    },
        Y = function Y(e, t) {
      var a = JSON.parse(e.response),
          r = t.includes("cfg_");
      return !G(a) && (r ? !H(a.config) && !H(a.specsHash) : X(a));
    },
        Z = {
      getStorage: function getStorage() {
        return null === this._storage ? null : this._storage || self.localStorage;
      },
      setCustomStorage: function setCustomStorage(e) {
        "function" != typeof e || e.get("library-debugger") || e.setItem("library-debugger", JSON.stringify({
          forceLogInfo: !1
        })), this._storage = e;
      },
      resetStorage: function resetStorage() {
        this._storage = self.localStorage;
      },
      removeCustomStorage: function removeCustomStorage() {
        this._storage = null;
      }
    },
        $ = Z,
        ee = function ee(e) {
      if (Z.getStorage() && e) {
        var t = Z.getStorage().getItem(e);
        if (t) try {
          return JSON.parse(t);
        } catch (e) {
          return t;
        }
      }
    },
        te = function te(e, t) {
      if (Z.getStorage() && t && e) {
        var a = "object" === f()(t) ? JSON.stringify(t) : t;
        Z.getStorage().setItem(e, a);
      }
    },
        ae = function ae(e) {
      if (Z.getStorage()) try {
        Z.getStorage().removeItem(e);
      } catch (t) {
        try {
          Z.getStorage().reset(e);
        } catch (e) {
          return;
        }
      }
    },
        re = "requirements",
        ie = "library-state",
        ne = "ClickTaleUnMaskPII",
        oe = "library-debugger",
        se = function se(e) {
      if ("undefined" != typeof window && "undefined" != typeof sessionStorage && e) {
        var t = sessionStorage.getItem(e);
        if (t) try {
          return JSON.parse(t);
        } catch (e) {
          return t;
        }
      }
    },
        le = a(10),
        ue = a(14);

    function ce(e, t) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), a.push.apply(a, r);
      }

      return a;
    }

    function ve(e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ce(Object(a), !0).forEach(function (t) {
          i()(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ce(Object(a)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
      }

      return e;
    }

    var pe = {
      model: {
        visit: {
          visitId: "",
          applicationDetails: {
            applicationName: "HelixErrors",
            applicationType: "Web",
            appVersion: "1.0",
            venonaVersion: ue.dependencies["@charter/quantum"].replace("^", ""),
            environment: {
              environmentName: "prod"
            }
          },
          device: {
            uuid: ""
          },
          analytics: {
            libraryVersion: ue.version
          }
        },
        domain: "portals",
        customer: "Charter"
      },
      messageId: 0
    },
        de = function de() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = ee("initial-library-state") || e,
          a = t.domain,
          r = t.customer,
          i = t.appType,
          n = t.appName,
          o = t.appVersion,
          s = void 0 === o ? "1.0" : o,
          l = t.requirementsVersion,
          u = t.deviceFormFactor,
          c = t.deviceModel,
          v = t.deviceOperatingSystem,
          p = t.deviceType;
      return {
        model: {
          customer: r,
          domain: a,
          visit: {
            applicationDetails: {
              applicationName: n,
              applicationType: i,
              appVersion: s.toString()
            },
            analytics: {
              requirementsVersion: l,
              requirementsSource: "local"
            },
            device: {
              deviceFormFactor: u,
              deviceModel: c,
              deviceOperatingSystem: v,
              deviceType: p
            }
          }
        }
      };
    },
        ge = function ge() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = se("library-state") || de(e),
          a = W(pe, t),
          r = a.model,
          i = (r = void 0 === r ? {} : r).visit,
          n = (i = void 0 === i ? {} : i).analytics,
          o = i.visitId,
          s = i.applicationDetails,
          l = (s = void 0 === s ? {} : s).applicationName,
          u = s.applicationType,
          c = s.appVersion,
          v = void 0 === c ? "1.0" : c,
          p = s.venonaVersion,
          d = s.environment,
          g = (d = void 0 === d ? {} : d).environmentName,
          y = i.device,
          f = (y = void 0 === y ? {} : y).uuid,
          m = i.analytics,
          w = (m = void 0 === m ? {} : m).libraryVersion,
          h = r.domain,
          b = r.customer,
          P = a.messageId;
      return {
        visitId: o,
        analytics: n,
        sequenceNumber: P,
        appVenonaVersion: p,
        applicationName: l,
        applicationType: u,
        appVersion: v.toString(),
        domain: h,
        customer: b,
        environment: {
          environmentName: g
        },
        libraryVersion: w,
        deviceUUID: f
      };
    },
        ye = function () {
      function e() {
        o()(this, e);
      }

      return l()(e, null, [{
        key: "generateErrorString",
        value: function value(e) {
          var t = new Map();
          t.errorCategory = "analytics";
          var a = e.applicationName,
              r = e.applicationType,
              i = e.appVersion,
              n = e.appVenonaVersion,
              o = e.deviceFormFactor,
              s = e.deviceType,
              l = e.model,
              u = e.operatingSystem,
              c = e.deviceUUID,
              v = e.visitId,
              p = e.customer,
              d = e.domain,
              g = e.appErrorCode,
              y = e.appErrorMessage,
              f = e.appErrorType,
              m = e.appErrorExtras,
              w = void 0 === m ? t : m,
              h = e.category,
              b = e.eventCaseId,
              P = e.msgEventType,
              T = e.sequenceNumber,
              S = e.analytics;
          return JSON.stringify({
            domain: d,
            customer: p,
            visit: {
              analytics: S,
              visitId: v,
              applicationDetails: {
                venonaVersion: n,
                appVersion: i,
                applicationName: a,
                applicationType: r
              },
              device: {
                deviceFormFactor: o,
                deviceType: s,
                model: l,
                operatingSystem: u,
                uuid: c
              }
            },
            messages: [{
              application: {
                error: {
                  errorCode: g,
                  errorMessage: y,
                  errorType: f,
                  errorExtras: w && !G(w) && w instanceof Map ? w : t
                }
              },
              message: {
                category: h,
                eventCaseId: b,
                name: P,
                sequenceNumber: T,
                timestamp: Date.now()
              }
            }]
          });
        }
      }, {
        key: "postHelixError",
        value: function value(e) {
          return be(e);
        }
      }, {
        key: "generateAN1000",
        value: function value(t) {
          var a = t.appVersion,
              r = void 0 === a ? "" : a,
              i = t.appName,
              n = void 0 === i ? "" : i,
              o = t.appType,
              s = void 0 === o ? "" : o,
              l = t.appEnvName,
              u = void 0 === l ? "" : l,
              c = t.requirementsVersion,
              v = void 0 === c ? "" : c,
              p = ge(t),
              d = Object.assign({}, t, ve(ve({}, p), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1000",
            appErrorMessage: "Cannot get events from remote or local file:".concat(n, "@").concat(s, "/").concat(v, ".json ENV: ").concat(u, " appVersion: ").concat(r, ". Analytics have been disabled!"),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(d));
        }
      }, {
        key: "generateAN1002",
        value: function value(t, a) {
          var r = ge(),
              i = Object.assign({}, t, ve(ve({}, r), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1002",
            appErrorMessage: "".concat(a),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "generateAN1003",
        value: function value(t, a) {
          var r = ge(),
              i = Object.assign({}, t, ve(ve({}, r), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1003",
            appErrorMessage: "Error calling Quantum init in start session: ".concat(a),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "generateAN1100",
        value: function value(t, a) {
          var r = ge(),
              i = Object.assign({}, t, ve(ve({}, r), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1100",
            appErrorMessage: "Error parsing Helix Extension: ".concat(a),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "generateAN1005",
        value: function value(t) {
          var a = ge(),
              r = Object.assign({}, t, ve(ve({}, a), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1005",
            appErrorMessage: "Error parsing Local Storage, fetching config from S3",
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(r));
        }
      }, {
        key: "generateAN1105",
        value: function value(t) {
          var a = ge(),
              r = Object.assign({}, t, ve(ve({}, a), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1105",
            appErrorMessage: "Error evaluating a Rules",
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(r));
        }
      }, {
        key: "generateAN2000",
        value: function value(t, a) {
          var r = ge(),
              i = Object.assign({}, t, ve(ve({}, r), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-2000",
            appErrorMessage: "".concat(a),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "generateErrorByCode",
        value: function value(t) {
          var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "UNDEFINED",
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "UNDEFINED",
              i = ge(),
              n = Object.assign({}, t, ve(ve({}, i), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-".concat(a),
            appErrorMessage: "".concat(r),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(n));
        }
      }, {
        key: "generateAN1001",
        value: function value(t) {
          var a = ge(),
              r = new Map();
          r.eventCaseId = G(t) ? "Missing Event Case, called track with empty string" : t, r.errorCategory = "analytics";
          var i = Object.assign({}, t, ve(ve({}, a), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1001",
            appClientErrorCode: "AN-1001",
            appErrorMessage: "Invalid EID:".concat(t),
            appErrorType: "analytics",
            appErrorExtras: r
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "generateAN1106",
        value: function value(t, a) {
          var r = ge(),
              i = Object.assign({}, t, ve(ve({}, r), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1106",
            appErrorMessage: "Error overloading Tracker: ".concat(a),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "generateAN1206",
        value: function value(t, a) {
          var r = ge(),
              i = Object.assign({}, t, ve(ve({}, r), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1206",
            appErrorMessage: "ClickTale track error: ".concat(a),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "generateAN1207",
        value: function value(t, a) {
          var r = ge(),
              i = Object.assign({}, t, ve(ve({}, r), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1207",
            appErrorMessage: "ClickTale Init error: ".concat(a),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "generateAN1208",
        value: function value(t, a) {
          var r = ge(),
              i = Object.assign({}, t, ve(ve({}, r), {}, {
            msgEventType: "error",
            eventCaseId: "Analytics_Generic_Error",
            appErrorCode: "AN-1208",
            appErrorMessage: "ClickTale Inject iframe error: ".concat(a),
            appErrorType: "analytics"
          }));
          e.postHelixError(e.generateErrorString(i));
        }
      }, {
        key: "ERROR_CODES",
        get: function get() {
          return Object.freeze({
            FETCH_FILE: 1101,
            PARSE_SPEC: 1102,
            PARSE_CONFIG: 1103,
            INVALID_SPEC_FILE: 1104
          });
        }
      }]), e;
    }(),
        fe = "GET",
        me = "POST",
        we = function we(e, t) {
      var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          r = arguments.length > 3 ? arguments[3] : void 0;
      return new Promise(function (i, n) {
        var o = new XMLHttpRequest();
        o.onreadystatechange = function () {
          4 === o.readyState && (o.status >= 400 && n(o), i(o));
        }, a.username && a.password ? o.open(e, t, !0, a.username, a.password) : o.open(e, t, !0), a.contentType && o.setRequestHeader("Content-Type", a.contentType), o.timeout = 3e3, o.send(r);
      });
    },
        he = function () {
      var e = b()(w.a.mark(function e(t) {
        var a,
            r,
            i,
            _n,
            o,
            s,
            l,
            u,
            c,
            v,
            p,
            d,
            g,
            y = arguments;

        return w.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                _n = function n() {
                  return (_n = b()(w.a.mark(function e(t, a) {
                    return w.a.wrap(function (e) {
                      for (;;) {
                        switch (e.prev = e.next) {
                          case 0:
                            return q.error("".concat(t, " - S3 download fail, going to retry"), a), e.abrupt("return", new Promise(function (e) {
                              return setTimeout(e, t * r);
                            }));

                          case 2:
                          case "end":
                            return e.stop();
                        }
                      }
                    }, e);
                  }))).apply(this, arguments);
                }, i = function i(e, t) {
                  return _n.apply(this, arguments);
                }, a = y.length > 1 && void 0 !== y[1] ? y[1] : 11, r = y.length > 2 && void 0 !== y[2] ? y[2] : 1e3, o = t.s3BaseUri, s = void 0 === o ? "https://cdn.pi.spectrum.net" : o, l = t.appType, u = t.appName, c = t.requirementsVersion, v = "".concat(s, "/").concat(u, "/").concat(l, "/").concat(c, ".json"), q.info("🔗 Fetching S3 from url: ".concat(v)), p = 0;

              case 8:
                if (!(p < a)) {
                  e.next = 33;
                  break;
                }

                return e.prev = 9, e.next = 12, we(fe, v, t);

              case 12:
                if (d = e.sent, !Y(d, v)) {
                  e.next = 17;
                  break;
                }

                return e.abrupt("return", d.response);

              case 17:
                throw "Failed - Invalid response";

              case 18:
                e.next = 30;
                break;

              case 20:
                if (e.prev = 20, e.t0 = e.catch(9), g = p + 1 === a) {
                  e.next = 26;
                  break;
                }

                return e.next = 26, i(p + 1, e.t0);

              case 26:
                if (!g) {
                  e.next = 30;
                  break;
                }

                throw ye.generateAN1000(t), q.error("Failed to fetch from S3: ".concat(v, " Error: ").concat(JSON.stringify(e.t0))), e.t0;

              case 30:
                p++, e.next = 8;
                break;

              case 33:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[9, 20]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
        be = function () {
      var e = b()(w.a.mark(function e(t) {
        var a, r, i, n, o;
        return w.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return a = ee("library-state") || {}, r = a.settings, i = (r = void 0 === r ? {} : r).endpoint, n = void 0 === i ? "https://collector-dev.pi-charter.net/api/collector" : i, e.prev = 3, e.next = 6, we(me, n, {
                  contentType: "application/json"
                }, t);

              case 6:
                return o = e.sent, e.abrupt("return", o.response);

              case 10:
                return e.prev = 10, e.t0 = e.catch(3), q.error("Failed to post to collector: ".concat(JSON.stringify(e.t0))), e.abrupt("return", null);

              case 14:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[3, 10]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
        Pe = function () {
      var e = b()(w.a.mark(function e(t) {
        var a;
        return w.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, e.next = 3, we(fe, t);

              case 3:
                return a = e.sent, e.abrupt("return", a.response);

              case 7:
                return e.prev = 7, e.t0 = e.catch(0), q.error("Failed to fetch from url: ".concat(t, " Error: ").concat(JSON.stringify(e.t0))), e.abrupt("return", null);

              case 11:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 7]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
        Te = "[31m",
        Se = "[32m",
        ke = "[33m",
        Re = "[34m",
        Ee = "[35m",
        qe = "[36m",
        Oe = "[37m",
        Ie = "[42m",
        xe = "[44m",
        Ae = "[45m",
        Ce = "enabled",
        De = "disabled",
        Ke = "started",
        Ne = "stopped",
        Ve = "notInConfig",
        Fe = "notLoaded",
        Me = function () {
      function e(t, a) {
        o()(this, e), this.log = t, this._loaded = !1, this._whitelist = "", this._enabled = !1, this._endpoint = a || "https://cdnssl.clicktale.net/www27/ptc/4392dbc3-09ae-4588-9a02-90f4e5a00444.js", this.status = Fe;
      }

      return l()(e, [{
        key: "init",
        value: function value(e) {
          try {
            e.ClickTaleOnReadyList = e.ClickTaleOnReadyList || [], this.loaded = !0, this.status = Ce;
            var t = "script",
                a = this.endpoint,
                r = e.document;
            e.clickTaleTagInjected || (e.clickTaleTagInjected = !0);

            var i = function i() {
              var e = r.createElementNS,
                  i = e ? e.call(r, "http://www.w3.org/1999/xhtml", t) : r.createElement(t),
                  n = r.getElementsByTagName(t)[0];
              i.async = !0, i.crossOrigin = "anonymous", i.type = "text/javascript", i.src = a, n.parentNode.insertBefore(i, n);
            };

            "loading" != r.readyState ? i() : r.addEventListener("DOMContentLoaded", function () {
              setTimeout(i, 0);
            });
          } catch (e) {
            q.error("ERR ClickTale Init:", e), ye.generateAN1207({}, e);
          }
        }
      }, {
        key: "startRecording",
        value: function value(e) {
          q.debug("🎥 ClickTale: ".concat(Se, "startRecording ").concat(Ie, " ").concat(e)), "function" == typeof window.clickTaleStartEventSignal && window.clickTaleStartEventSignal(e);
        }
      }, {
        key: "trackClickTaleEvent",
        value: function value(e) {
          return q.debug("🎥 ClickTale: ".concat(Se, "Event ").concat(Ae, " ").concat(e)), "function" == typeof window.ClickTaleEvent ? window.ClickTaleEvent(e) : null;
        }
      }, {
        key: "endRecording",
        value: function value(e) {
          q.debug("🎥 ClickTale: ".concat(Te, "endRecording ").concat(Ie, " ").concat(e)), "function" == typeof window.clickTaleEndEventSignal && window.clickTaleEndEventSignal(e);
        }
      }, {
        key: "isRecording",
        value: function value() {
          return "function" == typeof window.ClickTaleIsRecording ? (q.debug("🎥 ClickTale: ".concat(Se, "isRecording")), window.ClickTaleIsRecording()) : (q.debug("🎥 ClickTale: ".concat(Se, "is NOT Recording")), null);
        }
      }, {
        key: "track",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = e.enableClickTale,
              a = e.clickTaleWhitelist,
              r = e.clickTaleEndpoint,
              i = arguments.length > 1 ? arguments[1] : void 0,
              n = arguments.length > 2 ? arguments[2] : void 0;

          try {
            if (q.debug("🎥 ClickTale: ".concat(Se, "track ").concat(xe, " ").concat(i)), H(t) || !window) return void (this.status = Ve);
            window.QuantumVisitID = n, this.enabled = t, this.loaded || this.enabled ? !this.loaded && this.enabled ? (a && (this.whitelist = a), r && (this.endpoint = r), this.init(window), this.iframesInject()) : !this.isRecording() && this.enabled ? (this.status = Ke, this.startRecording(i)) : this.isRecording() && !this.enabled && (this.status = Ne, this.endRecording(i)) : this.status = De;
          } catch (e) {
            q.error("ERR ClickTale Track:", {
              eventId: i,
              err: e
            }), ye.generateAN1206({
              eventId: i
            }, e);
          }
        }
      }, {
        key: "trackViews",
        value: function value(e, t, a) {
          "pageViewInit" === e ? this.endRecording(a) : "pageViewCompleted" === e ? this.startRecording(a) : "selectAction" === e && this.trackClickTaleEvent(a);
        }
      }, {
        key: "iframesInject",
        value: function value() {
          var e = this;

          try {
            document.querySelectorAll("iframe").forEach(function (t) {
              !t || t.dataset && t.dataset.ctinjected || (e.init(t.contentWindow), t.dataset.ctinjected = !0);
            });
          } catch (e) {
            q.error("ERR ClickTale iframesInject:", e), ye.generateAN1208({}, e);
          }
        }
      }, {
        key: "whitelist",
        set: function set(e) {
          e && this.whitelist !== e && (this._whitelist = e, te(ne, e), window && (window.ClickTaleUnMaskPII = e, window.dispatchEvent(new Event("helix.clicktale.whitelist"))));
        },
        get: function get() {
          return this._whitelist;
        }
      }, {
        key: "enabled",
        set: function set(e) {
          H(e) || "boolean" != typeof e || (this._enabled = e);
        },
        get: function get() {
          return this._enabled;
        }
      }, {
        key: "endpoint",
        set: function set(e) {
          this._endpoint = e;
        },
        get: function get() {
          return this._endpoint;
        }
      }, {
        key: "loaded",
        set: function set(e) {
          this._loaded = e;
        },
        get: function get() {
          return this._loaded;
        }
      }]), e;
    }(),
        je = function () {
      var e = b()(w.a.mark(function e(t) {
        var a;
        return w.a.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.prev = 0, e.next = 3, he(t);

              case 3:
                return a = e.sent, e.abrupt("return", a);

              case 7:
                return e.prev = 7, e.t0 = e.catch(0), ye.generateErrorByCode(t, ye.ERROR_CODES.FETCH_FILE, e.t0), e.abrupt("return", null);

              case 11:
              case "end":
                return e.stop();
            }
          }
        }, e, null, [[0, 7]]);
      }));
      return function (t) {
        return e.apply(this, arguments);
      };
    }(),
        Be = function () {
      function e() {
        o()(this, e), this.log = q, this.enableAnalytics = !0, this.analyticsInitialized = !1, this.mappings = {}, this.events = {}, this.clickTale = new Me(q), this.extensions = {};
      }

      var t, a, r, i;
      return l()(e, [{
        key: "trackStartSession",
        value: function value() {
          this.analyticsInitialized = !0;
        }
      }, {
        key: "getEventCase",
        value: function value(e) {
          return L.getEventCase(e, this.tracker);
        }
      }, {
        key: "getMappedValues",
        value: function value(e, t, a) {
          var r = this;
          return H(this.mappings) || G(this.mappings) || H(this.mappings[a]) ? e : Object.keys(e).reduce(function (i, n) {
            var o = r.mappings[a][n];
            if (o) "object" === f()(o) ? i[o[t]] = e[n] : i[o] = e[n];else if (!r.config[n]) {
              var s = e.eventCaseId,
                  l = void 0 === s ? t : s;
              r.log.warn("⚠️ adHocData ".concat(ke, "discarded property | ").concat(Se, "property:").concat(Ee, " ").concat(n).concat(Se, " value:").concat(Oe, " ").concat(e[n], " ").concat(Se, " EID:").concat(qe, " ").concat(l, " "));
            }
            return i;
          }, {});
        }
      }, {
        key: "fetchEvents",
        value: (i = b()(w.a.mark(function e(t) {
          return w.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.eventsLoaded) {
                    e.next = 8;
                    break;
                  }

                  return this.reqFetchStart = Date.now(), e.next = 4, this.fetchConfigFromS3(t);

                case 4:
                  this.log.debug("fetched config, fetching from storage. eventsLoaded: ".concat(Oe).concat(this.eventsLoaded)), this.fetchFromStorage(t), this.log.debug("fetchFromStorage eventsLoaded: ".concat(Oe).concat(this.eventsLoaded)), this.reqFetchStop = Date.now();

                case 8:
                  this.eventsLoaded || (this.enableAnalytics = !1, this.log.error("Cannot get events from remote or local. Analytics have been disabled!")), this.fetchEventsComplete();

                case 10:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e) {
          return i.apply(this, arguments);
        })
      }, {
        key: "fetchEventsComplete",
        value: function value() {
          this.log.debug("this is an abstract method. Override it if needed");
        }
      }, {
        key: "fetchFromStorage",
        value: function value(e) {
          if (this.eventsLoaded) return !0;
          var t = ee(re);

          if (!H(t) && _(t) && t.requirementsVersion === e.requirementsVersion) {
            var a = t.data || {};
            return this.log.debug("RequirementsVersion fetch from storage: ".concat(qe, " SUCCESS")), this.setData(a, "local");
          }

          return !1;
        }
      }, {
        key: "setData",
        value: function value(e, t) {
          if (X(e)) {
            this.analyticsReqSource = t, this.mappings = e["tracker-mappings"], this.urlMappings = e["url-mappings"];
            var a = e.extensions;

            if (this.extensions = a, a && e.extensions.rules) {
              var r = a.rules,
                  i = void 0 === r ? [] : r,
                  n = i.length || 0;
              this.log.info("📖 Found ".concat(n, " extension rules "), i), this.expressions = e.extensions.rules;
            }

            return this.events = e, this.log.debug("Using events from ".concat(Oe).concat(t)), !0;
          }

          return !1;
        }
      }, {
        key: "fetchConfigFromS3",
        value: (r = b()(w.a.mark(function t(a) {
          var r,
              i,
              n,
              o = this;
          return w.a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return r = Object.assign({}, a, {
                    requirementsVersion: "cfg_".concat(a.requirementsVersion)
                  }), t.next = 3, he(r);

                case 3:
                  if (i = t.sent, t.prev = 4, n = JSON.parse(i), "Venona" === this.analyticsMode && this.resetConfiguration(n.config), r.specsHash = n.specsHash, Object.assign(r, n.config), delete r.requirementsVersion, this.config = Object.assign({}, a, r), !e.shouldFetchSpecs(this.config)) {
                    t.next = 16;
                    break;
                  }

                  return this.log.info("".concat(Se, "fetching from S3")), t.next = 15, this.fetchFromS3(this.config, !0);

                case 15:
                  this.log.info("fetchFromS3. eventsLoaded:".concat(Oe, " ").concat(this.eventsLoaded));

                case 16:
                  this.config && this.config.configCheckHeartbeatSeconds && setTimeout(function () {
                    return o.fetchConfigFromS3(a);
                  }, 1e3 * this.config.configCheckHeartbeatSeconds || 6e5), this.log.info("fetchConfigFromS3. eventsLoaded: ".concat(Oe).concat(this.eventsLoaded)), t.next = 23;
                  break;

                case 20:
                  t.prev = 20, t.t0 = t.catch(4), ye.generateErrorByCode(a, ye.ERROR_CODES.PARSE_CONFIG, t.t0);

                case 23:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[4, 20]]);
        })), function (e) {
          return r.apply(this, arguments);
        })
      }, {
        key: "fetchFromS3",
        value: (a = b()(w.a.mark(function e(t, a) {
          var r, i, n;
          return w.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.log.debug("Events fetchFromS3. eventsLoaded: ".concat(Oe).concat(this.eventsLoaded)), !this.eventsLoaded || a) {
                    e.next = 3;
                    break;
                  }

                  return e.abrupt("return");

                case 3:
                  return e.next = 5, je(t);

                case 5:
                  r = e.sent;

                  try {
                    i = JSON.parse(r), X(i) || ye.generateErrorByCode(t, ye.ERROR_CODES.INVALID_SPEC_FILE, "Failed to load data from S3: Invalid data."), this.analyticsReqSource = "remote", this.setData(i, "remote"), n = JSON.stringify({
                      requirementsVersion: t.requirementsVersion,
                      data: i,
                      specsHash: t.specsHash ? t.specsHash : 0
                    }), te(re, n), this.log.debug("Using events from S3. eventsLoaded: ".concat(Oe).concat(this.eventsLoaded));
                  } catch (e) {
                    this.log.info("fetchFromS3 ${COLOR.red}error ", e), ye.generateErrorByCode(t, ye.ERROR_CODES.PARSE_SPEC, e);
                  }

                case 7:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function (e, t) {
          return a.apply(this, arguments);
        })
      }, {
        key: "fetchFromLocal",
        value: (t = b()(w.a.mark(function e() {
          var t,
              a,
              r = arguments;
          return w.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (t = r.length > 0 && void 0 !== r[0] ? r[0] : this.config, !this.eventsLoaded) {
                    e.next = 3;
                    break;
                  }

                  return e.abrupt("return", !0);

                case 3:
                  return e.prev = 3, e.next = 6, Pe(t.defaultEvents);

                case 6:
                  return a = e.sent, X(a) || ye.generateErrorByCode(t, ye.ERROR_CODES.INVALID_SPEC_FILE, "Failed to load data from LocalStorage: Invalid data."), this.mappings = a["tracker-mappings"], this.events = a, this.log.debug("using events from local."), e.abrupt("return", !0);

                case 14:
                  return e.prev = 14, e.t0 = e.catch(3), this.log.error("Failed to load events from local: ".concat(e.t0)), e.abrupt("return", !1);

                case 18:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[3, 14]]);
        })), function () {
          return t.apply(this, arguments);
        })
      }, {
        key: "enableAnalytics",
        set: function set(e) {
          var t = !e && !1 !== e || e;
          this._enableAnalytics = t, !t && this.pendingEventsQueue.length && this.emptyQueue();
        },
        get: function get() {
          return this._enableAnalytics;
        }
      }, {
        key: "eventsLoaded",
        get: function get() {
          return L.getEventsLoaded();
        }
      }, {
        key: "events",
        set: function set(e) {
          if (!G(e)) {
            this.log.debug("calling tracker manager init"), L.init(e);
            var t = this.pendingStartSessionParams;
            this.reqFetchStop || (this.reqFetchStop = Date.now()), t && (this.log.info("Set events: Tracking start session."), this.trackStartSession.apply(this, [t.id].concat(T()(t.params))));
          }
        }
      }, {
        key: "expressions",
        set: function set(e) {
          var t = this;

          if (e) {
            this.log.debug("Found rules to parse");
            var a = [];
            e.map(function (e) {
              try {
                var r = new le.Expression();
                r.parse(e), r && a.push(r);
              } catch (a) {
                t.log.info("🛑 Invalid rule found", {
                  e: a,
                  rule: e
                }), ye.generateAN1100(t.config, a);
              }
            }), this._expressions = a, this.log.debug("Rules parsed into Expressions");
          }
        },
        get: function get() {
          return this._expressions;
        }
      }], [{
        key: "shouldFetchSpecs",
        value: function value(e) {
          var t = e.specsHash,
              a = e.requirementsVersion,
              r = ee(re);
          return !r || t !== r.specsHash || a !== r.requirementsVersion && (ye.generateAN1005(e, "requirementsVersion requested does not match local storage version"), !0);
        }
      }]), e;
    }();

    function Le(e, t) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), a.push.apply(a, r);
      }

      return a;
    }

    function Ue(e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Le(Object(a), !0).forEach(function (t) {
          i()(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Le(Object(a)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
      }

      return e;
    }

    var _e = {
      agentParser: new (a(20).UAParser)(),
      config: {
        breakpoint: [3840, 2560, 1920, 1600, 1440, 1280, 960, 728, 600, 320]
      }
    },
        Ge = function Ge() {
      return _e.agentParser;
    },
        He = function He() {
      return Ge().getResult();
    },
        ze = function ze() {
      return Ge().getDevice() || {};
    },
        Je = function Je() {
      var e;

      switch (null === (e = ze()) || void 0 === e ? void 0 : e.type) {
        case "mobile":
          return "phone";

        case "tablet":
          return "tablet";

        default:
          return "pc";
      }
    },
        We = function We() {
      var e, t, a, r;
      return "".concat(null === (e = He()) || void 0 === e || null === (t = e.browser) || void 0 === t ? void 0 : t.name, " ").concat(null === (a = He()) || void 0 === a || null === (r = a.browser) || void 0 === r ? void 0 : r.version);
    },
        Qe = function Qe() {
      var e, t, a, r;
      return "".concat(null === (e = He()) || void 0 === e || null === (t = e.os) || void 0 === t ? void 0 : t.name, " ").concat(null === (a = He()) || void 0 === a || null === (r = a.os) || void 0 === r ? void 0 : r.version);
    },
        Xe = function Xe() {
      var e,
          t,
          a,
          r = null === (e = ze()) || void 0 === e ? void 0 : e.type,
          i = null === (t = He()) || void 0 === t || null === (a = t.os) || void 0 === a ? void 0 : a.name;
      return "iOS" === i ? "mobile" === r ? "iPhone" : "tablet" === r ? "iPad" : "iPod touch" : "Android" === i ? "mobile" === r ? "androidPhone" : "tablet" === r ? "androidTablet" : "androidPhone" : "webBrowser";
    },
        Ye = function Ye(e) {
      return ee(e);
    },
        Ze = function Ze(e, t) {
      return te(e, t);
    },
        $e = function $e() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var t = 16 * Math.random() | 0;
        return ("x" === e ? t : 3 & t | 8).toString(16);
      });
    },
        et = function et() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "deviceUUID";
      if (Ye(e)) return Ye(e);
      var t = $e();
      return Ze(e, t), t;
    },
        tt = function tt() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "deviceUUID";
      return et(e);
    },
        at = function at() {
      var e, t, a, r, i, n;
      return r = "referrer", new URLSearchParams(null === (i = window) || void 0 === i || null === (n = i.location) || void 0 === n ? void 0 : n.search).get(r) || (null === (e = document) || void 0 === e ? void 0 : e.referrer) || (null === (t = window) || void 0 === t || null === (a = t.location) || void 0 === a ? void 0 : a.href) || "";
    },
        rt = function rt() {
      var e,
          t,
          a = (null === (e = window) || void 0 === e || null === (t = e.location) || void 0 === t ? void 0 : t.host) || "";
      if (a.includes("localhost")) return "local";
      return ["engnew", "engprod", "dev-", "dev2-", "mock-", "qa-", "stage-", "development.", "ci1-", "engr"].forEach(function (e) {
        if (a.includes(e)) return "staging";
      }), "prod";
    },
        it = function it() {
      var e, t;
      return (null === (e = screen) || void 0 === e ? void 0 : e.width) + "x" + (null === (t = screen) || void 0 === t ? void 0 : t.height);
    },
        nt = function nt() {
      var e,
          t,
          a = null === (t = window) || void 0 === t ? void 0 : t.innerWidth;
      return ((null == _e || null === (e = _e.config) || void 0 === e ? void 0 : e.breakpoint) || []).find(function (e) {
        return e < a;
      });
    },
        ot = function ot() {
      try {
        var e,
            t,
            a = new URLSearchParams(null === (e = window) || void 0 === e || null === (t = e.location) || void 0 === t ? void 0 : t.search);
        return a.get("cid") || a.get("cmp");
      } catch (e) {
        return "";
      }
    },
        st = function st() {
      try {
        var e,
            t,
            a = new URLSearchParams(null === (e = window) || void 0 === e || null === (t = e.location) || void 0 === t ? void 0 : t.search);
        if (a.get("visitId")) return a.get("visitId");
        if (a.get("exVisitID")) return a.get("exVisitID");
      } catch (e) {
        return "";
      }
    },
        lt = function lt() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

      try {
        if ("undefined" == typeof window) return Ue({
          customer: "Charter",
          appType: "Web",
          msgTriggeredBy: "user",
          settings: {
            logLevel: "error"
          }
        }, e);
        var t = Ue({
          customer: "Charter",
          appType: "Web",
          msgTriggeredBy: "user",
          settings: {
            logLevel: "error"
          },
          appRefLink: at(),
          appEnvName: rt(),
          deviceFormFactor: Je(),
          deviceModel: We(),
          deviceOperatingSystem: Qe(),
          deviceUuid: tt(),
          deviceType: Xe(),
          uiResponsiveBreakpoint: nt(),
          screenResolution: it(),
          campaignId: ot(),
          referrerAppVisitId: st()
        }, e),
            a = Object.keys(t).filter(function (e) {
          return null != t[e];
        }).reduce(function (e, a) {
          return Ue(Ue({}, e), {}, i()({}, a, t[a]));
        }, {});
        return a;
      } catch (t) {
        return Ue({
          customer: "Charter",
          appType: "Web",
          msgTriggeredBy: "user",
          settings: {
            logLevel: "error"
          }
        }, e);
      }
    };

    function ut(e, t) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), a.push.apply(a, r);
      }

      return a;
    }

    function ct(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var a,
            r = g()(e);

        if (t) {
          var i = g()(this).constructor;
          a = Reflect.construct(r, arguments, i);
        } else a = r.apply(this, arguments);

        return p()(this, a);
      };
    }

    var vt = function vt(e, t) {
      var a = Object.assign({}, e),
          r = !1;

      if (t) {
        var i = new le.Context();

        try {
          if (Object.keys(e).forEach(function (t) {
            i.setValue(new le.Operand(t, le.OperandType.Data), e[t]);
          }), (r = t.some(function (e) {
            return !e.eval(i);
          })) ? q.warn("🛑 - Ext Rules: ".concat(Te, "blockTrack:").concat(Se), r) : a = i.dataVar, JSON.stringify(e) !== JSON.stringify(i.dataVar)) try {
            Object.keys(i.dataVar).map(function (t) {
              var a = i.dataVar[t],
                  r = e[t] ? e[t] : "";
              a != r && q.warn("🎯 - Ext Rules: ".concat(ke, " update adHocData | ").concat(Se, "property: ").concat(Ee).concat(t, " ").concat(Se, "newValue: ").concat(qe).concat(a, " ").concat(Se, "oldValue: ").concat(qe).concat(r));
            });
          } catch (e) {
            q.error("🎯 - Ext Rules:  error", e);
          } else q.info("Ext Rules: NO changes to context obj:", {
            mappedValues: e
          });
        } catch (e) {
          q.error("🛑 - Ext Rules: There was an error evaluating Helix expressions: ".concat(e)), ye.generateAN1100(i.dataVar, e);
        }
      }

      return a.blockTrack = r, a;
    };

    function pt(e, t) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), a.push.apply(a, r);
      }

      return a;
    }

    function dt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = null != arguments[t] ? arguments[t] : {};
        t % 2 ? pt(Object(a), !0).forEach(function (t) {
          i()(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : pt(Object(a)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
      }

      return e;
    }

    var gt = function gt(e, t, a, r, i, n) {
      var o = e,
          s = dt({}, r),
          l = dt({}, i);

      if (s.fetchByUrl && n.info("urlMapping check Track eid: ".concat(Oe).concat(o), {
        eventsLoaded: t,
        opts: s,
        paramsIn: l,
        urlMappings: a
      }), t && s.fetchByUrl) {
        var u, c;
        if ("pageViewInit" === l.msgEventType) if (s.useCleanUrl) l.currPageUrl = s.useCleanUrl;else l.currPageUrl = (null === (u = window) || void 0 === u || null === (c = u.location) || void 0 === c ? void 0 : c.href) || "";

        var v = function (e, t, a, r) {
          var i = t || {},
              n = i.keyword,
              o = void 0 === n ? "" : n,
              s = null,
              l = Date.now();

          try {
            for (var u = 0, c = Object.keys(a); u < c.length; u++) {
              var v = c[u];

              if (new RegExp(v).test(e)) {
                if (r.info("fetchEidByUrl -- key: ".concat(Oe, " ").concat(v, ", ").concat(Se, " value: ").concat(qe, " ").concat(JSON.stringify(a[v])), {
                  result: s,
                  options: i
                }), (s = Object.assign({}, a[v])).keywords) {
                  var p = s.keywords.indexOf(o);
                  s.eid = s.eid[-1 === p ? 0 : p];
                }

                break;
              }
            }

            s || (r.error("urlMapping. No Event Case for URL"), ye.generateAN1001("urlMapping. No Event Case for URL: ".concat(e)));
          } catch (e) {
            r.error("trackByUrl warning: ".concat(e), e), r.error(e);
          }

          return r.debug("Time to process url regex tests: ".concat(Oe).concat(Date.now() - l, "ms")), s;
        }(o, s, a, n);

        if (!v) return {
          eid: null,
          opts: {},
          paramsIn: {}
        };
        o = v.eid, n.info("urlMapping - fetchByUrl:".concat(Oe, " ").concat(o)), "pageViewCompleted" === l.msgEventType && v.pcSupported && (l.msgEventType = "pageViewPartiallyRendered"), s.fetchByUrl = !1;
      }

      return {
        eid: o,
        opts: s,
        paramsIn: l
      };
    };

    function yt(e, t) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), a.push.apply(a, r);
      }

      return a;
    }

    function ft(e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = null != arguments[t] ? arguments[t] : {};
        t % 2 ? yt(Object(a), !0).forEach(function (t) {
          i()(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : yt(Object(a)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
      }

      return e;
    }

    function mt(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var a,
            r = g()(e);

        if (t) {
          var i = g()(this).constructor;
          a = Reflect.construct(r, arguments, i);
        } else a = r.apply(this, arguments);

        return p()(this, a);
      };
    }

    var wt = function wt(e) {
      return !H(e) && !H(e.properties) && !H(e.eventType) && e.eventType.name;
    },
        ht = function ht() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
          t = {
        appApiHost: "",
        appApiPath: "",
        appApiQueryParameters: ""
      };
      if (!e) return t;
      if (0 !== e.indexOf("http")) return t.appApiPath = e, t;
      var a = e.split("?");
      t.appApiQueryParameters = a[1] || "";
      var r = a[0].split("://"),
          i = r[1] || "";
      return t.appApiHost = i.substr(0, i.indexOf("/")), t.appApiPath = i.substr(i.indexOf("/")), t;
    },
        bt = {
      GET: {
        flushedEvents: "getFlushedEvents",
        visitId: "getVisitId",
        currentState: "getCurrentLibraryState",
        experimentConfigurations: "getExperimentConfigurations"
      },
      SET: {
        features: "setFeatures",
        ignoredEvents: "addIgnoredEvents",
        flushedEvents: "addFlushedEvents",
        endpoint: "endpoint"
      }
    },
        Pt = function (e) {
      c()(r, e);
      var t,
          a = mt(r);

      function r() {
        var e;
        return o()(this, r), (e = a.call(this)).tracker = "Venona", e.analyticsMode = "Venona", e.libInitStart = Date.now(), e;
      }

      return l()(r, [{
        key: "get",
        value: function value(e) {
          var t = bt.GET[e];
          return "function" == typeof this.analytics[t] ? this.analytics[t]() : (this.log.warn("".concat(ke, "GET: ").concat(qe, " ").concat(e)), this.analytics.get(e));
        }
      }, {
        key: "getSetter",
        value: function value() {
          var e = bt.SET || {};
          return (this.analytics.getSetterNames() || []).map(function (t) {
            var a = t.startsWith("set") ? "".concat(t.charAt(3).toLowerCase()).concat(t.substring(4)) : t;
            e[a] = t;
          }), e;
        }
      }, {
        key: "set",
        value: function value(e, t) {
          if (e && !H(t)) {
            "enabled" !== e || "boolean" != typeof t || t || (this.enableAnalytics = !1), "endpoint" === e && (this.endpoint = t);
            var a = this.getSetter(),
                r = a[e];
            if (this.log.warn("".concat(ke, "SET: ").concat(qe, " ").concat(e, " ").concat(Se, " value: ").concat(ke).concat(JSON.stringify(t)), {
              value: t,
              settersList: a
            }), "function" == typeof this.analytics[r]) return this.analytics[r](t);
            r || this.log.warn("".concat(e, " is not it the setter list"), a), this.analytics.set(e, t);
          }
        }
      }, {
        key: "useDefaultStorage",
        value: function value() {
          this.enablePersistence();
        }
      }, {
        key: "setStorage",
        value: function value(e) {
          this.setCustomStorage(e);
        }
      }, {
        key: "removeStorage",
        value: function value(e) {
          this.removeCustomStorage(e);
        }
      }, {
        key: "enablePersistence",
        value: function value() {
          try {
            "undefined" != typeof window && window.localStorage && null === this.persistence && (this.persistence = "local", this.log.debug("Persistence:".concat(Oe, " Local"))), this.analytics.enablePersistence();
          } catch (e) {
            this.log.error("enable Local Persistence:".concat(Te, " fail"), e), this.persistence = null;
          }
        }
      }, {
        key: "setCustomStorage",
        value: function value(e) {
          this.persistence = "custom", this.log.info("enablePersistence:".concat(Oe, " custom")), $.setCustomStorage(e), "function" == typeof this.analytics.setCustomStorage && this.analytics.setCustomStorage(e);
        }
      }, {
        key: "removeCustomStorage",
        value: function value() {
          $.removeCustomStorage(), "function" == typeof this.analytics.removeCustomStorage && this.analytics.removeCustomStorage(), this.persistence = null;
        }
      }, {
        key: "resetStorage",
        value: function value() {
          $.resetStorage(), "function" == typeof this.analytics.resetStorage && this.analytics.resetStorage();
        }
      }, {
        key: "clearStorage",
        value: function value() {
          this.log.info("clearStorage ");

          try {
            this.analytics.core.removeStoredState(), ae("requirements"), ae("deviceUUID"), ae("initial-library-state"), ae("library-first-launch");
          } catch (e) {
            this.log.error("Error while clearStorage ", JSON.stringify(e));
          }
        }
      }, {
        key: "flush",
        value: (t = b()(w.a.mark(function e() {
          return w.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (this.log.warn("".concat(ke, "flush: ").concat(qe, " called")), "function" != typeof this.analytics.flush) {
                    e.next = 5;
                    break;
                  }

                  return e.next = 4, this.analytics.flush();

                case 4:
                  return e.abrupt("return", e.sent);

                case 5:
                  throw new Error("Flush function is not defined in Quantum library");

                case 6:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }, {
        key: "stop",
        value: function value() {
          this.enableAnalytics = !1, this.log.warn("🛑  ".concat(Te, "stop: ").concat(qe, " called, Analytics are now disable")), "function" == typeof this.analytics.stop && this.analytics.stop();
        }
      }, {
        key: "track",
        value: function value() {
          var e,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              i = this.config.enableClickTale;

          try {
            if (i) {
              var n = this.get("visitId");
              this.clickTale.track(this.config, t, n);
            }

            if (this.config && !H(this.config.enableAnalytics) && !this.config.enableAnalytics) return void this.log.info("track -- Analytics have been disabled by config. Config: ".concat(JSON.stringify(this.config)));
            var o = gt(t, this.eventsLoaded, this.urlMappings, this.checkValidOpts(r), a, this.log),
                s = o.eid,
                l = o.opts,
                u = o.paramsIn;

            if (this.trackCalled = !0, this.allSetToTrack(s)) {
              var c = this.getEventCase(s);
              if (this.log.debug("getEventCase: ", c), !wt(c)) return void this.log.error("Invalid event case. ".concat(s, " is not tracked. eventCase: ").concat(JSON.stringify(c)));
              var v = c.properties;
              if (this.disabledEvents.indexOf(c.eventType.name) > -1) return;
              var p = c.eventType.name;

              if ("string" == typeof u.url && u.url.trim().length > 0) {
                var d = ht(u.url);
                Object.assign(u, d);
              }

              (e = this.getMappedValues(W(this.config, u, J(v)), p, "venona")).eventCaseId = s;
              var g = u.msgEventType || p;

              if ("function" == typeof this.analytics[g]) {
                "loginStop" !== g && "inVisitOauthRefresh" !== g || (e.oAuthToken = u.accountOauthToken);

                try {
                  if (!(e = vt(e, this.expressions)).blockTrack) {
                    if (this.clickTale.trackViews(e.msgEventType || g, e.opType, t), "startSession" === g && "blank" !== this.get("currentState")) throw new Error("Unexpected event startSession received in state ".concat(this.get("currentState")));
                    this.validateEID({
                      decodedEID: c,
                      adHocDataIn: a,
                      adHocDataOut: e,
                      optionsOut: l,
                      optionsIn: r,
                      eid: s,
                      sdkMethod: g,
                      mappingKey: "venona"
                    }), this.analytics[g](e, l);
                  }
                } catch (t) {
                  this.log.error("🛑 track: Error from analytics library: ".concat(t));
                  var y = new Map();
                  y.eventCaseId = s, y.errorCategory = "analytics", y.errorData = JSON.stringify({
                    eid: s,
                    opts: l,
                    paramsIn: u,
                    mappedValues: e
                  }), ye.generateAN2000({
                    appErrorExtras: y
                  }, t);
                }
              }
            } else if (this.enableAnalytics) if (this.eventsLoaded) {
              var f = this.getEventCase(s);

              if (!wt(f)) {
                if (this.log.warn("🛑 track: ".concat(Oe, "couldn't find ").concat(qe).concat(s, " ").concat(Oe, "in events, ").concat(Te, "make sure requirement ").concat(qe).concat(this.config.requirementsVersion).concat(Te, " is the correct version.")), this.getEventCase("error")) {
                  var m = new Map();
                  m.eventCaseId = G(s) ? "Missing Event Case, called track with empty string" : s, m.errorCategory = "analytics", this.track("error", {
                    eventCaseId: "Analytics_Generic_Error",
                    appErrorType: "analytics",
                    appClientErrorCode: "AN-1001",
                    appErrorCode: "AN-1001",
                    appErrorMessage: "Invalid EID:".concat(s),
                    appErrorExtras: m
                  });
                } else this.log.error("Fail to send tack error: "), ye.generateAN1001(s);

                return;
              }

              var w = f.properties;
              this.log.info("track: ".concat(Oe, "retrieved properties:"), w), this.log.info("track: check if current event is startSession"), "startSession" === f.eventType.name ? this.trackStartSession(s, u, l) : (this.log.info("track: ".concat(Oe, "Events loaded, waiting for startSession. Added ").concat(s, " to queue.")), this.updateQueue(s, u, l));
            } else this.log.debug("track: ".concat(Oe, "events not loaded. Added ").concat(s, " to queue.")), this.updateQueue(s, u, l);

            try {
              this.backwardCompatible();
            } catch (e) {
              this.log.error("There was an error making the backwardCompatible call: ".concat(JSON.stringify(e), " "), e);
            }
          } catch (t) {
            t.eventCaseId ? (this.log.error("There was an error making the track call: ".concat(t.eventCaseId), t), this.track(t.eventCaseId, t)) : (this.log.error("There was an error making the track call:", {
              mappedValues: e,
              error: t
            }), ye.generateAN1002(e, t));
          }
        }
      }, {
        key: "trackStartSession",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

          if (!this.config || H(this.config.enableAnalytics) || this.config.enableAnalytics) {
            var i = this.getEventCase(t);
            if (!wt(i)) return ye.generateAN1003(t, "Event case is not valid"), void this.log.error("startSession not triggered. Event case is not valid EID:".concat(t), {
              eventCase: i,
              params: a,
              options: r,
              eventId: t
            });
            var n = i.properties,
                o = W(this.config, a, J(n), {
              analyticsInitTimeMs: this.libInitStop - this.libInitStart || 0,
              analyticsReqResponseTimeMs: this.reqFetchStop - this.reqFetchStart || 0,
              analyticsReqSource: this.analyticsReqSource,
              analyticsReqVersion: this.config.requirementsVersion,
              analyticsLibVersion: Q()
            }),
                s = o.settings,
                l = void 0 === s ? {} : s,
                u = l.setters,
                c = void 0 === u ? {} : u,
                v = ft(ft(ft({}, l), Object.keys(c).reduce(function (e, t) {
              return e[t] = "string" == typeof c[t] ? c[t] : JSON.stringify(c[t]), e;
            }, {})), {}, {
              setters: void 0
            });
            H(c) || !_(c) || G(c) || (this.disabledEvents = c.disabledEvents || [], Object.keys(c).forEach(function (t) {
              return e.set(t, c[t]);
            })), o.settings = v;
            var p = this.getMappedValues(o, i.eventType.name, "venona");
            (p = vt(p, this.expressions)).eventCaseId = t;

            try {
              this.validateEID({
                decodedEID: i,
                adHocDataIn: W(this.config, a),
                adHocDataOut: p,
                optionsOut: r,
                optionsIn: r,
                eid: t,
                sdkMethod: "startSession",
                mappingKey: "venona"
              }), this.analytics.init(p, r);
            } catch (e) {
              this.log.error("Error initializing analytics library: ".concat(e)), ye.generateAN1003(p, e);
            }

            this.analyticsInitialized = !0, this.libInitStop = Date.now(), this.releaseQueue();
          } else this.log.info("track -- ".concat(Te, "Analytics have been disabled by config. Config:"), this.config);
        }
      }, {
        key: "allSetToTrack",
        value: function value(e) {
          return e ? this.enableAnalytics ? this.analyticsInitialized && this.eventsLoaded && this.getEventCase(e) ? (this.log.debug("allSetToTrack: ".concat(Oe, "Analytics tracked.")), !0) : this.analyticsInitialized && this.eventsLoaded && !this.getEventCase(e) ? (this.log.warn("allSetToTrack: ".concat(Te, "can't find EventCase: ").concat(qe).concat(e)), !1) : (this.log.debug("allSetToTrack: ".concat(Te, "Not ready to track.")), !1) : (this.log.error("allSetToTrack: ".concat(Te, "Analytics is disabled.")), !1) : (this.log.info("allSetToTrack: ".concat(Te, "Invalid event id.")), !1);
        }
      }, {
        key: "generateOverloadMethods",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          return t.reduce(function (t, a) {
            return ft(ft({}, t), {}, i()({}, a, function (t, r) {
              return e.trackOverload(a, t, r);
            }));
          }, {});
        }
      }, {
        key: "trackOverload",
        value: function value(e, t, a) {
          try {
            var r = vt(ft(ft({}, t), {}, {
              sdkMethod: e
            }), this.expressions);
            return r.blockTrack ? void this.log.warn("trackOverload blocked: ".concat(e)) : this.analytics[e](r, a);
          } catch (t) {
            this.log.error("Error overloading Tracker: ".concat(t)), ye.generateAN1106(e, t);
          }

          return this.analytics[e](t, a);
        }
      }, {
        key: "getQubeHeaders",
        value: function value(e) {
          var t = this.get("visitId"),
              a = $e(),
              r = this.config,
              i = r.appName,
              n = r.appType,
              o = this.analytics.core.getStoredState({
            applicationName: i,
            applicationType: n
          }).state,
              s = void 0 === o ? "{}" : o,
              l = JSON.parse(s).model,
              u = (l = void 0 === l ? {} : l).visit;
          return {
            "x-visit-id": t,
            "x-user-id": e,
            "x-app-session-id": (u = void 0 === u ? {} : u).appSessionId,
            "x-trace-id": a,
            "x-app-id": "".concat(i, "@").concat(n)
          };
        }
      }, {
        key: "backwardCompatible",
        value: function value() {
          var e,
              t = this.persistence;

          if (!("undefined" == typeof window || "local" !== t && window)) {
            var a = (null === (e = window) || void 0 === e ? void 0 : e.localStorage) || {
              setItem: function setItem() {},
              getItem: function getItem() {}
            },
                r = this.get("visitId");
            !window || window.QuantumVisitID && window.QuantumVisitID === r || (window.QuantumVisitID = r);
            var i = a.getItem(ie);
            if (!i && r) a.setItem(ie, JSON.stringify({
              model: {
                visit: {
                  visitId: r
                }
              }
            }));else if (r) {
              var n = (JSON.parse(i) || {}).model,
                  o = (n = void 0 === n ? {} : n).visit;
              (o = void 0 === o ? {} : o).visitId !== r && a.setItem(ie, JSON.stringify({
                model: {
                  visit: {
                    visitId: r
                  }
                }
              }));
            }
          }
        }
      }, {
        key: "checkValidOpts",
        value: function value(e) {
          var t = e.timestamp;

          if (t) {
            var a = new Date("2021-04-26T00:00:00Z").getTime(),
                r = new Date();

            if ("number" != typeof t || t < a) {
              var i = new Map();
              i.errorCategory = "analytics", i.timestamp = t, i.systemTime = r.getTime(), "number" != typeof t ? (i.errorType = "Time stamp is the wrong type (".concat(f()(t), ")"), this.track("error", {
                eventCaseId: "Analytics_Generic_Error",
                appErrorType: "analytics",
                appClientErrorCode: "AN-1050",
                appErrorCode: "AN-1050",
                appErrorMessage: "Invalid timestamp: ".concat(t),
                appErrorExtras: i
              })) : t < a && (i.errorType = "Time stamp is too far in the past", this.track("error", {
                eventCaseId: "Analytics_Generic_Error",
                appErrorType: "analytics",
                appClientErrorCode: "AN-1050",
                appErrorCode: "AN-1050",
                appErrorMessage: "Invalid timestamp: ".concat(t),
                appErrorExtras: i
              })), this.log.error("".concat(Te, "AN-1050 ").concat(ke, "| ").concat(i.errorType, ": ").concat(t)), delete e.timestamp;
            }
          }

          return e;
        }
      }, {
        key: "disabledEvents",
        set: function set(e) {
          this._disabledEvents = e && Array.isArray(e) ? e : [];
        },
        get: function get() {
          return this._disabledEvents || [];
        }
      }]), r;
    }(function (e) {
      c()(s, e);
      var t,
          a,
          r,
          n = ct(s);

      function s() {
        var e;
        return o()(this, s), (e = n.call(this)).persistence = null, e.endpoint = null, e.config = {}, e.customConfig = {}, e.pendingEventsQueue = [], e.pendingStartSessionParams = null, e.isReleasingQueue = !1, e.initialMaxEventsPerSecond = 20, e;
      }

      return l()(s, [{
        key: "track",
        value: function value() {
          this.log.debug("this is an abstract method. Override it in child");
        }
      }, {
        key: "trackAndFlush",
        value: (r = b()(w.a.mark(function e() {
          var t,
              a,
              r,
              i = arguments;
          return w.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (t = i.length > 0 && void 0 !== i[0] ? i[0] : "", a = i.length > 1 && void 0 !== i[1] ? i[1] : {}, r = i.length > 2 && void 0 !== i[2] ? i[2] : {}, this.analyticsInitialized) {
                    e.next = 5;
                    break;
                  }

                  return e.abrupt("return", Promise.reject("Analytics not initialized: Cannot flush without analytics."));

                case 5:
                  return this.releaseQueue(), e.next = 8, this.flush();

                case 8:
                  return e.next = 10, this.track(t, a, r);

                case 10:
                  return e.abrupt("return", this.flush());

                case 11:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return r.apply(this, arguments);
        })
      }, {
        key: "init",
        value: (a = b()(w.a.mark(function e() {
          var t,
              a = arguments;
          return w.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return t = a.length > 0 && void 0 !== a[0] ? a[0] : {}, e.prev = 1, te("initial-library-state", t), this.config = this.getDefaultConfig(t), this.log.info("💈 Initializing....", {
                    config: t,
                    enrichedConfig: this.config
                  }), e.next = 7, this.fetchEvents(this.config);

                case 7:
                  e.next = 12;
                  break;

                case 9:
                  e.prev = 9, e.t0 = e.catch(1), this.log.error("There was an error initializing Helix: ".concat(e.t0), e.t0);

                case 12:
                case "end":
                  return e.stop();
              }
            }
          }, e, this, [[1, 9]]);
        })), function () {
          return a.apply(this, arguments);
        })
      }, {
        key: "updateQueue",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";

          if (this.enableAnalytics) {
            for (var t = arguments.length, a = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
              a[r - 1] = arguments[r];
            }

            e.indexOf("startSession") > -1 ? this.pendingStartSessionParams = {
              id: e,
              params: a
            } : (this.pendingEventsQueue.push({
              id: e,
              params: a
            }), this.log.info("Adding to ".concat(ke, "queue").concat(Se, "..."), {
              pendingEventsQueue: this.pendingEventsQueue
            }));
          }
        }
      }, {
        key: "releaseQueue",
        value: (t = b()(w.a.mark(function e() {
          var t,
              a,
              r,
              i = this;
          return w.a.wrap(function (e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (0 !== (t = this.pendingEventsQueue.length || 0)) {
                    e.next = 3;
                    break;
                  }

                  return e.abrupt("return");

                case 3:
                  if (a = this.analytics ? this.analytics.get("maxEventsPerSecond") : 20, this.log.info("Releasing ".concat(ke).concat(t).concat(Se, " queue events..."), this.pendingEventsQueue), this.analytics && a < t && (this.initialMaxEventsPerSecond = a, r = t < 100 ? t + 5 : 100, this.log.info("".concat(Te, "⚠️ Increasing ").concat(Se, "maxEventsPerSecond during release Queue from ").concat(a, " to ").concat(r)), this.analytics.set("maxEventsPerSecond", r)), !this.isReleasingQueue) {
                    e.next = 8;
                    break;
                  }

                  return e.abrupt("return");

                case 8:
                  if (this.isReleasingQueue = !0, this.pendingEventsQueue.forEach(function (e) {
                    return i.track.apply(i, [e.id].concat(T()(e.params)));
                  }), this.emptyQueue(), this.isReleasingQueue = !1, !this.analytics || this.initialMaxEventsPerSecond === this.analytics.get("maxEventsPerSecond")) {
                    e.next = 17;
                    break;
                  }

                  return e.next = 15, this.analytics.flush();

                case 15:
                  this.log.info("Resetting maxEventsPerSecond post releaseQueue to ".concat(this.initialMaxEventsPerSecond)), this.analytics.set("maxEventsPerSecond", this.initialMaxEventsPerSecond);

                case 17:
                case "end":
                  return e.stop();
              }
            }
          }, e, this);
        })), function () {
          return t.apply(this, arguments);
        })
      }, {
        key: "emptyQueue",
        value: function value() {
          this.pendingEventsQueue.length = 0;
        }
      }, {
        key: "getDefaultConfig",
        value: function value(e) {
          try {
            var t = e.noFetchDefaultData,
                a = t ? e : lt(e),
                r = a.domain,
                n = a.appEnvName,
                o = a.settings,
                s = (o = void 0 === o ? {} : o).logLevel,
                l = void 0 === s ? "error" : s;

            if (l) {
              var u = "prod" === n ? "error" : l;
              a.settings.logLevel = u, this.log && this.log.setLevel(u), this.analytics && this.analytics.log && this.analytics.log.setLevel(u);
            }

            return "undefined" == typeof window || null !== this.persistence || t || (this.log.debug("Auto set Persistence"), this.enablePersistence()), !this.endpoint && r && n && ("internal_apps" === r && "prod" === n ? (this.log.debug("Setting collector endpoint: ".concat(Oe, "Internal app ").concat(Ie, "PRODUCTION"), {
              domain: r,
              appEnvName: n
            }), this.set("endpoint", "https://collector.pi.spectrum.net/topics/internal_quantum?bulk=true")) : "internal_apps" === r ? (this.log.debug("Setting collector endpoint: ".concat(Oe, "Internal app ").concat(xe, "STAGING"), {
              domain: r,
              appEnvName: n
            }), this.set("endpoint", "https://collector.pi-charter.net/topics/internal_quantum?bulk=true")) : "prod" === n ? (this.log.debug("Setting collector endpoint: ".concat(Oe, "Client facing app ").concat(Ie, "PRODUCTION"), {
              domain: r,
              appEnvName: n
            }), this.set("endpoint", "https://collector.pi.spectrum.net/api/collector?bulk=true")) : (this.log.debug("Setting collector endpoint: ".concat(Oe, "Client facing app ").concat(xe, "STAGING"), {
              domain: r,
              appEnvName: n
            }), this.set("endpoint", "https://collector.pi-charter.net/api/collector?bulk=true"))), a;
          } catch (t) {
            return function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var a = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ut(Object(a), !0).forEach(function (t) {
                  i()(e, t, a[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : ut(Object(a)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
                });
              }

              return e;
            }({
              customer: "Charter",
              appType: "Web",
              msgTriggeredBy: "user",
              settings: {
                logLevel: "error"
              }
            }, e);
          }
        }
      }, {
        key: "validateEID",
        value: function value(e) {
          var t = this,
              a = e.decodedEID,
              r = void 0 === a ? {} : a,
              i = e.adHocDataIn,
              n = e.adHocDataOut,
              o = e.optionsOut,
              s = void 0 === o ? [] : o,
              l = e.optionsIn,
              u = e.eid,
              c = e.sdkMethod,
              v = e.mappingKey,
              p = r.properties,
              d = self ? self.localStorage : null,
              g = JSON.parse(d ? d.getItem(oe) : {}) || {};
          this.resetConfiguration(g);
          var y = this.config.settings,
              f = (y = void 0 === y ? {} : y).logLevel,
              m = void 0 === f ? "error" : f;

          if ("info" === m || "debug" === m || "warn" === m) {
            var w = J(p),
                h = v.charAt(0).toUpperCase() + v.slice(1);

            try {
              for (var b = Object.keys(p).map(function (e) {
                var a = p[e],
                    r = a.valid,
                    i = a.requiredTrackers,
                    n = a.type;
                return {
                  key: e,
                  required: i[h],
                  name: t.mappings[v][e],
                  valid: r,
                  type: n
                };
              }).filter(function (e) {
                return e.required;
              }) || [], P = 0, T = Object.entries(i); P < T.length; P++) {
                var S = k()(T[P], 2),
                    R = S[0],
                    E = S[1],
                    q = this.mappings[v][R];

                if (q) {
                  var O = "string" == typeof q ? q : q[Object.keys(q)[0]],
                      I = n[O],
                      x = (p[R] || {}).valid;
                  I != E ? this.log.warn("⚠️ adHocData ".concat(ke, " pre-filled value change | ").concat(Se, "property: ").concat(Ee).concat(R, " ").concat(Se, " value: ").concat(Te).concat(E, " ").concat(Se, "newValue: ").concat(qe).concat(I).concat(Se, " EID:").concat(qe, " ").concat(u)) : x && x.length > 0 && !x.includes(E.toString()) && this.log.warn("⚠️ adHocData ".concat(ke, "invalid property | ").concat(Se, " value: ").concat(Te).concat(E, " ").concat(Se, " valid: ").concat(qe).concat(JSON.stringify(x), " ").concat(Se, "EID:").concat(qe, " ").concat(u, " ").concat(Se, "property: ").concat(Re).concat(R, " "), {
                    valid: x
                  });
                }
              }

              b.map(function (e) {
                var a = e.key,
                    r = t.mappings[v][a];

                if (r) {
                  var i = "string" == typeof r ? r : r[Object.keys(r)[0]];
                  n[i] || t.log.warn("⚠️ adHocData ".concat(ke, "missing required property | ").concat(Se, "property: ").concat(Te).concat(a, " ").concat(Se, "EID:").concat(qe, " ").concat(u));
                }
              });
            } catch (e) {
              this.log.error("error", e);
            }

            this.log.warn("🌐 Tracked:".concat(Se, " ").concat(u, " | ").concat(qe, " ").concat(c), {
              decoded_EID: p,
              preFilled: w,
              adHocDataIn: i,
              adHocDataOut: n,
              optionsOut: s,
              optionsIn: l
            });
          }
        }
      }, {
        key: "resetConfiguration",
        value: function value(e) {
          var t = this;
          G(e) || this.log.debug("⚙️ resetConfiguration ", e);

          try {
            Object.keys(e).map(function (a) {
              if ("enableAnalytics" !== a && "configCheckHeartbeatSeconds" !== a || e[a] === t.customConfig[a]) {
                if ("forceLogInfo" === a && e.forceLogInfo !== t.customConfig[a]) {
                  t.log.info("🛎️  Resetting configuration ".concat(Se).concat(a, ": ").concat(qe).concat(e[a]));
                  var r = e.forceLogInfo,
                      i = E[r] ? r : "info";
                  i !== t.config.settings.logLevel && (t.config.settings.logLevel = i), t.log && t.log.setLevel(i), t.analytics && t.analytics.log && t.analytics.log.setLevel(i);
                } else e[a] !== t.customConfig[a] && (t.log.info("🛎️  Resetting configuration ".concat(Se).concat(a, ": ").concat(qe).concat(e[a])), t.set(a, e[a]));
              } else t.customConfig[a] = e[a];
              t.customConfig[a] = e[a];
            });
          } catch (e) {
            this.log.critical("Error", e);
          }
        }
      }]), s;
    }(Be));

    function Tt(e, t) {
      var a = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), a.push.apply(a, r);
      }

      return a;
    }

    function St(e) {
      for (var t = 1; t < arguments.length; t++) {
        var a = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Tt(Object(a), !0).forEach(function (t) {
          i()(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Tt(Object(a)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
      }

      return e;
    }

    function kt(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var a,
            r = g()(e);

        if (t) {
          var i = g()(this).constructor;
          a = Reflect.construct(r, arguments, i);
        } else a = r.apply(this, arguments);

        return p()(this, a);
      };
    }

    var Rt = a(37),
        Et = function (e) {
      c()(a, e);
      var t = kt(a);

      function a() {
        var e;
        return o()(this, a), (e = t.call(this)).domain = "portals", e.analytics = Rt, e;
      }

      return l()(a, [{
        key: "quantum",
        get: function get() {
          var e = Object.keys(Rt.core.eventChecks) || [];
          return St(St({}, this.analytics), this.generateOverloadMethods(e));
        }
      }]), a;
    }(Pt);

    t.default = new Et();
  }]);
});